export default {
	"access.organization.name": "Access to organization card",
	"access.user.card": "Access to user card",
	"action.customize.view": "Personalizar vista",
	"action.default.view": "Vista por defecto",
	"action.viewcart": "Ver el carrito",
	"active": "Active",
	"add-suborg.add-suborg": "Añadir suborganización",
	"add-suborg.admin-info": "Información del administrador",
	"add-suborg.administrator": "Administrador",
	"add-suborg.confirmation": "Confirmación",
	"add-suborg.email": "Correo electrónico del administrador",
	"add-suborg.firstname": "Nombre del administrador",
	"add-suborg.id": "Id. de la organización",
	"add-suborg.intro": "Para la organización Arcelormittal Europe, selecciona una organización existente o crea una nueva:",
	"add-suborg.lastname": "Apellido del administrador",
	"add-suborg.matchin-org-intro": "Utilizar datos de la organización coincidente:",
	"add-suborg.matching-organizations": "Organizaciones correspondientes",
	"add-suborg.new-org-intro": "Crea una nueva suborganización desde cero:",
	"add-suborg.org-info": "Información sobre la organización",
	"add-suborg.org-name": "Nombre de la organización",
	"add-suborg.organization-details": "Detalles de la organización",
	"add-suborg.please-select": "Por favor, selecciona una opción",
	"add-suborg.quick-search": "Buscar un usuario",
	"add-suborg.vat-num-already-exists": "El número de IVA ya existe. Por favor, indica un nuevo número de IVA",
	"add-suborg.vat-number": "Número de IVA",
	"add-user.add-user": "Añadir usuario",
	"add-user.admin-user": "Ascender como administrador de esta organización",
	"add-user.confirmation": "Confirmación",
	"add-user.email": "Correo electrónico",
	"add-user.email-exist": "La dirección de correo electrónico ya existe",
	"add-user.intro": "Para la organización Arcelormittal Europe, selecciona un usuario existente o crea uno nuevo:",
	"add-user.matchin-users-intro": "Utilizar datos de usuarios coincidentes:",
	"add-user.matching-users": "Usuarios coincidentes",
	"add-user.name": "Nombre",
	"add-user.new-user-intro": "  Crear un nuevo usuario desde cero:",
	"add-user.please-select": "Por favor, selecciona una opción",
	"add-user.proceed-to-creation": "Proceder a crearlo",
	"add-user.referal-organization": "Organización de referencia",
	"add-user.required": "Obligatorio",
	"add-user.services": "Servicios",
	"add-user.services-management": "Gestión de servicios",
	"add-user.user-creation": "Creación de usuario",
	"add-user.user-email": "Correo electrónico",
	"add-user.user-exists": "El usuario seleccionado ya existe para la organización",
	"add-user.user-firstname": "Nombre",
	"add-user.user-informations": "Información del usuario",
	"add-user.user-lastname": "Apellido(s)",
	"add-user.user-not-active": "Usuario seleccionado no activo",
	"add-user.user-type": "Type of user",
	"add.item.to.cart.error.msg": "Algo ha ido mal al añadir artículos al carrito, por favor inténtelo de nuevo después de algún tiempo.",
	"add.to.cart.label": "Añadir al carrito",
	"administrator.message": "es el administrador de la organización:",
	"ag-grid.copy": "Copiar",
	"ag-grid.copyWithHeaders": "Copiar con encabezados",
	"ag-grid.csvExport": "CSV Exportar",
	"ag-grid.excelExport": "Excel Exportar (.xlsx)&lrm;",
	"ag-grid.excelXmlExport": "Excel Exportar (.xlm)&lrm;",
	"ag-grid.export": "Exportar",
	"ag-grid.paste": "Pegar",
	"all.productsFamilies.not.available": "No todas las familias de productos están disponibles",
	"application.procurement.supplier.rfqNumber": "Número de RFQ del proveedor",
	"aqdb.N.of.dispatch.note": "N of Dispatch Note",
	"aqdb.ageing.duration": "Duration of ageing",
	"aqdb.ageing.temp": "Temperature of ageing",
	"aqdb.aluminium": "% Al",
	"aqdb.anisotropy.avg.r": "R average",
	"aqdb.anisotropy.direction": "Cutting Direction Compared to Rolling",
	"aqdb.anisotropy.r": "Value R",
	"aqdb.arsenic": "% Ar",
	"aqdb.article.reference": "Article reference",
	"aqdb.aspect.side.1": "Aspect side 1 code",
	"aqdb.aspect.side.2": "Aspect side 2 code",
	"aqdb.av.date": "Available date",
	"aqdb.avg.hardening.ratio": "Coefficient of Average Work Hardening",
	"aqdb.axis": "Axis",
	"aqdb.bakeHardening.with.elongation": "Bake-hardening with 2% elongation",
	"aqdb.bakeHardening.without.elongation": "Bake-hardening without elongation",
	"aqdb.base.product.number": "Base product number",
	"aqdb.base.product.release": "Base product release",
	"aqdb.batch": "Batch",
	"aqdb.batch.reference": "Batch reference",
	"aqdb.bend.indicator": "Code folding",
	"aqdb.boron": "% B",
	"aqdb.calcium": "% Ca",
	"aqdb.carbon": "% C",
	"aqdb.carbon.eq.formula": "Formula carbon-equivalent",
	"aqdb.carbon.equivalent": "Carbon equivalent",
	"aqdb.casting.date": "Casting date",
	"aqdb.casting.mill": "Casting Mill",
	"aqdb.cerium": "% Ce",
	"aqdb.chemical.characteristics": "Chemical characteristics",
	"aqdb.chemical.characteristics.cast.analysis": "Chemical characteristics - Cast analysis",
	"aqdb.chemical.characteristics.product.analysis": "Chemical characteristics - Product analysis",
	"aqdb.chemical.formula": "Another combination",
	"aqdb.chemical.surface.chemical.treatment.avg1": "Average value 1",
	"aqdb.chemical.surface.chemical.treatment.avg2": "Average value 2",
	"aqdb.chemical.surface.chemical.treatment.avg3": "Average value 3",
	"aqdb.chemical.surface.chemical.treatment.avg4": "Average value 4",
	"aqdb.chemical.surface.chemical.treatment.avg5": "Average value 5",
	"aqdb.chemical.surface.chemical.treatment.element1": "Chemical element 1",
	"aqdb.chemical.surface.chemical.treatment.element2": "Chemical element 2",
	"aqdb.chemical.surface.chemical.treatment.element3": "Chemical element 3",
	"aqdb.chemical.surface.chemical.treatment.element4": "Chemical element 4",
	"aqdb.chemical.surface.chemical.treatment.element5": "Chemical element 5",
	"aqdb.chemical.surface.chemical.treatment.type": "Type of chemical coating",
	"aqdb.chemical.surface.treatment": "Coating / Surface characteristics - Inorganic coating",
	"aqdb.chromium": "% Cr",
	"aqdb.coating.surface.face": "Face",
	"aqdb.coating.surface.side": "Side",
	"aqdb.code": "Code",
	"aqdb.combination.value": "Value combination",
	"aqdb.commercial.quality": "Commercial quality",
	"aqdb.complete.message": "Indicator of complete message",
	"aqdb.copper": "% Cu",
	"aqdb.customer.article.ref": "Customer Article Ref.",
	"aqdb.customer.product": "Customer product",
	"aqdb.customer.product.data": "Customer products data",
	"aqdb.datas.transmitted.on.certificate": "Data transmitted on certificate",
	"aqdb.date": "Date",
	"aqdb.date.chemical": "Identification Date",
	"aqdb.delivery.mill": "Delivery mill",
	"aqdb.description": "Technical Quality Label",
	"aqdb.dimensions.form": "Dimensions & Form",
	"aqdb.direction.L": "Longitudinal",
	"aqdb.direction.T": "Transverse",
	"aqdb.dis.elongation": "Lengthening distributed",
	"aqdb.dispatch.advice.number": "Dispatch advice number",
	"aqdb.dispatch.date": "Dispatch Date",
	"aqdb.erichsen.index": "Erichsen index",
	"aqdb.external.diameter": "External diameter of MU",
	"aqdb.face.appearance.code1": "Face appearance code 1",
	"aqdb.face.appearance.code2": "Face appearance code 2",
	"aqdb.family.group.code": "Family group code",
	"aqdb.flag.complete": "Complete",
	"aqdb.flag.incomplete": "Incomplete",
	"aqdb.form": "Form",
	"aqdb.format.actual": "Format (actual/ordered)",
	"aqdb.formula.cal02": "Formula CAL02",
	"aqdb.formula.cal15": "Formula CAL15",
	"aqdb.grade": "Grade",
	"aqdb.gross.weight": "Gross Weight",
	"aqdb.hardness.index": "Hardness number",
	"aqdb.hardness.type": "Condition of the hardness test",
	"aqdb.heat.number": "Heat N°'",
	"aqdb.hydrogen": "% H",
	"aqdb.induction.10000w": "Induction at 10000 W",
	"aqdb.induction.2500w": "Induction at 2500 W",
	"aqdb.induction.5000w": "Induction at 5000 W",
	"aqdb.internal.diameter": "Internal diameter of MU",
	"aqdb.label": "Datos de AQDB",
	"aqdb.lead": "% Pb",
	"aqdb.level": "Palier",
	"aqdb.losses.15t": "Losses at 1,5 T",
	"aqdb.losses.1t": "Losses at 1 T",
	"aqdb.magnetic.characteristicList": "Magnetic characteristics",
	"aqdb.manganese": "% Mn",
	"aqdb.marked.identity": "Marked Identity",
	"aqdb.measure.type": "Measure type",
	"aqdb.measured.datas": "Measured data",
	"aqdb.mechanical.characteristics.anisotropy": "Mechanical characteristics - Anisotropy",
	"aqdb.mechanical.characteristics.bake.hardening": "Mechanical characteristics - Bake hardening",
	"aqdb.mechanical.characteristics.bending": "Mechanical characteristics - Bending",
	"aqdb.mechanical.characteristics.erichsen": "Mechanical characteristics - Erichsen",
	"aqdb.mechanical.characteristics.hardness": "Mechanical characteristics - Hardness",
	"aqdb.mechanical.characteristics.impact.resistance": "Mechanical characteristics - Resilience",
	"aqdb.mechanical.characteristics.tensile.test": "Mechanical characteristics - Tensile test",
	"aqdb.metal.coating.aluminium": "% Aluminium",
	"aqdb.metal.coating.average.quantity": "Average quantity",
	"aqdb.metal.coating.characteristics": "Coating / Surface characteristics - Metal coating",
	"aqdb.metal.coating.delta.phase": "Mass Phase Delta",
	"aqdb.metal.coating.dzeta.phase": "Mass Phase Dzeta",
	"aqdb.metal.coating.gamma.phase": "Mass Phase Gamma",
	"aqdb.metal.coating.iron.rate": "Iron rate in galvallia",
	"aqdb.metal.coating.lead": "% Lead",
	"aqdb.metal.coating.measure.type": "Type of measurement",
	"aqdb.metal.coating.nature": "Nature of metallic coating",
	"aqdb.metal.coating.nickel": "% Nickel",
	"aqdb.metal.coating.powdering": "Powdering",
	"aqdb.metal.coating.quantity.centre": "Quantity Centre",
	"aqdb.metal.coating.quantity.edge1": "Quantity Edge 1",
	"aqdb.metal.coating.quantity.edge2": "Quantity Edge 2",
	"aqdb.metal.coating.spangling": "Spangling",
	"aqdb.metal.unit": "Metal unit",
	"aqdb.metal.unit.date": "Metal Unit Identification Date",
	"aqdb.metal.unit.information": "Metal unit informations",
	"aqdb.metal.unit.mill": "Metal Unit Identification Mill",
	"aqdb.mill.cast": "Mill Cast Number",
	"aqdb.mill.cast.number": "Mill Cast Number",
	"aqdb.mill.code": "Receiving mill code",
	"aqdb.mill.description": "Mill",
	"aqdb.mill.internal.ref": "Mill internal reference",
	"aqdb.modelled.data": "Modelled data",
	"aqdb.molybdenum": "% Mo",
	"aqdb.mpa.unit": "megapascal (Mpa)",
	"aqdb.nature": "Nature",
	"aqdb.net.weight": "Net weight (t)",
	"aqdb.nickel": "% Ni",
	"aqdb.niobium": "% Nb",
	"aqdb.nitrogen": "% N2",
	"aqdb.no": "No",
	"aqdb.nominal.thickness": "Nominal thickness",
	"aqdb.nominal.width": "Nominal width",
	"aqdb.notch.average.crystallinity.index": "Average crystallinity index",
	"aqdb.notch.average.ductility.rate": "Average ductility rate",
	"aqdb.notch.average.energy": "Average energy (in Joules)",
	"aqdb.notch.crystallinity.index1": "Crystallinity index 1",
	"aqdb.notch.crystallinity.index2": "Crystallinity index 2",
	"aqdb.notch.crystallinity.index3": "Crystallinity index 3",
	"aqdb.notch.energy1": "Energy 1 (in Joules)",
	"aqdb.notch.energy2": "Energy 2 (in Joules)",
	"aqdb.notch.energy3": "Energy 3 (in Joules)",
	"aqdb.notch.percent.ductility1": "Ductility rate 1",
	"aqdb.notch.percent.ductility2": "Ductility rate 2",
	"aqdb.notch.percent.ductility3": "Ductility rate 3",
	"aqdb.organic.coating.bending": "Bending",
	"aqdb.organic.coating.brilliance": "Brilliance",
	"aqdb.organic.coating.characteristics": "Coating / Surface characteristics - Organic coating",
	"aqdb.organic.coating.colour": "Colour",
	"aqdb.organic.coating.delta.a": "Delta A",
	"aqdb.organic.coating.delta.b": "Delta B",
	"aqdb.organic.coating.delta.e": "Delta E",
	"aqdb.organic.coating.delta.l": "Delta L",
	"aqdb.organic.coating.nature": "Nature of organic coating",
	"aqdb.organic.coating.reticulation": "Reticulation",
	"aqdb.organic.coating.thickness": "Thickness",
	"aqdb.origin.mill": "Origin Mill",
	"aqdb.other.characteristics": "Other Characteristics",
	"aqdb.oui": "Oui",
	"aqdb.phosphorus": "% P",
	"aqdb.pos.across.length": "Position test-tube in the length of the product",
	"aqdb.pos.across.width": "Position test-tube in the width of the product",
	"aqdb.product.family": "Product family",
	"aqdb.quality.code": "Technical Quality Code",
	"aqdb.quality.data": "consultar datos de calidad",
	"aqdb.quality.label": "Technical Quality Label",
	"aqdb.quality.version": "Technical Quality Version",
	"aqdb.quarter": "Quarter",
	"aqdb.recipient": "Recipient",
	"aqdb.release": "Technical Quality Version",
	"aqdb.roughness.characteristics": "Coating / Surface characteristics - Roughness",
	"aqdb.roughness.cut.off": "Cut-Off",
	"aqdb.roughness.obtainment": "Method of obtainment",
	"aqdb.roughness.peaks": "Number of peaks",
	"aqdb.roughness.ra": "Ra",
	"aqdb.roughness.rt": "Rt",
	"aqdb.roughness.rz": "Rz",
	"aqdb.roughness.threshold": "Threshold",
	"aqdb.roughness.w": "W",
	"aqdb.sample.type": "Type of test-tube",
	"aqdb.segment": "Segment",
	"aqdb.segments.no": "Number of Segments",
	"aqdb.serial.number": "Serial number",
	"aqdb.shipping": "Shipping Information",
	"aqdb.silicium": "% Si",
	"aqdb.steel.condition": "State of Metal",
	"aqdb.sulphur": "% S",
	"aqdb.surface.cleanliness.carbon": "Surface carbon",
	"aqdb.surface.cleanliness.characteristics": "Coating / Surface characteristics - Surface cleanliness",
	"aqdb.surface.cleanliness.iron": "Surface iron",
	"aqdb.surface.mu": "Surface of MU",
	"aqdb.technical.grade": "Technical grade",
	"aqdb.temp.notch": "Temperature notch test",
	"aqdb.tensile.direction": "Direction",
	"aqdb.tensile.re.rm": "Re/Rm",
	"aqdb.tensile.total.lengthening": "Total Lengthening",
	"aqdb.tensile.ultimate.tensile.stress": "Ultimate Tensile Stress",
	"aqdb.tensile.work.hardening.coefficient": "Work-hardening coefficient",
	"aqdb.test.condition": "Condition of the test",
	"aqdb.test.number.anisotropy": "Number of the test of anisotropy",
	"aqdb.test.number.bakehardening": "Number of the test Bake Hardening",
	"aqdb.test.number.bending": "Number of the bending test",
	"aqdb.test.number.erichsen": "Number of the test of Erichsen",
	"aqdb.test.number.hardness": "Number of the Hardness test",
	"aqdb.test.number.res": "Number of the reslience test",
	"aqdb.test.number.tensile": "Number of the tensile test",
	"aqdb.test.steel.condition": "State of the test-tube",
	"aqdb.test.temp": "Temperature of the test",
	"aqdb.thickness.mm": "Thickness (mm)",
	"aqdb.tin": "% Sn",
	"aqdb.titanium": "% Ti",
	"aqdb.unit": "Unit",
	"aqdb.user": "User",
	"aqdb.value.cal02": "CAL02",
	"aqdb.value.cal15": "CAL15",
	"aqdb.vanadium": "% V",
	"aqdb.weight.mu": "Net weight/Gross weight",
	"aqdb.width.mm": "Width (mm)",
	"aqdb.yes": "Yes",
	"aqdb.yield.stress": "Yield Stress",
	"aqdb.zinc": "% Zn",
	"aqdb.zirconium": "% Zr",
	"arcelormittal.need4steel.action.next": "Siguiente",
	"arcelormittal.need4steel.action.proceed.to.order.button": "Proceder al pedido",
	"arcelormittal.need4steel.entry": "ArcelorMittal Need4Steel®",
	"arcelormittal.need4steel.menu.entry": "ArcelorMittal Need4Steel",
	"attachment.limit.description": "PDF, DOC, XLS, PPT or images only. Max 20MB per file and max 3 files.",
	"auction-material.category.subcategory": "Cat/sub",
	"auction-material.details": "Detalles del material",
	"auction-material.downgrading.reason": "Motivo de la degradación",
	"auction-material.oil.type": "Tipo de aceite",
	"auction-offer.now-rows": "No hay oferta de subasta abierta disponible",
	"auction-offer.soldTo.changed.warning": "If you change the corporate name, all the bid details you have entered/modified in current session will be lost.",
	"auction.bid.list": "Subastas - Lista de ofertas",
	"auction.bid.week": "Semana de la oferta",
	"auction.bidding": "Ofertas de subastas enc",
	"auction.bids": "Ofertas",
	"auction.bundle.number": "Número de paquete",
	"auction.confirm.bid": "Confirmar oferta",
	"auction.confirmation": "Confirmación",
	"auction.dashboard": "Panel de subastas",
	"auction.description": "Descripción de la subasta",
	"auction.ended": "Finalizado",
	"auction.entry": "Subastas",
	"auction.main.steelgrade": "Grado de acero principal (por volumen)",
	"auction.market": "Mercado",
	"auction.mill": "Fábrica",
	"auction.my.auction.bids": "Mis ofertas de subasta",
	"auction.name": "Nombre de la subasta",
	"auction.new.offer.check": "Comprobar nueva oferta en la subasta",
	"auction.offer.bid.awarded": "Awarded",
	"auction.offer.bid.pending": "Pending",
	"auction.offer.bid.rejected": "Rejected",
	"auction.offer.bundle": "Paquete",
	"auction.offer.clear.infos": "Borrar información",
	"auction.offer.customer.reference": "Referencia del cliente",
	"auction.offer.customerref.mandatory": "La referencia del cliente es obligatoria",
	"auction.offer.delivery.address.mandatory": "Delivery address is mandatory",
	"auction.offer.effective.price": "Precio efectivo",
	"auction.offer.exw.price": "Precio EXW €/t",
	"auction.offer.exwprice.mandatory": "El precio Exw es obligatorio",
	"auction.offer.invoicing.in": "Facturación en",
	"auction.offer.lanned.loading.date": "Fecha de carga planificada",
	"auction.offer.no.bids": "No bids available",
	"auction.offer.payment.condition": "Condiciones de pago",
	"auction.offer.tmode.mandatory": "El modo de transporte es obligatorio",
	"auction.offer.transport.cost": "Coste de transporte",
	"auction.offer.transport.invoiced.conditions": "Condiciones de facturación del transporte",
	"auction.offer.type.of.maritime.transport": "Tipo de transporte marítimo",
	"auction.overview": "Tu resumen de subastas de esta semana",
	"auction.price.unit.et": "€/t",
	"auction.product.type": "Tipo de producto",
	"auction.selection": "Selección de subastas",
	"auction.submit.not.authorized.internal": "Enviar acción no autorizada en modo simulación o delegación",
	"auction.timer.days": "días",
	"auction.timer.endsin": "Termina en",
	"auction.timer.hours": "h",
	"auction.timer.minutes": "min",
	"auction.timer.weight.available": "Disponible",
	"auction.transport.price": "Coste de transporte (€/t)",
	"auction.weight.unit.gross": "bruto",
	"auctions.menu": "Subastas",
	"auctions.opened": "subastas abiertas",
	"batch-card.all-documents": "Todos los documentos de este lote",
	"batch-card.batch-information": "Datos del lote",
	"batch-card.batch-status": "Estado del lote",
	"batch-card.certificate-display-all": "Mostrar todos los certificados",
	"batch-card.create-call-off": "Iniciar un nuevo eCall-off",
	"batch-card.current-location": "Ubicación actual",
	"batch-card.customer-article-reference": "Referencia del artículo del cliente",
	"batch-card.customer-order-number": "Número de pedido del cliente",
	"batch-card.data-not-found": "Batch data not found",
	"batch-card.date-available-for-dispatch": "Fecha disponible para el envío",
	"batch-card.days-in-stock": "Número de días en stock",
	"batch-card.detailed-batch-status": "Estado detallado del lote ",
	"batch-card.dispatch-advice-display-all": "Mostrar todos los avisos del envío",
	"batch-card.document-date": "Fecha",
	"batch-card.document-number": "Número del documento",
	"batch-card.document-show": "Mostrar documento",
	"batch-card.document-type": "Tipo",
	"batch-card.final-use": "Uso final",
	"batch-card.followup": "Seguimiento",
	"batch-card.gross-weight": "Peso bruto",
	"batch-card.heat-number": "Número de colada",
	"batch-card.invoice-display-all": "Mostrar todas las facturas",
	"batch-card.last-certificate": "Último certificado",
	"batch-card.last-dispatch-advice": "Último aviso del envío",
	"batch-card.last-documents": "Últimos documentos",
	"batch-card.last-invoice": "Última factura",
	"batch-card.length": "Largo (mm)",
	"batch-card.mill": "Fábrica",
	"batch-card.mill-order-number": "Número de pedido de fábrica",
	"batch-card.net-weight": "Peso neto",
	"batch-card.package-serial-number": "Número de serie del paquete",
	"batch-card.planned-loading-date": "Fecha de carga prevista",
	"batch-card.shipments": "Entregas",
	"batch-card.steelgrade": "Grado del acero",
	"batch-card.stock-alert": "Alerta de stock",
	"batch-card.supplier-order-number": "Número de pedido del proveedor",
	"batch-card.thickness": "Espesor (mm)",
	"batch-card.width": "Ancho (mm)",
	"batch-list.last-seen": "Últimos lotes vistos",
	"batch.card": "Datos del lote",
	"batch.card.article": "Artículo",
	"batch.card.customer": "Cliente",
	"batch.card.dimensions": "Dimensiones",
	"batch.card.final-use": "Uso final",
	"batch.card.go-to-the-order": "Ir al pedido",
	"batch.card.information": "Datos del lote",
	"batch.card.invoiced": "Facturado",
	"batch.card.mill": "Fábrica",
	"batch.card.mill-order": "Pedido de fábrica",
	"batch.card.order": "Pedido",
	"batch.card.weight": "Peso",
	"batch.coil-length": "Largo (mm)",
	"batch.current-location": "Ubicación actual",
	"batch.current.location": "Ubicación actual",
	"batch.date-for-dispatch": "Fecha disponible para el envío",
	"batch.despatch.advice": "Aviso del envío",
	"batch.despatch.date": "Fecha de envío",
	"batch.detailed-batch-status": "Estado detallado del lote",
	"batch.ecall-status": "eCall-off status",
	"batch.from.same.invoice": "Solo lotes a partir del número de factura:",
	"batch.from.same.invoice.available": "están disponibles para esta reclamación",
	"batch.gross": "Peso bruto",
	"batch.gross-t": "Bruto (t)",
	"batch.heat-number": "Número de colada",
	"batch.in-stock": "en existencias",
	"batch.in-transit-detail": "En tránsito - Detalles",
	"batch.invoice.date": "Invoice date",
	"batch.length": "Longitud",
	"batch.net": "Peso neto",
	"batch.net-t": "Neto (t)",
	"batch.not.invoiced": "Lote no facturado",
	"batch.not.invoiced.select.other": "Por favor, vuelve más tarde para plantear un problema de calidad sobre esta unidad de material.",
	"batch.not.invoiced.sorry": "Lo sentimos, el lote que has elegido aún no se ha facturado",
	"batch.package-serial-number": "Número de serie del paquete",
	"batch.planned-loading-date": "Fecha de carga planificada",
	"batch.reference": "Lote",
	"batch.requested-delivery-date": "Fecha de entrega solicitada para llamada",
	"batch.requested-delivery-date-from": "Requested delivery date from",
	"batch.requested-delivery-date-to": "Requested delivery date to",
	"batch.shipment.date": "Fecha de envío",
	"batch.shipto": "Enviar a",
	"batch.status": "Estado del lote",
	"batch.supplier.invoice.number": "Invoice number",
	"batch.view.all": "Ver todos los lotes",
	"batch.view.all.at": "Ver todos los lotes en {{value}}",
	"batches.detailed.batch.status": "Estado detallado del lote",
	"batches.doc": "Doc",
	"batches.gross-t": "Bruto (t)",
	"batches.net-t": "Neto (t)",
	"batches.number.of.day.in.stock": "Número de días en existencias",
	"blocked-service-alert.plural": "Lo sentimos, estos servicios no están disponibles en este momento, por favor intente más tarde: {{services}}",
	"blocked-service-alert.refresh": "Actualizar",
	"blocked-service-alert.singular": "Lo sentimos, este servicio no está disponible en este momento, por favor intente más tarde: {{service}}",
	"browse.files": "Browse files",
	"cancel.issue": "Cancel your issue",
	"card.no.selected": "ningún producto seleccionado",
	"card.prototype": "Prototipo",
	"card.prototype.lastModificationdate": "Last modification date",
	"card.prototype.production": "Producción",
	"card.selected": "{{value}} productos seleccionados",
	"cdd.in.date": "CDD en día",
	"cdd.in.week": "CDD en semana",
	"chart-title.M1": "Ene",
	"chart-title.M10": "Oct",
	"chart-title.M11": "Nov",
	"chart-title.M12": "Dic",
	"chart-title.M2": "Feb",
	"chart-title.M3": "Mar",
	"chart-title.M4": "Abr",
	"chart-title.M5": "May",
	"chart-title.M6": "Jun",
	"chart-title.M7": "Jul",
	"chart-title.M8": "Ago",
	"chart-title.M9": "Sep",
	"chart-title.Q1": "T1",
	"chart-title.Q2": "T2",
	"chart-title.Q3": "T3",
	"chart-title.Q4": "T4",
	"chart-title.S1": "S1",
	"chart-title.S2": "S2",
	"check.new.offer": "Comprobar nuevas ofertas",
	"choose.customer.last.used": "Últimas selecciones:",
	"choose.customer.restrict": "Por favor, limite su alcance al utilizar la aplicación SteelUser, ya que es una aplicación específica del cliente.",
	"choose.customer.select": "Como usuario interno, tiene que seleccionar el cliente al que quiere mostrar los datos",
	"choose.visibility.select": "Por favor, seleccione su visibilidad entre las opciones disponibles:",
	"claim-batch.receipt-date": "Fecha de recepción",
	"claim.action.plan.notif": "Si es necesario, llame a su contacto técnico para llevar a cabo una medida correctiva",
	"claim.add-batch-to-this-issue": "Añadir lote a esta edición",
	"claim.add.attachment": "Añadir adjuntos",
	"claim.additional.costs.invalid": "El importe reclamado por otros gastos debe ser válido",
	"claim.additional.costs.mandatory": "El importe reclamado por otros gastos es obligatorio",
	"claim.additional.costs.requested": "Costes adicionales solicitados",
	"claim.amount.for.other.costs": "Importe reclamado por otros gastos",
	"claim.amount.previous.value": "Su importe anterior: {{value}}",
	"claim.amount.unit.error": "Factura expresada en:",
	"claim.archived": "Archivo",
	"claim.attach.several.documents": "Adjuntar uno o varios documentos",
	"claim.attachment.error": "Los archivos adjuntos no se han cargado correctamente; por favor, inténtalo de nuevo.",
	"claim.attachment.filename.error": "Please make sure that your filename is less than 80 characters",
	"claim.attachment.limit.zl": "El nombre del archivo debe tener menos de 80 caracteres",
	"claim.attachment.limit.zr": "Proporcione todos los detalles relevantes necesarios para validar el importe y la cantidad reclamados, como los números de bobina afectados, el peso y cualquier otra información de apoyo. Proporcionar información completa y precisa nos ayudará a procesar su reclamación de forma rápida y eficiente. El nombre del archivo debe tener menos de 80 caracteres",
	"claim.attachment.mandatory": "Por favor, añade al menos un archivo adjunto",
	"claim.attachment.uploading.error": "Algunos archivos adjuntos aún se están cargando; por favor, espera.",
	"claim.attachments": "Adjuntos",
	"claim.attachments.description": "Por favor, añade al menos una foto o un vídeo que pueda ayudar a ArcelorMittal a responder a tu solicitud",
	"claim.barcode.number": "Número de código de barras",
	"claim.batch": "Lote",
	"claim.batch.reference.mandatory": "El campo Número de lote es obligatorio",
	"claim.batch.selection": "Selección de lote",
	"claim.batches": "Lotes",
	"claim.choose.defect": "Elegir defecto",
	"claim.claimtype.label": "Tipo de reclamación",
	"claim.comment": "Comentario",
	"claim.comment.mandatory": "El comentario es obligatorio",
	"claim.comment.placeholder": "Ingrese un breve comentario para explicar el problema de calidad. Intente ser lo más preciso posible.",
	"claim.contact.type.mandatory": "El tipo de contacto es obligatorio",
	"claim.created": "Creado",
	"claim.created.by": "Creado por",
	"claim.current.status": "Estado actual",
	"claim.current.statusddot": "Estado actual :",
	"claim.dashboard.services": "Mis servicios",
	"claim.dashboard.services.claims": "Comentarios sobre calidad",
	"claim.defect": "Defecto",
	"claim.defect.mandatory": "El campo Defecto es obligatorio",
	"claim.display-pending-drafts": "comentarios pendientes",
	"claim.display-saved-drafts": "borrador(es) guardado(s)",
	"claim.first.batch.selection": "Primera selección de lote",
	"claim.full.quantity": "Cantidad completa",
	"claim.go-back-to-batch-management": "Volver a la gestión de lotes",
	"claim.guarantee.request": "SOLICITUD DE NUEVA GARANTÍA",
	"claim.impacted.quantity": "Cantidad afectada",
	"claim.impacted.quantity.mandatory": "El campo Cantidad afectada es obligatorio",
	"claim.impacted.quantity.minimum": "Introduce una cantidad válida mayor o igual a 1.",
	"claim.impacted.quantity.t": "Cantidad afectada (t)",
	"claim.last.modification": "Última modificación",
	"claim.main.batch.remove": "Eliminar",
	"claim.main.batch.selected": "Lote seleccionado",
	"claim.material.costs": "Costos de material",
	"claim.material.unit": "Unidad de medida",
	"claim.multi.batch.related.order": "Pedido relacionado",
	"claim.no.attachment": "No hay adjuntos",
	"claim.no.reference": "Sin referencia",
	"claim.no.sample.needed": "No se necesita una muestra para este defecto.",
	"claim.not-existing-or-not-permission": "La reclamación no existe o no tiene permiso para acceder a los datos de la reclamación.",
	"claim.optional": "Opcional",
	"claim.other.amount.cost": "Importe reclamado por otros gastos",
	"claim.paid.amount": "Importe pagado",
	"claim.placeholder.reference.number": "Número de referencia del cliente",
	"claim.quality.issue": "Reclamo",
	"claim.quality.issue.information": "Información de la calidad",
	"claim.quality.issue.summary": "Resumen de la calidad",
	"claim.quantity.limit.error": "Cantidad solicitada superior a la facturada.",
	"claim.quantity.previous.value": "Su importe anterior: {{value}}",
	"claim.quantity.tons.error": "La cantidad afectada debe ser inferior a 1000 por unidad: Toneladas métricas",
	"claim.quantity.unit.error": "Factura expresada en:",
	"claim.raise-new-quality-issue": "Plantear un problema de calidad",
	"claim.receipt.date.mandatory": "La fecha de recepción es obligatoria",
	"claim.reference.number": "Número de referencia",
	"claim.request.type": "Tipo de solicitud",
	"claim.requested.amount": "Importe solicitado",
	"claim.requested.material.costs": "Costos de material solicitados",
	"claim.sample": "La muestra se enviará a:",
	"claim.sample.agency": "Contacto comercial",
	"claim.sample.cts": "Contacto técnico",
	"claim.sample.mandatory": "La muestra es obligatoria",
	"claim.sample.not": "No enviaré una muestra",
	"claim.sample.not.recommended": "(no recomendado)",
	"claim.sample.other": "Otro",
	"claim.sample.other.comment": "Ingrese el destino de la muestra",
	"claim.status.created": "Creado",
	"claim.total.amount": "Importe total evaluado",
	"claim.total.requested.amount": "Importe total solicitado",
	"claim.total.requested.calculated": "Cantidad total solicitada calculada",
	"claim.total.weight": "Peso total",
	"claim.type.filter.label": "Tipo de reclamación",
	"claim.type.zl": "Reclamación del cliente ZL",
	"claim.type.zr": "Regularización de reclamo ZR",
	"claim.visit": "Contacto de ArcelorMittal",
	"claim.visit.text": "Quiero que un contacto de ArcelorMittal se ponga en contacto conmigo.",
	"claim.warning": "Advertencia",
	"claim.warning.takenintoaccount": "Advertencia tomada en cuenta",
	"claim.zr.attachment.info": "Siempre mencione todos los lotes afectados y cualquier detalle relevante adicional (por ejemplo, cantidad por lote) para garantizar un manejo eficiente de la reclamación.",
	"coil.calculator.additional.data": "Datos adicionales",
	"coil.calculator.all.other.coils": "Todas las demás bobinas",
	"coil.calculator.density.text": "Se basa en una densidad constante de \"7,85t/m³\".",
	"coil.calculator.inner.diameter": "Diámetro interno de la bobina",
	"coil.calculator.inner.diameter.label": "Diámetro interno de la bobina (mm)",
	"coil.calculator.inner.diameter.mandatory": "El diámetro interno de la bobina es obligatorio",
	"coil.calculator.input.parameters": "Parámetros de entrada",
	"coil.calculator.length": "Longitud de la bobina",
	"coil.calculator.length.label": "Longitud de la bobina (m)",
	"coil.calculator.length.mandatory": "La longitud de la bobina es obligatoria",
	"coil.calculator.metallic.coating.thickness.label": "Espesor del revestimiento metálico (g/㎡)",
	"coil.calculator.metallic.coating.type.label": "Tipo de revestimiento metálico",
	"coil.calculator.metallic.coating.type.mandatory": "El tipo de revestimiento metálico es obligatorio",
	"coil.calculator.no.result.text": "Por favor, rellena todos los campos para ver los resultados.",
	"coil.calculator.nominal.thickness.label": "Espesor nominal (mm)",
	"coil.calculator.nominal.thickness.mandatory": "El espesor nominal es obligatorio",
	"coil.calculator.organic.coated.coils": "Bobinas con recubrimiento orgánico",
	"coil.calculator.organic.coated.film.thickness.label": "Espesor de la película de recubrimiento orgánico (μm)",
	"coil.calculator.outer.diameter": "Diámetro externo de la bobina",
	"coil.calculator.outer.diameter.label": "Diámetro externo de la bobina (mm)",
	"coil.calculator.outer.diameter.mandatory": "El diámetro externo de la bobina es obligatorio",
	"coil.calculator.outer.less.than.inner.error": "Campo menor que el Ø interno.",
	"coil.calculator.product.information": "Información del producto",
	"coil.calculator.result": "Resultado",
	"coil.calculator.specific.weight": "Peso específico",
	"coil.calculator.specific.weight.label": "Peso específico (kg/mm)",
	"coil.calculator.specific.weight.mandatory": "El peso específico es obligatorio",
	"coil.calculator.technical.feasibility.text": "La herramienta no proporciona ninguna factibilidad técnica en nuestras fábricas de las bobinas calculadas.",
	"coil.calculator.tool.text": "Esta calculadora de bobinas es una herramienta que te ayudará a calcular el diámetro exterior, el peso, la longitud o el peso específico de la bobina.",
	"coil.calculator.total.paint.thickness.label": "Espesor total de la pintura arriba + abajo (μm)",
	"coil.calculator.weight": "Peso de la bobina",
	"coil.calculator.weight.label": "Peso de la bobina (ton)",
	"coil.calculator.weight.mandatory": "El peso de la bobina es obligatorio",
	"coil.calculator.width.label": "Anchura (mm)",
	"coil.calculator.width.mandatory": "La anchura es obligatoria",
	"comment.offer.set": "Comentarios :",
	"commercial-documents-da.enduser": "Usuario final",
	"commercial-documents-da.heat": "Colada",
	"commercial-documents-da.serial": "De serie",
	"commercial-documents-da.supplier-article-reference": "Referencia de artículo del proveedor",
	"commercial-documents.all-my-documents": "Todos mis documentos",
	"commercial-documents.amount": "Amount certified",
	"commercial-documents.batch-number": "Número de lote",
	"commercial-documents.batches-details": "Detalles del lote",
	"commercial-documents.ce.enduser": "Usuario final",
	"commercial-documents.ce.serial-number": "Número de serie",
	"commercial-documents.ce.supplier-article-reference": "Referencia de artículo del proveedor",
	"commercial-documents.certificate-card": "Tarjeta de certificado",
	"commercial-documents.certificate-date": "Fecha de certificado",
	"commercial-documents.certificate-number": "Número de certificado",
	"commercial-documents.certificate-type": "Tipo de certificado",
	"commercial-documents.customer": "Cliente",
	"commercial-documents.customer-article-reference": "Referencia del artículo del cliente",
	"commercial-documents.customer-claim-reference": "Referencia de reclamación del cliente",
	"commercial-documents.customer-order-number": "Número de pedido del cliente",
	"commercial-documents.date": "Fecha del documento",
	"commercial-documents.dimensions": "Dimensiones",
	"commercial-documents.discount": "Descuento",
	"commercial-documents.dispatch-advice-date": "Fecha del aviso de envío",
	"commercial-documents.dispatch-advice-number": "Número de aviso de envío",
	"commercial-documents.display-all-orders": "Mostrar todos los pedidos",
	"commercial-documents.docsWithCreationDateGtLastConnectionDate": "Documentos registrados desde tu última conexión",
	"commercial-documents.documents": "documentos",
	"commercial-documents.download-cart": "Descargar carrito",
	"commercial-documents.emptyHeatNumber": "N/A",
	"commercial-documents.endQuarter": "End Quarter",
	"commercial-documents.enduser": "Usuario final",
	"commercial-documents.final-use": "Uso final",
	"commercial-documents.general-information": "Información general",
	"commercial-documents.heat-number": "Número de colada",
	"commercial-documents.invoice": "Factura",
	"commercial-documents.invoice-amount": "Importe de la factura (total)",
	"commercial-documents.invoice-amount-without-vat": "Importe de la factura sin IVA (total)",
	"commercial-documents.invoice-card": "Tarjeta de la factura",
	"commercial-documents.invoice-currency": "Moneda de la factura",
	"commercial-documents.invoice-date": "Fecha de la factura",
	"commercial-documents.invoice-discount": "Descuento de la factura (total)",
	"commercial-documents.invoice-number": "Número de factura",
	"commercial-documents.invoice-quantity": "Cantidad de factura",
	"commercial-documents.invoice-tax-amount": "Importe de impuestos de la factura (total)",
	"commercial-documents.invoice-type": "Tipo de factura",
	"commercial-documents.invoiced-quantity": "Cantidad facturada",
	"commercial-documents.invoiced-quantity-unit": "Cantidad facturada (unidad)",
	"commercial-documents.line-status": "Estado de la línea",
	"commercial-documents.mill": "Fábrica",
	"commercial-documents.mill-order-number": "Número de pedido de fábrica",
	"commercial-documents.my-commercial-documents": "Mis documentos comerciales",
	"commercial-documents.number": "Número de documento",
	"commercial-documents.order-acknowledgement-date": "Fecha de confirmación de pedido",
	"commercial-documents.order-acknowledgement-number": "Número de confirmación de pedido",
	"commercial-documents.order-acknowledgement-type": "Tipo de confirmación de pedido",
	"commercial-documents.order-quantity": "Cantidad facturada",
	"commercial-documents.order-reference": "Referencia del pedido",
	"commercial-documents.orderAcknowledgement-card": "Confirmación de pedido",
	"commercial-documents.ordered-quantity": "Cantidad solicitada (t)",
	"commercial-documents.orders-line-details": "Detalles de la línea de pedido",
	"commercial-documents.orders-number": "Número de pedido",
	"commercial-documents.payer": "Pagador",
	"commercial-documents.payer-vat-number": "Número de IVA del pagador",
	"commercial-documents.payment-due-date": "Fecha de vencimiento del pago",
	"commercial-documents.payment-due-to": "Pago debido a",
	"commercial-documents.payment-information": "Información del pago",
	"commercial-documents.plant-invoice-number": "Número de factura de la planta",
	"commercial-documents.product": "Producto",
	"commercial-documents.product-descriptions": "Descripción del producto",
	"commercial-documents.proforma": "Proforma",
	"commercial-documents.received-by-steeluser": "Recibido por SteelUser",
	"commercial-documents.rrp": "RRP type",
	"commercial-documents.shipto": "Enviar a",
	"commercial-documents.soldto": "Vendido a",
	"commercial-documents.steel-grade": "Grado de acero",
	"commercial-documents.subtype": "Subtipo",
	"commercial-documents.supplier-claim-reference": "Referencia de reclamación del proveedor",
	"commercial-documents.supplier-order-number": "Número de pedido del proveedor",
	"commercial-documents.supplier-vat-number": "Número de IVA del proveedor",
	"commercial-documents.tax": "Impuesto",
	"commercial-documents.transport-mode": "Modo de transporte",
	"commercial-documents.transport-reference": "Referencia de transporte",
	"commercial-documents.type": "Tipo de documento",
	"commercial-documents.vat": "IVA",
	"commercial-documents.vat-percentage": "Porcentaje de IVA",
	"commercial-documents.weight": "Peso",
	"commercial-documents.without-vat": "Sin IVA",
	"commercial-documents.xcarbsubtype": "XCarb® sub-type",
	"confirm.continue": "¿Quieres continuar?",
	"confirm.modified": "Última modificación el",
	"confirm.respectively": "respectivamente.",
	"confirm.same.material": "Hay otra reclamación sobre la misma unidad material con referencia a",
	"confirm.thanks": "Muchas gracias, hemos recibido tu solicitud.",
	"confirm.thanks.fastlane": "Muchas gracias, hemos recibido tu solicitud.",
	"confirmation.message": "No podrás deshacer esta acción después de la confirmación.",
	"contact.us": "Contact e-Business Support",
	"contactmail.popup.success.msg-line1": "Thanks, we have well received your message.",
	"contactmail.popup.success.msg-line2": "We will provide feedback as soon as possible.",
	"contactmail.submit.attachment.error.msg": "Sorry, something wrong with the attachment, try to reupload it",
	"contactmail.submit.error.msg": "Sorry, something wrong during the process. Try again later.",
	"contactmail.submit.session.error.msg": "Sorry, something wrong with your session, try to log again.",
	"continue.draft": "Continuar con el borrador",
	"corrosion.A": "Atmospheric",
	"corrosion.S": "Soil Corrosion",
	"create.new.order": "Crear un nuevo pedido",
	"create.new.request": "CREAR UNA NUEVA SOLICITUD",
	"customer.share.view": "Compartir la vista",
	"customer.simulation": "Seleccionar un cliente",
	"dashboard.active.parameters": "Parámetros activos",
	"dashboard.add-widget": "Agregar widget",
	"dashboard.add-widget-instruction": "Por favor seleccione el dispositivo que quiere añadir",
	"dashboard.cancel": "Cancelar",
	"dashboard.card.time-in-stock": "Tiempo en existencias",
	"dashboard.card.time-in-stock.time-to-call": "TIEMPO PARA LLAMAR",
	"dashboard.card.time-in-stock.view-details": "Ver detalles",
	"dashboard.claims": "Reclamaciones",
	"dashboard.condition": "Condición:",
	"dashboard.customer-material-reference": "Número de material del cliente",
	"dashboard.customize-indicator": "Personalizar",
	"dashboard.customize-information": "Personalizar",
	"dashboard.delete.confirmation-question": "¿Realmente quieres eliminar este widget?",
	"dashboard.documents-since-last-connection": "Documentos registrados desde su última conexión",
	"dashboard.drag-customer-article-here": "Coloque la referencia del artículo del cliente aquí",
	"dashboard.drag-drop-information": "Arrastra y suelta valores en el cuadro de la derecha",
	"dashboard.drag-steelgrades-here": "Suelta los grados de acero aquí",
	"dashboard.efeasibility": "eFeasibility",
	"dashboard.efeasibility.add.new": "Ask for a new feasibility",
	"dashboard.indicator": "Indicador",
	"dashboard.information": "Datos",
	"dashboard.key-indicator": "Indicador clave",
	"dashboard.key-information": "Información importante",
	"dashboard.my-business-overview": "Mi visión general del negocio",
	"dashboard.my.data": "Mis datos",
	"dashboard.order-status": "Estado del pedido",
	"dashboard.orders": "Pedidos",
	"dashboard.rts-widget.title": "En existencias",
	"dashboard.rts-widget.tooltip": "Cantidad lista para enviar disponible para este producto en todas las existencias",
	"dashboard.savechanges": "Guardar cambios",
	"dashboard.saving": "los widgets del tablero se están guardando ...",
	"dashboard.schedule.business.order-status": "Schedule business order status",
	"dashboard.spot.order-status": "Spot order status",
	"dashboard.steelgrade": "Grado del acero",
	"dashboard.validate": "Validar",
	"dashboard.view.more": "Ver más",
	"dashboard.widget-configuration": "Configuración",
	"dashboard.widget-preview": "Avance",
	"dashboard.widget.highest-stocks": "5 existencias más altas",
	"dashboard.widget.material-ready-to-ship": "Listo para enviar",
	"dashboard.without-value": "Sin valor",
	"datacenter-filter.LMD": "Modification date",
	"datacenter-filter.PO-Reception-date": "PO Reception date",
	"datacenter-filter.PO-Reception-week": "PO Reception week",
	"datacenter-filter.Proposed-Total-weight": "Proposed total weight",
	"datacenter-filter.Proposed-blank-weight": "Proposed blank weight",
	"datacenter-filter.Proposed-price": "Propuesta de precios",
	"datacenter-filter.additional-desc": "Additional item information",
	"datacenter-filter.back-office-customer": "Cliente de oficina interna",
	"datacenter-filter.back-office-role": "Función de oficina interna",
	"datacenter-filter.batch-reference": "Lote",
	"datacenter-filter.batch-status": "Detailed batch status",
	"datacenter-filter.batches-not-delivered-gross": "Batches not yet delivered to final destination (Gross, t)",
	"datacenter-filter.batches-not-delivered-net": "Batches not yet delivered to final destination (net, t)",
	"datacenter-filter.bill-to": "Bill to",
	"datacenter-filter.carrier-name": "Carrier name",
	"datacenter-filter.cdd": "CDD (semana)",
	"datacenter-filter.cdd-date": "CDD",
	"datacenter-filter.chemical-passivation": "Chemical Passivation",
	"datacenter-filter.choice": "Calidad",
	"datacenter-filter.coating": "Especificación del recubrimiento",
	"datacenter-filter.coilAxis": "CoilAxis",
	"datacenter-filter.collate-documents": "Collate Documents",
	"datacenter-filter.color-bottom-side": "Color parte inferior ",
	"datacenter-filter.color-category-bottom-side": "Color Category Bottom Side",
	"datacenter-filter.color-category-top-side": "Color Category Top Side",
	"datacenter-filter.color-top-side": "Color parte superior",
	"datacenter-filter.creation-date": "Fecha de creación",
	"datacenter-filter.current-location": "Ubicación actual",
	"datacenter-filter.customer-article-reference": "Referencia del artículo del cliente",
	"datacenter-filter.customer-order-number": "Número de pedido del cliente",
	"datacenter-filter.customer-order-number-without-item": "Customer order nr w/o item",
	"datacenter-filter.customer-req-name": "Customer request name",
	"datacenter-filter.customerRefusal": "Customer refusal comments",
	"datacenter-filter.data-sheet-bottom-side": "Hoja de datos org. : cara inf.",
	"datacenter-filter.data-sheet-top-side": "Hoja de datos org. : cara sup.",
	"datacenter-filter.date-available-for-dispatch": "Fecha disponible para el envío",
	"datacenter-filter.delay": "Delay",
	"datacenter-filter.delivery-address": "Dirección de entrega",
	"datacenter-filter.delivery-address-order": "Delivery address for order",
	"datacenter-filter.delivery-location": "Delivery location",
	"datacenter-filter.delivery-mode": "Modo de envío",
	"datacenter-filter.destination-address": "Destination Address",
	"datacenter-filter.destination-by-boat": "Destino en barco",
	"datacenter-filter.destination-name": "Destination Name",
	"datacenter-filter.detailed-batch-status": "Estado detallado del lote",
	"datacenter-filter.dimension": "Dim (mm)",
	"datacenter-filter.dispatch-advice": "Aviso de envío",
	"datacenter-filter.dispatch-advice-date": "Fecha de la nota de envío",
	"datacenter-filter.dispatch-advice-date-n1": "N-1 Fecha de expedición",
	"datacenter-filter.dispatch-advice-date-n2": "N-2 Fecha de expedición",
	"datacenter-filter.dispatch-advice-number": "Número de la nota de envío",
	"datacenter-filter.dispatch-advice-number-n1": "N-1 Número de la nota de envío",
	"datacenter-filter.dispatch-advice-number-n2": "N-2 Número de la nota de envío",
	"datacenter-filter.dispatch-date": "Fecha de expedición",
	"datacenter-filter.easy-film-bottom": "EasyFilm Bottom",
	"datacenter-filter.easy-film-top": "EasyFilm Top",
	"datacenter-filter.end-user": "Usuario final",
	"datacenter-filter.final-use": "Uso final",
	"datacenter-filter.first-name": "Nombre",
	"datacenter-filter.form": "Forma",
	"datacenter-filter.grade": "Grado",
	"datacenter-filter.gross-consignment": "Consign. (Bruto,t)",
	"datacenter-filter.gross-first-batch": "Primera bobina en stock (semana)",
	"datacenter-filter.gross-in-transit-details": "Detalles en tránsito (bruto, t)",
	"datacenter-filter.gross-last-batch": "Última bobina en stock (semana)",
	"datacenter-filter.heat-number": "Número de colada",
	"datacenter-filter.hts-code": "hts code",
	"datacenter-filter.incoterm2": "Incoterm 2",
	"datacenter-filter.internal-diameter": "Internal Diameter",
	"datacenter-filter.interpretation-delivery-date": "Interpretación fecha de envío",
	"datacenter-filter.invalid-number": "Número no válido",
	"datacenter-filter.item-sold-to-party": "Referencia posición del sold to",
	"datacenter-filter.last-name": "Apellido(s)",
	"datacenter-filter.length": "longitud",
	"datacenter-filter.loading-program-number": "Loading program number",
	"datacenter-filter.material-not-avilable": "Material not available",
	"datacenter-filter.materialAvailability": "Material Availability",
	"datacenter-filter.mill": "Fábrica",
	"datacenter-filter.mill-order-number": "Número de pedido de fábrica",
	"datacenter-filter.net-consignment": "Consign. (Neto,t)",
	"datacenter-filter.net-in-transit": "En tránsito (Neto, t)",
	"datacenter-filter.net-in-transit-details": "Detalles en tránsito (neto, t)",
	"datacenter-filter.net-ready-to-ship": "Listo para envío (Neto, t)",
	"datacenter-filter.nominal-gloss-bottom-side": "Brillo nominal lado inferior",
	"datacenter-filter.nominal-gloss-top-side": "Brillo nominal lado superior",
	"datacenter-filter.oil-reference": "Oil Reference",
	"datacenter-filter.order-created-by": "Order created by",
	"datacenter-filter.order-creator": "Order creator",
	"datacenter-filter.order-item-status": "Situación del pedido posición",
	"datacenter-filter.order-reason": "Motivo de la orden",
	"datacenter-filter.organic-structure-bottom-side": "Estructura recub.org.cara inf",
	"datacenter-filter.organic-structure-top-side": "Estructura recub.org.cara sup",
	"datacenter-filter.organization-city": "Ciudad",
	"datacenter-filter.organization-id": "Id. de la organización",
	"datacenter-filter.organization-name": "Nombre de la organización",
	"datacenter-filter.organization-role": "Rol",
	"datacenter-filter.organization-service": "Servicio de la organización",
	"datacenter-filter.organization-status": "Estado de la organización",
	"datacenter-filter.organization-suppliers": "Proveedores de la organización",
	"datacenter-filter.organization-type": "Tipo de organización",
	"datacenter-filter.package-serial-number": "Número de serie del paquete",
	"datacenter-filter.paint-marking-for-sh": "Paint Marking (for SH)",
	"datacenter-filter.pattern-for-sh": "Pattern (for SH)",
	"datacenter-filter.planned-shipment-date": "Fecha de carga prevista",
	"datacenter-filter.ponumber": "PO Number",
	"datacenter-filter.price-unit": "Price unit",
	"datacenter-filter.produced-length-dimension": "Actual length",
	"datacenter-filter.producedDimension": "Dim producida",
	"datacenter-filter.producedLength": "Longitud producida (m)",
	"datacenter-filter.producedThickness": "Espesor producido (mm)",
	"datacenter-filter.producedWidth": "Ancho producido (mm)",
	"datacenter-filter.product-category": "Familia de producto",
	"datacenter-filter.product-description": "Descripción del producto",
	"datacenter-filter.proposed-coating": "Proposed coating",
	"datacenter-filter.proposed-inner-diameter": "Proposed inner diameter",
	"datacenter-filter.proposed-length": "Proposed length",
	"datacenter-filter.proposed-oiling": "Proposed oiling",
	"datacenter-filter.proposed-outside-diameter": "Proposed outer diameter",
	"datacenter-filter.proposed-packing": "Proposed packaging",
	"datacenter-filter.proposed-quantity": "Proposed quantity",
	"datacenter-filter.proposed-steelgrade": "Proposed steel grade",
	"datacenter-filter.proposed-thickness": "Proposed thickness",
	"datacenter-filter.proposed-unit": "Proposed quantity unit",
	"datacenter-filter.proposed-weight": "Proposed sheet weight",
	"datacenter-filter.proposed-width": "Proposed width",
	"datacenter-filter.protection": "Protección",
	"datacenter-filter.proto-name": "Prototype name",
	"datacenter-filter.proto-status": "Prototype status",
	"datacenter-filter.provisional-firm-item": "Posición provisional/firme",
	"datacenter-filter.quantity-unit": "Quantity Unit",
	"datacenter-filter.rdd": "RDD",
	"datacenter-filter.rdd-date": "RDD",
	"datacenter-filter.rdd-week": "RDD (week)",
	"datacenter-filter.ready-to-ship-date": "Date available for dispatch",
	"datacenter-filter.readyForDispatch": "Ready for dispatch at PO receipt (week)",
	"datacenter-filter.req-desc": "Request Description",
	"datacenter-filter.sales-quarter": "Trimestre de venta",
	"datacenter-filter.service-level": "Nivel de servicio",
	"datacenter-filter.service-request": "Solicitud de servicio",
	"datacenter-filter.ship-to": "Ship to",
	"datacenter-filter.ship-to-address": "Delivery address",
	"datacenter-filter.shipment-reference-date": "Dispatch date",
	"datacenter-filter.shipping-date": "Shipping date",
	"datacenter-filter.shipping-week": "Expected shipping week",
	"datacenter-filter.sold-to": "Cliente",
	"datacenter-filter.special-stock-partner": "Stock partner",
	"datacenter-filter.spot-or-schedule": "Spot or schedule",
	"datacenter-filter.standard": "Standard",
	"datacenter-filter.standard-steel-grade": "Calidad del acero",
	"datacenter-filter.steeluser-order-number": "Referencia del pedido de comercio electrónico",
	"datacenter-filter.stockist": "Stockist",
	"datacenter-filter.supplier-rfq": "SupplierRfqNumber",
	"datacenter-filter.surface": "Superficie",
	"datacenter-filter.thickness": "Espesor (mm)",
	"datacenter-filter.total-thickness-coating-bottom": "Espesor total fondo recubrimiento inferior (G/M2)",
	"datacenter-filter.total-thickness-coating-top": "Espesor total recubrimiento superior (G/M2)",
	"datacenter-filter.trademark-name-bottom-side": "Nombre de marca parte inferior",
	"datacenter-filter.trademark-name-top-side": "Nombre de marca parte superior",
	"datacenter-filter.transport-mode": "Modo de transporte",
	"datacenter-filter.transport-mode-n1": "N-1 Modo de transporte",
	"datacenter-filter.transport-mode-n2": "N-2 Modo de transporte",
	"datacenter-filter.transport-reference": "Referencia del transporte",
	"datacenter-filter.transport-reference-n1": "N-1 Referencia del transporte",
	"datacenter-filter.transport-reference-n2": "N-2 Referencia del transporte",
	"datacenter-filter.transportRef": "Transport reference",
	"datacenter-filter.ultrasonic-testing": "Ultrasonic Testing",
	"datacenter-filter.user-creation-date": "Fecha de creación",
	"datacenter-filter.user-email": "Correo electrónico",
	"datacenter-filter.user-first-name": "Nombre",
	"datacenter-filter.user-id": "Id.",
	"datacenter-filter.user-last-name": "Apellido(s)",
	"datacenter-filter.user-organization-name": "Nombre de la organización",
	"datacenter-filter.user-role": "Rol",
	"datacenter-filter.user-status": "Estado",
	"datacenter-filter.users-city": "Ciudad",
	"datacenter-filter.users-countrycode": "Código de país",
	"datacenter-filter.width": "Ancho (mm)",
	"datacenter-filter.z-test-certificat": "Z-test Certificat",
	"datacenter-shipment.batch": "Lote",
	"datacenter-shipment.customer": "Cliente",
	"datacenter-shipment.customer-article-reference": "Referencia del artículo del cliente",
	"datacenter-shipment.customer-order-number": "Número de pedido del cliente",
	"datacenter-shipment.date-available-for-dispatch": "Fecha disponible para el envío",
	"datacenter-shipment.dispatch-advice-date": "Fecha del aviso de envío",
	"datacenter-shipment.dispatch-advice-number": "Número de aviso de envío",
	"datacenter-shipment.grade": "Grado de acero",
	"datacenter-shipment.gross-weight": "Peso bruto (t)",
	"datacenter-shipment.mill": "Fábrica",
	"datacenter-shipment.net-weight": "Peso neto (t)",
	"datacenter-shipment.ship-to": "Enviar a",
	"datacenter-shipment.shipment-quantity-gross": "Cantidad de envío (Bruta, t)",
	"datacenter-shipment.shipment-quantity-net": "Cantidad de envío (Neta, t)",
	"datacenter-shipment.supplier-order-number": "Número de pedido del proveedor",
	"datacenter-shipment.thickness": "Espesor (mm)",
	"datacenter-shipment.transport-mode": "Modo de transporte",
	"datacenter-shipment.transport-reference": "Referencia de transporte",
	"datacenter-shipment.width": "Ancho (mm)",
	"datacenter.add-columns": "Añadir columnas",
	"datacenter.all": "Todo",
	"datacenter.all-columns-added-to-grid": "Todas las columnas añadidas a la parrilla",
	"datacenter.all-data-center": "Todos los centros de datos",
	"datacenter.annealed": "Recocido",
	"datacenter.apply": "Aplicar",
	"datacenter.aqdb": "eAQDB",
	"datacenter.aqdb-view": "Data center: eAQDB",
	"datacenter.at-reshipper-gross": "En el transportista (Bruto, t)",
	"datacenter.at-reshipper-net": "En el transportista (Neto, t)",
	"datacenter.balanced-not-produced": "Cantidad no fabricada",
	"datacenter.batch": "Lotes",
	"datacenter.batches": "Centro de datos: Lotes",
	"datacenter.calloff": "Centro de datos: eCall-off",
	"datacenter.calloff-by-batch": "eCall-off por lotes",
	"datacenter.calloff-by-volume": "Ecall-off por volumen",
	"datacenter.cancel": "Cancelar",
	"datacenter.click-on-items-on-the-right": "Pulsar sobre los items de la derecha para añadir un filtro",
	"datacenter.cold-rolled": "Laminación en Frío",
	"datacenter.columns": "Columnas",
	"datacenter.commercial-documents": "Centro de datos: Documentos comerciales",
	"datacenter.composite": "Compuesto",
	"datacenter.create-new-view": "Crear una nueva vista",
	"datacenter.current-layout": "Diseño actual",
	"datacenter.customize-view": "Vista customizada",
	"datacenter.cutting-beveling": "Corte y recanteado",
	"datacenter.data-center": "Centro de datos",
	"datacenter.data-center-shipments": "Centro de datos: Envíos",
	"datacenter.default": "Por defecto",
	"datacenter.delete": "Eleminir",
	"datacenter.do-you-want-remove": "Quiere quitar la vista",
	"datacenter.document": "Documentos comerciales",
	"datacenter.documents": "Documentos",
	"datacenter.download-invoice": "Descargar factura",
	"datacenter.drag-and-drop-item-hint": "Arrastrar y soltar un item para agregar o eliminar una columna",
	"datacenter.drag-element-here-fixed": "Arrastrar aquí para añadir columnas fijas",
	"datacenter.drag-element-here-hide": "Arrastrar aquí para ocultar columnas en la parrilla",
	"datacenter.drag-element-here-scrollable": "Arrastrar aquí para añadir columnas deslizables",
	"datacenter.edit-view": "Editar vista",
	"datacenter.favorite.added": "View added to favorites",
	"datacenter.favorite.max-reached": "Maximum number of favorites reached. Remove an existing favorite before adding a new one.",
	"datacenter.favorite.removed": "View removed from favorites",
	"datacenter.favorite.update-error": "Unable to update favorite status",
	"datacenter.filter.clear": "Clear",
	"datacenter.filters": "Filtros",
	"datacenter.fixed-columns": "Columnas fijas",
	"datacenter.fixed-columns-scrollable": "Fixed columns (10 maximum)",
	"datacenter.graph.first-bar-label": "Menos de 30 días",
	"datacenter.graph.fourth-bar-label": "91 días o más",
	"datacenter.graph.second-bar-label": "31 - 60 días",
	"datacenter.graph.third-bar-label": "61 - 90 días",
	"datacenter.guarantee": "Centro de datos: Garantía",
	"datacenter.handed-over-to-planning": "Pasado a planificación",
	"datacenter.hot-rolled": "Laminación en caliente",
	"datacenter.in-transit-gross": "En tránsito (Bruto, t)",
	"datacenter.in-transit-to-customer-gross": "En tránsito hacia el cliente (bruto, t)",
	"datacenter.in-transit-to-customer-net": "En tránsito hacia el cliente (neto, t)",
	"datacenter.land-transit-gross": "Tránsito terrestre (Bruto, t)",
	"datacenter.land-transit-net": "Tránsito terrestre (Neto, t)",
	"datacenter.layout": "Diseño",
	"datacenter.layout-sorting": "Disposición y clasificación",
	"datacenter.metallic-coated": "Recubrimiento metálico",
	"datacenter.minimal-quantity-for-this-item-is": "La cantidad mínima para este artículo es",
	"datacenter.name-your-new-layout": "Nombre su nuevo diseño",
	"datacenter.nb-days-in-stock": "Número de días en stock",
	"datacenter.net-qty-delivered": "Entregado (Neto t)",
	"datacenter.net-qty-not-delivered": "Not Delivered (Net, t)",
	"datacenter.normalizing": "Homogeneización",
	"datacenter.offer": "Ofertas",
	"datacenter.offer.subcategory": "Subcategoría",
	"datacenter.offers": "Centro de datos: Líneas de oferta",
	"datacenter.on-vessel-gross": "Por barco/vía marítima (Bruto, t)",
	"datacenter.on-vessel-net": "Por barco/vía marítima (Neto, t)",
	"datacenter.open-needs": "Necesidades abiertas",
	"datacenter.or-save-as-a-new-view": "o guardar como una nueva vista",
	"datacenter.order": "Pedidos",
	"datacenter.ordered": "Pedido (t)",
	"datacenter.orders": "Centro de datos: Pedidos",
	"datacenter.organic-coated": "Recubrimiento orgánico",
	"datacenter.organization": "Organizaciones",
	"datacenter.organizations": "Centro de datos: Organizaciones",
	"datacenter.overseas-transit-gross": "Tránsito al extranjero (Bruto, t)",
	"datacenter.overseas-transit-net": "Tránsito al extranjero (Neto, t)",
	"datacenter.oxi-cutting": "Oxicorte",
	"datacenter.packing": "Embalaje",
	"datacenter.pickled": "Decapado",
	"datacenter.planned-casting": "Colada planeada (t)",
	"datacenter.prematerial-ordered": "Prematerial solicitado",
	"datacenter.prototypes": "Data center: Prototypes",
	"datacenter.qty-delivered": "Entregado (Bruto t)",
	"datacenter.qty-gross": "Bruto (t)",
	"datacenter.qty-in-production": "TEC (t)",
	"datacenter.qty-in-transit": "En tránsito (t)",
	"datacenter.qty-net": "Neto (t)",
	"datacenter.qty-not-delivered": "Not Delivered (Gross, t)",
	"datacenter.qty-ordered": "Ped (t)",
	"datacenter.qty-ready-to-ship": "Listo para envío (t)",
	"datacenter.quality": "Calidad",
	"datacenter.quality-control": "Control de calidad (toneladas)",
	"datacenter.quality-issues": "Centro de datos: Problemas de calidad",
	"datacenter.requested-quantity-is-greater-than-the-maximum-value": "La cantidad solicitada es superior al valor máximo",
	"datacenter.reset-all-filters": "Restablecer todos los filtros",
	"datacenter.result": "1 resultado",
	"datacenter.results": "{{value}} resultados",
	"datacenter.rolling-stand": "Soporte rodante",
	"datacenter.rts-gross": "RTS (Bruto, t)",
	"datacenter.save": "Guardar",
	"datacenter.save-as": "Guardar como",
	"datacenter.save-changes-in-the-view": "Guardar cambios en la vista",
	"datacenter.save-new-layout-as": "Guardar nuevo diseño como",
	"datacenter.save-new-view": "Guardar nueva vista",
	"datacenter.save-the-view": "Guardar la vista",
	"datacenter.schedule-business-order": "Programar pedidos del negocio",
	"datacenter.schedule-business-orders": "Centro de datos: Programar pedidos del negocio",
	"datacenter.scrollable-columns": "Columnas deslizables",
	"datacenter.select-a-view": "Seleccionar una vista",
	"datacenter.selected": "(valor) seleccionado",
	"datacenter.shipment": "Envíos",
	"datacenter.shot-blasting": "Granallado",
	"datacenter.skin-pass": "Skin-pass",
	"datacenter.slab": "Desbaste",
	"datacenter.slitting": "Cortar (Slitting)",
	"datacenter.sorting": "Clasificación",
	"datacenter.stock-blocked-gross": "Stock blocked (Gross, t)",
	"datacenter.stock-blocked-net": "Stock blocked (Net, t)",
	"datacenter.total": "Total",
	"datacenter.users": "Centro de datos: Usuarios",
	"datacenter.view-load-error": "No se puede cargar la vista del centro de datos",
	"datacenter.view-name": "Nombre de la vista",
	"datacenter.view-name.duplicate.error": "A view with the name '{{viewName}}' already exists. Please choose a different name.",
	"datacenter.view-name.error": "El nombre de la vista debe ser único",
	"datacenter.view-not-found": "View '{{viewName}}' not found",
	"datacenter.view.add-filters": "Añadir filtros",
	"datacenter.you-have-too-many-fixed-columns-to-add-a-new-one": "Tienes demasiadas columnas fijas para añadir una nueva",
	"datacenter.you-have-too-many-scroll-columns-to-add-a-new-one": "You have too many scrollable columns to add a new one",
	"datacenterview.Certificate": "Certificado",
	"datacenterview.DispatchAdvice": "Aviso del envío",
	"datacenterview.Invoice": "Factura",
	"datacenterview.OrderAcknowledgment": "Confirmación de pedido",
	"defect.CDCUS00A": "Dimensiones",
	"defect.CDCUS00B": "Peso",
	"defect.CDCUS00C": "Aspecto de la superficie",
	"defect.CDCUS00D": "Problema del revestimiento",
	"defect.CDCUS00E": "Soldaduras",
	"defect.CDCUS00F": "Óxido",
	"defect.CDCUS00G": "Lisura",
	"defect.CDCUS00H": "Propiedades mecánicas/análisis químico",
	"defect.CDCUS00I": "Problemas al procesar el metal",
	"defect.CDCUS00J": "Embalaje",
	"defect.CDCUS00K": "Tiempo de entrega",
	"defect.CDCUS00L": "Transporte",
	"defect.CDCUS00M": "Error de etiquetado",
	"defect.Z/CDCUS00A/0600": "Dimensiones",
	"defect.Z/CDCUS00B/0100": "Peso de la bobina",
	"defect.Z/CDCUS00B/0200": "Cantidad enviada (demasiada/menos, diferencia con la cantidad facturada...)",
	"defect.Z/CDCUS00C/0400": "Corrosión y oxidación",
	"defect.Z/CDCUS00C/1400": "Aspecto de la superficie",
	"defect.Z/CDCUS00D/0500": "Problema del recubrimiento",
	"defect.Z/CDCUS00E/0400": "Soldaduras",
	"defect.Z/CDCUS00F/0400": "Protección de la superficie (aceite, película, ...)",
	"defect.Z/CDCUS00G/0700": "Planitud",
	"defect.Z/CDCUS00H/0600": "Calidad (propiedades mecánicas, análisis químico, ...)",
	"defect.Z/CDCUS00I/0600": "Procesando",
	"defect.Z/CDCUS00J/0900": "Presentación (empaquetado, etiquetado, enrollado, ...)",
	"defect.Z/CDCUS00K/0300": "Tiempo de entrega",
	"defect.Z/CDCUS00L/0100": "Error de transporte (dirección, modo)",
	"defect.Z/CDCUS00L/0600": "Daños de transporte",
	"defect.Z/CDCUS00M/0300": "Documentación técnica (certificados, descripción del producto, conocimiento de embarque...)",
	"delete.draft": "Eliminar borrador",
	"delete.only-administrator": "No es posible eliminar este usuario porque no hay ningún otro usuario en la empresa.",
	"delivery-tracking.at-overseas-stock": "En stock overseas",
	"delivery-tracking.delivery-follow-up": "Seguimiento del envío",
	"delivery-tracking.in-land-transit": "Tránsito terrestre",
	"delivery-tracking.in-overseas-transit": "En tránsito overseas",
	"delivery-tracking.in-transit-to-customer": "En tránsito hacia el cliente",
	"delivery-tracking.order-and-delivery-overview": "Vista general de pedidos y entregas",
	"delivery-tracking.stock-per-mill": "Existencias por fábrica",
	"delivery-tracking.to-reshipper-in-land-transit-to-warehouse": "Al re-expedidor/En tránsito terrestre/En el almacen",
	"delivery-tracking.total": "Total",
	"delivery-tracking.view-details": "Ver detalles",
	"delivery.status.late": "Tarde",
	"delivery.status.on-customer-time": "A la hora del cliente",
	"delivery.status.on-supplier-time": "A la hora del proveedor",
	"delivery.status.on-time": "A tiempo",
	"dialog-upload-file": "Please upload a file",
	"dialog.all-column-added-to-grid": "Todas las columnas añadidas a la cuadrícula",
	"dialog.apply": "Aplicar",
	"dialog.customize.view.title": "Selecciona las columnas con un arrastrar y soltar",
	"dialog.delete.description": "¿Estás seguro/a de que deseas eliminar a este usuario?",
	"dialog.delete.title": "Eliminar usuario",
	"dialog.drag-elements-here-hide": "Arrastra el elemento para ocultar columnas en la cuadrícula",
	"dialog.drag-elements-here-scrollable": "Arrastra aquí para añadir columnas al diseño",
	"dialog.loose-data-message": "Esta acción eliminará todos tus datos. ¿Quieres continuar?",
	"dialog.select.batch": "Seleccionar lote",
	"doc-ce-subtype.01": "2.1: Declaración de cumplimiento con el pedido",
	"doc-ce-subtype.02": "2.1: Declaration of compliance with the order",
	"doc-ce-subtype.17": "3.1: Certificado de inspección 3.1",
	"doc-ce-subtype.51": "2.2: Informe de pruebas",
	"doc-ce-subtype.52": "3.2: Certificado de inspección 3.2",
	"doc-ce-subtype.car": "Chemical Analysis Report",
	"doc-ce-subtype.cconf": "Certificado de cumplimiento",
	"doc-ce-subtype.ccpu": "Certificado de pruebas",
	"doc-ce-subtype.cem": "Marcado CE",
	"doc-ce-subtype.ceran": "Certificado de pruebas 2.2 Análisis químico",
	"doc-ce-subtype.cerre": "Certificado de recepción",
	"doc-ce-subtype.cerus": "Certificado de recepción",
	"doc-ce-subtype.cinsp": "Certificado de inspección 3.2",
	"doc-ce-subtype.ctl": "Informe de inspección",
	"doc-ce-subtype.fcp": "Ficha de características del producto",
	"doc-ce-subtype.ohsas": "Informe de seguridad",
	"doc-in-subtype.AVOIR": "Nota de crédito",
	"doc-in-subtype.DEBIT": "Carta de débito",
	"doc-in-subtype.FACTU": "Factura",
	"doc-oa-subtype.N": "Editado",
	"doc-oa-subtype.O": "Original",
	"doc-xcarb-subtype.a": "Green Steel Certificate",
	"doc-xcarb-subtype.b": "Recycled and renewably produced",
	"doc-xcarb-subtype.c": "EcoSheetPilePlus",
	"doc-xcarb-subtype.d": "Steel Certificate",
	"doc-xcarb-subtype.e": "Steel certificate (factor:0.7)",
	"doc-xcarb-subtype.f": "Steel certificate (factor:1.0)",
	"doc-xcarb-subtype.g": "Steel certificate Integral",
	"doc-xcarb.amount": "Amount",
	"doc-xcarb.endquarter": "End quarter",
	"doc-xcarb.rrpDownloadLink": "RRP link",
	"doc-xcarb.rrpType": "RRP type",
	"document-card.data-not-found": "Document data not found",
	"download-detailed-report": "Download detailed report",
	"download.pdf-files": "Descargar archivos PDF",
	"draft.creationdate": "Fecha de creación",
	"draft.deleted.successfully": "Tu borrador de oferta ha sido eliminado correctamente",
	"draft.lastupdate": "Última actualización",
	"draft.selected.product": "Producto seleccionado",
	"draft.total.tons": "Toneladas totales",
	"draft.value": "BORRADOR",
	"draftoffer.list": "borrador de lista",
	"draftorder.list": "borrador de lista",
	"drafts.all.drafts": "Todos los borradores",
	"drafts.has.been.deleted": "El borrador ha sido eliminado",
	"drafts.my.drafts": "Mis borradores",
	"drafts.no.draft": "No se han encontrado borradores",
	"drafts.saved": "borradores guardados",
	"drafts.search.drafts": "Buscar en borradores",
	"drafts.sort.by.modification": "Ordenar por modificación",
	"drafts.sort.by.reference": "Ordenar por referencia",
	"drag.and.drop.files": "Arrastrar y soltar",
	"ecall-comment-grid": "Comment",
	"ecall-off-batch-cancellation-date": "Cancelled Date",
	"ecall-off-call-creater": "eCall-off creator",
	"ecall-off-card-gross-quantity": "Gross Quantity",
	"ecall-off-card-net-quantity": "Net Quantity",
	"ecall-off-creation-date": "Creation date",
	"ecall-off-information-box": "eCall-off information",
	"ecall-off.all-batches": "Todos los lotes",
	"ecall-off.apply-for-all": "Aplicar para todos",
	"ecall-off.batch": "lote",
	"ecall-off.batches": "lotes",
	"ecall-off.call-off": "Cancelación",
	"ecall-off.call-off-by-batch": "Cancelación por lotes",
	"ecall-off.call-off-by-volume": "Cancelación por volumen",
	"ecall-off.call-off-date": "Fecha ECall-off  ",
	"ecall-off.call-off-follow-up": "Seguimiento de cancelación",
	"ecall-off.call-off-header-information": "Información de encabezado de cancelación",
	"ecall-off.call-off-request": "Solicitud de cancelación",
	"ecall-off.callable-weight": "Material total disponible (To)",
	"ecall-off.called-batches": "Lotes llamados",
	"ecall-off.called-order-items": "Elementos de pedidos llamados",
	"ecall-off.called-volume": "Volumen llamado (To)",
	"ecall-off.canceled": "Cancelled date",
	"ecall-off.change-mills": "Cambiar fábricas",
	"ecall-off.choose-batches": "Elige los lotes que quieras cancelar",
	"ecall-off.choose-order-items": "Elige los elementos de pedidos que quieras cancelar",
	"ecall-off.closed-or-called": "Called",
	"ecall-off.comment_instruction": "Please fill in this field only if the eCall-off does not follow the standard process. Kindly, do not include messages such as “urgent”, “asap”, “thanks”, or similar. This field is intended only for exceptions to the normal flow.",
	"ecall-off.comment_placeholder": "This field should only be filled in if the eCall-off deviates from the standard flow and the information provided is new and not yet recorded elsewhere.",
	"ecall-off.copy-to": "Copia a",
	"ecall-off.customer-call-off-reference": "Referencia de cancelación del cliente",
	"ecall-off.do-you-really-want-to-change-mills": "¿De verdad quieres cambiar las fábricas?",
	"ecall-off.ecall-card": "Tarjeta de llamadas electrónicas",
	"ecall-off.exception": "Exception remark",
	"ecall-off.followup": "You will be able to view it in your My eCall-offs.",
	"ecall-off.information-entry": "Entrada de información de cancelación",
	"ecall-off.last-call-off-demand": "Última solicitud de cancelación",
	"ecall-off.material-picking": "Recogida de material",
	"ecall-off.max": "Máx. {{value}}",
	"ecall-off.mill-section": "Selección de fábrica",
	"ecall-off.my-ecalls": "Mis llamadas electrónicas",
	"ecall-off.no-batches-found": "No se han encontrado lotes",
	"ecall-off.no-mills": "No hay fábricas con lotes llamables",
	"ecall-off.no-selected-batches": "no hay lotes seleccionados",
	"ecall-off.open-or-callable": "Callable",
	"ecall-off.order-items": "elementos de pedidos",
	"ecall-off.personnalize-your-call-off-informations": "Personalizar tu información de cancelaciones",
	"ecall-off.rdd-mode": "Modo RDDC",
	"ecall-off.ready-to-call": "Tus {{objects}} listos para llamar",
	"ecall-off.requested-date": "Fecha solicitada",
	"ecall-off.requested-date-weekend-warning": "The selected requested delivery date falls on a weekend",
	"ecall-off.requested-ship-to": "Requested Ship To",
	"ecall-off.required": "necesario",
	"ecall-off.see-card": "Ver tarjeta",
	"ecall-off.select-a-mill": "Selecciona una fábrica para ver tu material listo para enviar",
	"ecall-off.select-your-mill": "Selecciona tu fábrica",
	"ecall-off.selected": "{{value}} seleccionado",
	"ecall-off.selected-batches": "{{value}} lotes seleccionados",
	"ecall-off.selected-batches-only": "Solo lotes seleccionados",
	"ecall-off.selected-only": "Solo seleccionados",
	"ecall-off.selection-will-be-rest": "La selección se restablecerá",
	"ecall-off.separate-email-addresses": "Separa las direcciones de correo electrónico con <<;>> (punto y coma)",
	"ecall-off.ship-to": "Ship To",
	"ecall-off.start-a-new-call-off": "INICIAR UNA NUEVA CANCELACIÓN",
	"ecall-off.submit-call-off": "Enviar tu solicitud de cancelación",
	"ecall-off.submitted.successfully": "Your eCall-off {{value}} has been submitted successfully.",
	"ecall-off.summary": "Resumen de cancelaciones",
	"ecall-off.supplier-call-off-reference": "Supplier eCall-off reference",
	"ecall-off.the": "El",
	"ecall-off.tons": "Toneladas",
	"ecall-off.total-called-weight": "Peso total cancelado",
	"ecall-off.total-material-request": "Solicitud de material total",
	"ecall-off.type-your-comment": "Escribe tu comentario",
	"ecall-off.type-your-exception": "Type your exception remark",
	"ecall-off.unloading-reference": "Referencia de descarga",
	"ecall-off.view-batch-card": "Ver tarjeta de lote",
	"ecall-off.your-batches-ready-to-call": "Tus lotes listos para ser llamados",
	"ecall-requested-deliverydate-from-grid": "Requested date from",
	"ecall-requested-deliverydate-to-grid": "Requested date to",
	"ecall-total-volume-called": "Total volume called",
	"ecall.batch.callCreator": "eCall-off creator",
	"ecall.exct-date-error": "You cannot choose exact date for the selected batches",
	"ecall.row.creation.date": "eCall-off creation date",
	"ecall.searchfield.extendable": "Búsqueda rápida...",
	"edit.draft": "Editar borradores",
	"efeasibility-disclaimer": "While care has been taken regarding the available information about quality or usability of our materials, it only serves as a description. All notices, advices, recommendations, calculations and, more generally, any information you have access from Steel User are given for your guidance, within the framework of a best effort undertaking, and on the basis of our experience and the state of our last knowledge. However, any industrial application/order/implementation based on such content shall have to be validated by your usual contact at ArcelorMittal Group.",
	"efeasibility-disclaimer.end": "ArcelorMittal Group accepts no responsibility or liability for any errors or information which is found to be misleading.  The use of the information contained herein is at the user’s risk and no warranty is implied or expressed by ArcelorMittal Group with respect to the use of the information.\n",
	"efeasibility.excel.file.name": "Feasibility",
	"efeasibility.excel.template": "Get excel template",
	"efeasibility.template.error": "Please upload a file which follows the template provided by SteelUser application",
	"efeasibility.template.product.category.validation": "Product category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.product.sub.category.validation": "Product sub category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.soldtoname.validation": "Customer name is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.standard.steelgrade.validation": "Standard steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.steelgrade.validation": "Steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"elink.add.attachment": "Agregar archivo adjunto",
	"elink.category": "Categoría",
	"elink.comment": "Comentario",
	"elink.comment-is-required": "Se requiere comentario",
	"elink.contact-mill": "Contacto fábrica",
	"elink.copy-to": "Copia a",
	"elink.data-automatically-sent-with-the-mail": "Datos enviados automáticamente con el correo",
	"elink.delete": "Eliminar",
	"elink.dimension": "Dimensiones (mm)",
	"elink.from": "Desde",
	"elink.invalid-email-format": "Formato de dirección de correo no válido",
	"elink.message": "Mensaje",
	"elink.send": "Enviar",
	"elink.subject": "Asunto",
	"email-message": "Email has been sent to confirm your new mail address",
	"end.date": "Fecha de finalización",
	"eoffer-From.month": "Del mes",
	"eoffer-Period.label": "Periodo",
	"eoffer-Period.type": "Tipo de período",
	"eoffer-Period.type.custom": "Para un intervalo personalizado",
	"eoffer-Period.type.month": "Para un intervalo de un mes",
	"eoffer-Period.type.quarter": "Para un intervalo de un trimestre",
	"eoffer-Period.type.semester": "Para un intervalo de un semestre",
	"eoffer-Period.type.year": "Para un intervalo de un año",
	"eoffer-Quarter": "Trimestre",
	"eoffer-Semester": "Semestre",
	"eoffer-To.month": "Al mes",
	"eoffer-selected.period": "Período seleccionado",
	"eoffer.Choose.the.split.of.quantities.by": "Elija la división de cantidades por",
	"eoffer.accepted": "Aceptado",
	"eoffer.action.default": "Por defecto",
	"eoffer.action.delete": "Eliminar",
	"eoffer.action.duplicate": "Duplicado",
	"eoffer.action.new": "Nuevo",
	"eoffer.action.new.request": "Solicitud",
	"eoffer.action.new.request.for-a-new": "para una nueva oferta",
	"eoffer.additional.fields": "Características adicionales",
	"eoffer.assistant": "Contacto comercial (assistant)",
	"eoffer.available.fields": "Características disponibles",
	"eoffer.cancel": "Cancelar",
	"eoffer.cart.finalise": "Finalice su carrito",
	"eoffer.cart.input.request": "Introduzca la cantidad requerida, la fecha de entrega y otra información",
	"eoffer.cart.volume.request": "Volumen solicitado",
	"eoffer.choose.split.quantities.error": "Por favor, elija la división de cantidades",
	"eoffer.choose.split.quantity.error": "Elija la división de cantidades",
	"eoffer.cockpit": "Cabina de oferta electrónica",
	"eoffer.comment": "Comentario",
	"eoffer.comment.product.is": "Deja un comentario para este producto",
	"eoffer.confirm.thanks": "Muchas gracias, hemos recibido su solicitud.",
	"eoffer.continue": "Continuar",
	"eoffer.continue.draft": "Continuar este borrador",
	"eoffer.create.enduser": "Usuario final",
	"eoffer.currency": "Divisa",
	"eoffer.current.step": "Paso actual",
	"eoffer.customer": "Cliente",
	"eoffer.datacenter.offerLines": "Centro de datos: Líneas de oferta",
	"eoffer.delivery.date": "Fecha de entrega de la interpretación",
	"eoffer.dialog.clear.products": "Si cambia el Cliente o la Dirección de entrega o el Usuario final, los productos del carrito se perderán. ¿Quieres continuar?",
	"eoffer.dialog.month": "Mes",
	"eoffer.dialog.monthweek": "Mes o semana ",
	"eoffer.dialog.offer.remove.product": "Eliminará el producto seleccionado, ¿desea continuar?",
	"eoffer.dialog.offer.submission.error": "Error al enviar la oferta",
	"eoffer.dialog.pdm": "Fábrica de entrega preferida",
	"eoffer.dialog.period": "Seleccionar su pedido",
	"eoffer.dialog.quantity": "Cantidad",
	"eoffer.dialog.requested.delivery.time": "Seleccione su hora de entrega solicitada",
	"eoffer.dialog.reset.requested.delivery.time": "Modificará el período y restablecerá los tiempos de entrega solicitados, ¿desea continuar?",
	"eoffer.dialog.week": "Semana",
	"eoffer.dialog.year": "Año",
	"eoffer.dimension.mm": "Dimensiones (en mm)",
	"eoffer.draft": "Borrador",
	"eoffer.draft.edit.message.line": "para presentarse a ArcelorMittal o eliminarse.",
	"eoffer.draft.edit.message.text": "Puede editarse más tarde en",
	"eoffer.draft.list.link": "tu borrador de lista",
	"eoffer.draft.saved.successfully": "Su solicitud de oferta se ha guardado correctamente como borrador",
	"eoffer.drafts": "Borrador",
	"eoffer.enduser": "Usuario final",
	"eoffer.entry": "Ofrecer entrada",
	"eoffer.error.loading": "No ha sido posible cargar los valores de la oferta",
	"eoffer.error.noenduser": "Vendido a {{value}} sin usuario final",
	"eoffer.error.noshipto": "Vendido a {{value}} sin enviado a",
	"eoffer.error.noshiptoenduser": "Vendido a {{value}} sin enviado a y usuario final",
	"eoffer.error.nosoldto": "No se ha encontrado el vendido a",
	"eoffer.feasibility": "Viabilidad",
	"eoffer.feasibility.no": "Rechazado",
	"eoffer.feasibility.pending": "Pendiente",
	"eoffer.feasibility.yes": "OK",
	"eoffer.field": "Característica",
	"eoffer.form": "Forma",
	"eoffer.header.commercial.contacts": "CONTACTOS COMERCIALES",
	"eoffer.header.commitment.period": "Período de compromiso:",
	"eoffer.header.custOffNumber": "Referencia de la oferta del cliente",
	"eoffer.header.customer": "cliente",
	"eoffer.header.entity.information": "Información sobre entidades",
	"eoffer.header.last.update.date": "Fecha de la última actualización",
	"eoffer.header.offer.name": "Nombre de la oferta",
	"eoffer.header.offer.validity.date": "Fecha de validez de la oferta:",
	"eoffer.header.suppOffNumber": "Referencia de oferta del proveedor",
	"eoffer.header.technical.contacts": "CONTACTOS TÉCNICOS",
	"eoffer.header.terms.information": "Información sobre términos",
	"eoffer.header.total": "Total",
	"eoffer.home": "Oferta electrónica",
	"eoffer.home.active": "Ofertas",
	"eoffer.home.cockpit": "Mi cabina de oferta electrónica",
	"eoffer.home.request": "Nuevo",
	"eoffer.home.tool": "Solicitar una oferta",
	"eoffer.idd.not.found": "No se han encontrado los parámetros de IDD",
	"eoffer.in.calculation": "En cálculo",
	"eoffer.incot.not.found": "No se han encontrado los parámetros de Incoterm",
	"eoffer.incoterms": "Incoterms",
	"eoffer.interpretation.delivery.date": "Fecha de entrega de la interpretación",
	"eoffer.mandatory.currency.reference": "La divisa es obligatoria",
	"eoffer.mandatory.delivery.address": "La dirección de entrega es obligatoria",
	"eoffer.mandatory.enduser.reference": "El usuario final es obligatorio",
	"eoffer.mandatory.idd.reference": "IDD es obligatorio",
	"eoffer.mandatory.incot.reference": "Incoterm es obligatorio",
	"eoffer.mandatory.priceUnit.reference": "La unidad de precio es obligatoria",
	"eoffer.mandatory.quantity": "La cantidad es obligatoria",
	"eoffer.mandatory.requestedDeliveryTime": "RDT es obligatorio",
	"eoffer.mandatory.rfq.reference": "La referencia RFQ es obligatoria",
	"eoffer.mandatory.soldTo.reference": "Vendido a es obligatorio",
	"eoffer.mandatory.tmode.reference": "El modo de transporte es obligatorio",
	"eoffer.merge.warning": "Algunos artículos se han fusionado. Se han detectado como productos idénticos.",
	"eoffer.message.offer.not.saved": "No ha sido posible guardar la oferta",
	"eoffer.message.offer.not.submit": "No se ha podido enviar la oferta",
	"eoffer.message.offer.saved": "Oferta guardada",
	"eoffer.mill": "Fábrica",
	"eoffer.mill.supplier.choice": "A elección del proveedor",
	"eoffer.minimum.quantity": "La cantidad mínima requerida es 1",
	"eoffer.next": "Siguiente",
	"eoffer.offer": "Oferta",
	"eoffer.offer.and.order": "Descripción general de la oferta",
	"eoffer.offer.card": "Tarjeta de oferta",
	"eoffer.offer.dashboard.not.retrived": "No se han podido recuperar los datos del panel de ofertas",
	"eoffer.offer.plural": "Ofertas",
	"eoffer.offer.request": "Solicitud de ofertas",
	"eoffer.offer.terms": "Seleccione los términos de su solicitud de oferta",
	"eoffer.offerLine": "Línea de oferta",
	"eoffer.offerLine.plural": "Líneas de oferta",
	"eoffer.offers.draft": "Ofertas - Borrador",
	"eoffer.paymentTerms": "Condiciones de pago",
	"eoffer.pc.label.weightDiameterMax": "Máx",
	"eoffer.pc.label.weightDiameterMin": "Mín",
	"eoffer.pc.label.weightDiameterUnit": "Unidad",
	"eoffer.period": "Período",
	"eoffer.period.end": "Período (final)",
	"eoffer.period.in.month.value": "{{value}} mes",
	"eoffer.period.month": "Período (en meses)",
	"eoffer.period.orderBook": "Período para el libro de pedidos históricos",
	"eoffer.period.quarter.initial.letter": "Q",
	"eoffer.period.selection.needed": "Selección necesaria",
	"eoffer.period.semester.initial.letter": "H",
	"eoffer.period.start": "Período (inicio)",
	"eoffer.prefered.delivery.mill": "Fábrica de entrega preferida",
	"eoffer.previous": "Previo",
	"eoffer.price": "Precio",
	"eoffer.pricing.unit": "Unidad de precio",
	"eoffer.product": "Producto",
	"eoffer.product.card": "Información del producto",
	"eoffer.product.family": "Familia de productos ",
	"eoffer.product.family.infos.text": "Selecciona un cliente, una dirección de entrega y un usuario final para acceder a la lista de productos",
	"eoffer.product.family.plural": "Familias de productos",
	"eoffer.product.load.content": "No ha sido posible cargar el contenido del producto",
	"eoffer.product.not.found": "La descripción del pedido no está disponible",
	"eoffer.product.plural": "Productos",
	"eoffer.quantity": "Cantidad",
	"eoffer.quantity.error": "Introduce una cantidad válida",
	"eoffer.quantity.ton": "Cantidad (toneladas)",
	"eoffer.quit.with.save": "Guardar y salir",
	"eoffer.quit.without.save": "Salir sin guardar",
	"eoffer.referenceAm": "Referencia AM",
	"eoffer.refresh": "Actualizar",
	"eoffer.remove.product": "Continuar y eliminar el producto seleccionado",
	"eoffer.request.new.offer": "Solicitar una nueva oferta",
	"eoffer.request.new.offer.from.draft": "Solicitar una nueva oferta de este",
	"eoffer.requested": "Solicitado",
	"eoffer.requested.delivery.time": "Hora de entrega solicitada",
	"eoffer.reset.requested.delivery.time": "Continuar y restablecer los tiempos de entrega",
	"eoffer.review.selections.and.submit": "Revise sus selecciones y envíe",
	"eoffer.rfq.id": "Su único RFQ ID es",
	"eoffer.rfq.reference": "Su referencia RFQ",
	"eoffer.save": "Guardar",
	"eoffer.save.offer.draft": "Guardar solicitud de oferta como borrador",
	"eoffer.save.offer.question": "Salir del asistente sin guardar la oferta, ¿desea continuar?",
	"eoffer.searchfield.extendable": "Búsqueda rápida",
	"eoffer.select.period.info": "Haga clic a continuación para seleccionar un período desde 1 mes hasta 1 año natural",
	"eoffer.select.price": "Seleccione el período de compromiso de precio para esta oferta",
	"eoffer.selector": "Selector",
	"eoffer.set.entities": "Establecer entidades para esta oferta",
	"eoffer.shipto": "Dirección de entrega",
	"eoffer.simulation.shipto.enduser.error": "Error debido a la imposición de otro [destinatario/usuario final] tras la simulación.",
	"eoffer.soldto": "Dirección de entrega",
	"eoffer.status": "Estado",
	"eoffer.status.accepted": "Aceptado",
	"eoffer.status.accepted.plural": "Aceptado",
	"eoffer.status.canceled": "Cancelado",
	"eoffer.status.canceled.plural": "Cancelado",
	"eoffer.status.draft": "Borrador",
	"eoffer.status.draft.plural": "Borrador",
	"eoffer.status.offered": "Ofrecido",
	"eoffer.status.offered.plural": "Ofrecido",
	"eoffer.status.rejected": "Rechazado",
	"eoffer.status.requested": "Solicitado",
	"eoffer.status.requested.plural": "Solicitado",
	"eoffer.steelGrade": "Grado del acero",
	"eoffer.subcategory": "Subcategoría",
	"eoffer.submission.feedback": "Puede realizar un seguimiento del estado de su RFQ a través de su panel de solicitud de oferta",
	"eoffer.submit": "Enviar",
	"eoffer.supplier.offer.number": "Referencia de oferta del proveedor",
	"eoffer.table.customer": "Cliente",
	"eoffer.table.enduser": "Usuario final",
	"eoffer.table.header.colTopSide": "Lado de color superior",
	"eoffer.table.header.custMatRef": "Referencia del artículo del cliente",
	"eoffer.table.header.custOffRef": "Referencia de la oferta del cliente",
	"eoffer.table.header.delivery.mill": "Fábrica de entrega preferida",
	"eoffer.table.header.dim": "Dim (mm)",
	"eoffer.table.header.dimension": "Dimensiones (en mm)",
	"eoffer.table.header.dimensions": "Dimensiones",
	"eoffer.table.header.feasibility": "Viabilidad",
	"eoffer.table.header.last.update": "Fecha de la última actualización",
	"eoffer.table.header.orderCount": "Artículos",
	"eoffer.table.header.period": "Período",
	"eoffer.table.header.price": "Precio",
	"eoffer.table.header.qttOrdered": "Cantidad",
	"eoffer.table.header.quantity": "Cantidad (toneladas)",
	"eoffer.table.header.rfqRef": "Referencia RFQ",
	"eoffer.table.header.standsteelGrade": "Grado de acero estándar",
	"eoffer.table.header.status": "Estado",
	"eoffer.table.header.steelGrade": "Grado",
	"eoffer.table.item.number": "Número de artículo",
	"eoffer.table.morw": "Mes o semana",
	"eoffer.table.price.unit": "Precio (unidad)",
	"eoffer.table.price.value": "Precio (valor)",
	"eoffer.table.quantity.unit": "Cantidad (unidad)",
	"eoffer.table.quantity.value": "Cantidad (valor)",
	"eoffer.table.shipto": "Enviar a",
	"eoffer.title.my.offers": "Mis ofertas",
	"eoffer.title.productlist.filter": "Elija el producto que desea solicitar en",
	"eoffer.title.section.coilWeightInPercent": "Peso de la bobina en %",
	"eoffer.title.section.dimensionUnit": "Unidad de medida",
	"eoffer.title.section.length": "Longitud",
	"eoffer.title.section.organicCoating": "Revestimiento ecológico",
	"eoffer.tonnes": "Toneladas",
	"eoffer.total.quantity.for.period.draft": "Cantidad total del período",
	"eoffer.track.status": "Puede seguir el estado de su RFQ a través de su",
	"eoffer.transport.mode": "Modo de transporte",
	"eoffer.validityDate": "Validez",
	"eoffer.weightAndInvoicing": "Peso y facturas",
	"eoffer.wizard.cart": "Carrito",
	"eoffer.wizard.delivery.address": "Dirección de entrega",
	"eoffer.wizard.end": "Revisar-enviar",
	"eoffer.wizard.error.products.families": "No se han encontrado las familias de productos",
	"eoffer.wizard.header.entity.information": "Información sobre entidades",
	"eoffer.wizard.header.terms.information": "Información sobre términos",
	"eoffer.wizard.parameters.error": "No ha sido posible cargar los parámetros de la oferta",
	"eoffer.wizard.period.error": "La fecha se ha restablecido",
	"eoffer.wizard.period.selection.error": "Por favor, selecciona una fecha en el futuro y válida para el periodo seleccionado",
	"eoffer.wizard.request": "Solicitar una oferta",
	"eoffer.wizard.specs": "Especificaciones de productos",
	"eoffer.wizard.step.status": "Paso {{step}} de 4",
	"eoffer.wizard.submit": "Envíe su solicitud de oferta",
	"eoffer.wizard.table.header.quantity": "Cantidad (t)",
	"eoffer.wizard.terms": "Términos de la oferta",
	"eorder.action.next": "Siguiente",
	"eorder.action.save.draft": "Guardar el pedido como borrador",
	"eorder.add.item.confirm.action": "¿Desea confirmar esta acción?",
	"eorder.add.item.confirm.change": "¿Desea confirmar este cambio?",
	"eorder.add.item.different.family.warning": "El artículo seleccionado no es de la misma familia que el que está en la cesta. Vaciaremos la cesta antes de añadir el/los nuevo(s) solicitado(s).",
	"eorder.add.item.different.form.warning": "El artículo(s) seleccionado(s) no es(son) de la misma forma que el(los) que está(n) en la cesta. Vaciaremos la cesta antes de añadir el/los nuevo(s) solicitado(s).",
	"eorder.add.item.empty.customer.warning": "El campo del cliente está vacío. No es posible añadir ningún artículo a la cesta.",
	"eorder.add.item.limit.exeeds.warning": "Al añadir [X] artículo(s) al carrito, el pedido será demasiado grande para el proceso actual (>100 artículos). Por favor, reduce el contenido del carrito o el número de artículo(s) a añadir e inténtalo de nuevo.",
	"eorder.add.item.success": "[X] artículo(s) añadido(s) correctamente a la cesta",
	"eorder.confirm.message": "Confirmar",
	"eorder.create.order.title": "Datos del pedido",
	"eorder.customer.change.warning": "Si cambia el campo Cliente, se borrará el carro actual. Un mismo pedido no puede mezclar artículos de diferentes clientes.",
	"eorder.draft.deleted.successfully": "Tu borrador de pedido ha sido eliminado correctamente",
	"eorder.draft.edit.message.text": "Podrás editarlo en",
	"eorder.draft.last.update.date": "Fecha de la última actualización",
	"eorder.draft.list.link": "tu borrador de lista.",
	"eorder.draft.norequest": "No hay borrador de solicitud",
	"eorder.draft.order-card.edit": "Editar este borrador",
	"eorder.draft.order-card.no-item.text": "Ningún borrador",
	"eorder.draft.order-card.placed.text": "Borrador de detalles del pedido",
	"eorder.draft.order-card.title": "Borrador de detalles del pedido",
	"eorder.draft.product.family": "Familia",
	"eorder.draft.product.number": "Número de productos",
	"eorder.draft.requested.quantity": "Cantidad solicitada",
	"eorder.draft.saved.successfully": "Tu borrador se ha guardado.",
	"eorder.fixed-columns": "Fixed columns",
	"eorder.grid.header.view.label": "View",
	"eorder.line.select.family.product": "To add an item into cart, choose the number of copy of a product, and click on the corresponding button Add to cart",
	"eorder.mandatory.currency": "La divisa es obligatoria",
	"eorder.mandatory.end.user": "El usuario final es obligatorio",
	"eorder.mandatory.idd": "Fecha de entrega de la interpretación es obligatoria",
	"eorder.mandatory.pricingUnit": "La unidad de precio es obligatoria",
	"eorder.mandatory.shipTo.reference": "El envío es obligatorio",
	"eorder.message.order.not.saved": "No ha sido posible guardar el pedido",
	"eorder.no.product.family": "No products found for the selected customer",
	"eorder.order": "Solicitud de pedido",
	"eorder.order.creation": "Creación de pedidos",
	"eorder.orders.request": "Solicitud de pedidos",
	"eorder.product.color.bottom": "Colour (Bottom)",
	"eorder.product.colour.top": "Colour (Top)",
	"eorder.product.custmaterialnum": "Customer Material Number",
	"eorder.product.data.commercial.steelgrade.id": "IdGradoAceroComercial",
	"eorder.product.data.customer.article": "artículoCliente",
	"eorder.product.dimension": "Dimensiones",
	"eorder.product.empty.row": "No active product linked to this template",
	"eorder.product.family.infos.title": "Selecciona un cliente, una dirección de entrega y un usuario final para acceder a la lista de productos",
	"eorder.product.fc.products.label": "Fully configured products",
	"eorder.product.grid.note.fc": "[Y] product(s).",
	"eorder.product.grid.note.nfc": "[X] template(s) and [Y] product(s). A template is an item with empty variables to let you create a new product",
	"eorder.product.lastused": "Last used",
	"eorder.product.lastused.default": "Nunca",
	"eorder.product.metalliccoating": "Metallic Coating",
	"eorder.product.organiccoating.datasheet.top": "Organic Coating Data Sheet (Top)",
	"eorder.product.organicdatasheet.bottom": "Organic Coating Data Sheet (Bottom)",
	"eorder.product.removablefilm": "Removable Protective Film",
	"eorder.product.steelgrade": "Steel Grade",
	"eorder.product.surfaceaspect": "Surface Aspect",
	"eorder.product.template.add.to.cart": "Add as empty product to cart",
	"eorder.product.type.fc": "Catalog product",
	"eorder.product.type.fm": "To be configured (with default values)",
	"eorder.product.type.nfc": "To be configured",
	"eorder.product.variables": "variables(s)",
	"eorder.product.variables.title": "Variables on this template:",
	"eorder.save.draft.confirmation": "¿Desea guardar [X] como borrador?",
	"eorder.save.draft.error.message": "Lo sentimos, se ha producido un error durante el proceso de guardado del borrador de su pedido. Inténtelo más tarde o envíe un mensaje a su contacto de AM.",
	"eorder.save.draft.success.message": "Se ha guardado correctamente un borrador de su solicitud de pedido.",
	"eorder.select.product.spec": "Products list",
	"eorder.submit.error.msg.bad.data": "Datos erróneos en la solicitud.",
	"eorder.submit.error.msg.rqd.data.missing": "Faltan datos obligatorios",
	"eorder.submit.order.success.follow.up.link": "SEGUIMIENTO DEL PEDIDO Y LA ENTREGA.",
	"eorder.submit.order.success.follow.up.text": "Puedes seguir la evolución de su estado en tu",
	"eorder.submit.order.success.text1": "Tu solicitud de pedido",
	"eorder.submit.order.success.text2": "ha sido procesada.",
	"eorder.wizard.header.customer": "El cliente es obligatorio",
	"eorder.wizard.header.customer-order-number": "Número de pedido del cliente",
	"eorder.wizard.header.customer-order-number.error.invalid": "Número de pedido del cliente no válido",
	"eorder.wizard.header.customer-order-number.error.mandatory": "El número de pedido del cliente es obligatorio",
	"eorder.wizard.header.purchase-order-contract.error.invalid": "Número de contrato no válido",
	"eorder.wizard.header.purchase-order-contract.error.mandatory": "El contrato de pedido es obligatorio",
	"eorder.wizard.order.currency": "Divisa",
	"eorder.wizard.order.enduser": "Usuario final",
	"eorder.wizard.order.idd": "Fecha de entrega de la interpretación",
	"eorder.wizard.order.pricingUnit": "Unidad de precio",
	"eorder.wizard.order.purchase.contract": "Contrato de pedido",
	"eorder.wizard.order.shipto.name": "Dirección de entrega",
	"eorder.wizard.order.soldto.name": "cliente",
	"eorder.wizard.parameters.error": "No ha sido posible cargar los parámetros de la oferta electrónica",
	"eorder.wizard.product.action.delete": "Eliminar",
	"eorder.wizard.product.action.duplicate": "Duplicado",
	"eorder.wizard.product.card.error": "⚠ This item is no more valid or has issues to be loaded",
	"eorder.wizard.product.itemnumber": "Número de artículo",
	"eorder.wizard.product.modification.no.products": "No hay producto.",
	"eorder.wizard.product.modification.order.title": "Pedido",
	"eorder.wizard.product.modification.title.cart": "Su cesta",
	"eorder.wizard.product.modification.title.item": "artículo",
	"eorder.wizard.product.modification.title.items": "artículo(s)",
	"eorder.wizard.product.quantity": "Cantidad (t)",
	"eorder.wizard.product.rdd": "RDD",
	"eorder.wizard.product.rdd.error": "Fecha en el pasado",
	"eorder.wizard.product.rdd.type": "Tipo de RDD",
	"eorder.wizard.product.service.level": "Nivel de servicio",
	"eorder.wizard.product.steelgrade": "Grado de acero",
	"eorder.wizard.product.thickness": "grosor",
	"eorder.wizard.product.width": "anchura",
	"eorder.wizard.quantity.error": "Introduce una cantidad válida mayor o igual a 1.",
	"eorder.wizard.stepper.step.order.information": "Información de pedidos y selección de productos",
	"eorder.wizard.stepper.step.product.modification": "Modificación del producto",
	"eorder.wizard.stepper.step.summary": "Resumen de pedidos",
	"eorder.wizard.summary.header.contract.po": "Contrato (PO)",
	"eorder.wizard.summary.header.currency.po": "Moneda de facturación",
	"eorder.wizard.summary.header.order.title": "Datos del pedido",
	"eorder.wizard.summary.order.placed.text": "Pedido realizado - ",
	"eorder.wizard.summary.terms.conditions.text": "Al hacer clic en proceder al pedido, aceptas las condiciones de la entrada de pedidos en la web",
	"eorder.wizard.summary.total.quantity": "Cantidad total (t)",
	"epassivefilm.P": "E-Passivation®",
	"epassivefilm.S": "Easyfilm®",
	"error.cancelling.issue": "Error while cancelling issue",
	"error.choose.pdf.manager": "Por favor, instale pdf manager en su teléfono",
	"error.deleting.draft": "Error al eliminar el borrador",
	"error.file.download": "Se ha producido un error durante la descarga",
	"error.file.not.found": "El archivo no existe",
	"error.inavlid.transport.cost": "Coste de transporte no válido",
	"error.place.atleast.one.bid": "Haz al menos una oferta antes de guardar",
	"exception-report.amlno": "AMLNo",
	"exception-report.comment-by-am": "Historical exception report Arcelormittal comment",
	"exception-report.comment-by-customer": "Historical exception report customer comment",
	"exception-report.delete": "Tu solicitud de informe de excepción se ha eliminado correctamente",
	"exception-report.dialog.add-comment.title": "Añade un comentario para finalizar tu informe de excepciones sobre el pedido",
	"exception-report.dialog.current-status.title": "El estado actual de tu solicitud de pedido",
	"exception-report.dialog.processing": "Procesando",
	"exception-report.docNo": "N.º documento",
	"exception-report.edit-request": "Editar comentario",
	"exception-report.last.comment-by-am": "Exception report Arcelormittal last comment",
	"exception-report.last.comment-by-customer": "Exception report customer last comment",
	"exception-report.make-new-request": "Request exception report",
	"exception-report.order-card-header": "Solicitud especial",
	"exception-report.save": "Tu solicitud de informe de excepción ha sido enviada. Puedes seguir tu solicitud semanal en la LISTA DE PEDIDOS",
	"exception-report.status": "Estatus del comentario",
	"exception-report.yearweek": "AñoSemana",
	"fabrication.process.H": "Tubing + HF",
	"fabrication.process.L": "Tubing + Laser",
	"fabrication.process.R": "Roll Forming",
	"fabrication.process.S": "Stamping",
	"fast.lane.entry": "Fast Lane",
	"fastlane.attachments": "Adjuntos",
	"fastlane.create.details.field.currency": "Elegir moneda",
	"fastlane.delivery.address": "La dirección de entrega es obligatoria!",
	"fastlane.delivery.infos.title": "Selecciona un cliente, una dirección de entrega y un usuario final para acceder a la lista de productos",
	"fastlane.error.nosoldto": "No se ha encontrado el vendido a",
	"fastlane.file.import.button": "Import",
	"fastlane.file.import.note": "Prefill all items by using a file",
	"fastlane.file.import.progressMessage": "Import in progress.",
	"fastlane.file.import.result.label": "Result",
	"fastlane.file.import.result.text": "Please upload a file",
	"fastlane.file.import.validate": "Validate",
	"fastlane.file.template.download.note": "Use proper format for file by downloading the template by clicking here",
	"fastlane.header.customer-request-name.error.mandatory": "Request name is mandatory!",
	"fastlane.header.wizard.customer-request-name": "Request name",
	"fastlane.import.popup.text.1": "Upload an XLS file to prefill in one run all your items. Please follow the template in order to allow automatic detection.",
	"fastlane.import.popup.text.2": "If some fields are too long for text fields, they will be cut (ex: Name for an item: limit = 80 chars)",
	"fastlane.import.popup.text.3": "If some fields require a list of values and the file contains a non existing value, it will be ignored.",
	"fastlane.import.popup.text.4": "A given item must have all mandatory fields provided",
	"fastlane.import.popup.text.5": "The list of all defects will be provided at the end of the process to let you validate or retry.",
	"fastlane.import.popup.title": "Prefill all items",
	"fastlane.info.commercial.data": "Datos comerciales",
	"fastlane.info.request.details": "Request details",
	"fastlane.itemlist.coil.inner.diameter": "Diámetro interno",
	"fastlane.itemlist.coil.inner.diameter.508mm": "508 mm",
	"fastlane.itemlist.coil.inner.diameter.610mm": "610 mm",
	"fastlane.itemlist.coil.inner.diameter.NA": "N/A",
	"fastlane.itemlist.coil.inner.diameter.default": "Vertical",
	"fastlane.itemlist.coil.max_outer_diameter": "Max outer diameter",
	"fastlane.itemlist.global.quantity": "Cantidad",
	"fastlane.itemlist.global.quantity.error": "Quantity is mandatory!",
	"fastlane.itemlist.global.select_unit.error": "Please select a unit",
	"fastlane.itemlist.global.unit": "Unidad",
	"fastlane.itemlist.global.unit.error": "¡La unidad es obligatoria!",
	"fastlane.itemlist.item.additional.info": "Additional item information",
	"fastlane.itemlist.navig.duplicate": "Duplicado",
	"fastlane.itemlist.navig.reset": "Restablecer",
	"fastlane.itemlist.order.thickness": "Espesor",
	"fastlane.itemlist.product.blankWeight.error.invalid": "BlankWeight debe ser mayor que 0",
	"fastlane.itemlist.product.blank_weight": "Blank weight",
	"fastlane.itemlist.product.blank_weight.error": "The weight of one unit is mandatory!",
	"fastlane.itemlist.product.coating.error.invalid": "El recubrimiento debe ser mayor que 0",
	"fastlane.itemlist.product.coating.mandatory": "Coating is mandatory!",
	"fastlane.itemlist.product.coil_axis": "Coil axis",
	"fastlane.itemlist.product.coil_axis.default": "-- None --",
	"fastlane.itemlist.product.coil_axis.horizontal": "Horizontal",
	"fastlane.itemlist.product.coil_axis.vertical": "Vertical",
	"fastlane.itemlist.product.form_blank": "Form Blank",
	"fastlane.itemlist.product.item_form": "Forma",
	"fastlane.itemlist.product.item_form.error": "¡El formulario es obligatorio!",
	"fastlane.itemlist.product.item_name": "Name",
	"fastlane.itemlist.product.item_name.error": "Name for the item is mandatory!",
	"fastlane.itemlist.product.item_number": "Número de artículo",
	"fastlane.itemlist.product.length.error": "Length is mandatory!",
	"fastlane.itemlist.product.length.error.invalid": "La longitud debe ser mayor que 0",
	"fastlane.itemlist.product.maxOuterDiameter.error.invalid": "MaxOuterDiameter debe ser mayor que 0",
	"fastlane.itemlist.product.quantity.error.invalid": "La cantidad debe ser mayor que 0",
	"fastlane.itemlist.product.select_form.error": "Please select a form",
	"fastlane.itemlist.product.slitting_coil": "Slitting Coil",
	"fastlane.itemlist.product.steel_grade": "Grado de acero",
	"fastlane.itemlist.product.steel_grade.error": "Steel grade is mandatory!",
	"fastlane.itemlist.product.thickness.error": "Thickness is mandatory!",
	"fastlane.itemlist.product.thickness.error.invalid": "El espesor debe estar comprendido entre 0.1 y 999",
	"fastlane.itemlist.product.width.error": "Width is mandatory!",
	"fastlane.itemlist.product.width.error.invalid": "El ancho debe ser mayor que 0",
	"fastlane.itemlist.productcharacteristic.oilquantity": "Aceitado",
	"fastlane.itemlist.quality.calculator.coil": "Bobina",
	"fastlane.itemlist.quality.calculator.sheet": "Hoja",
	"fastlane.itemlist.unit.blanks": "Blanks",
	"fastlane.itemlist.unit.sheets": "Hojas",
	"fastlane.itemlist.unit.tons": "Toneladas",
	"fastlane.mandatory.delivery.address": "La dirección de entrega es obligatoria",
	"fastlane.prototype.dialog.week": "semana",
	"fastlane.prototype.not.found": "Not found",
	"fastlane.prototyperequest.request": "Fast Lane request",
	"fastlane.request.title": "Request information",
	"fastlane.soldto.shipto.error": "Sorry, there is an issue in your service settings, please contact SteelUser administrator",
	"fastlane.submit.error.msg": "Something went wrong. Please contact your SteelUser administrator.",
	"fastlane.submit.error.msg.mandatoryfield": "Some mandatory fields are missing.",
	"fastlane.submit.error.msg.nosoldtoshipto": "Something is wrong with your settings for this service",
	"fastlane.submit.error.msg.notoken": "Your session is expired. Please log in the application.",
	"fastlane.submit.request.error.msg.title": "Error during validation of your request",
	"fastlane.template.addinfo.validation": "Additional Information cannot exceed 255 chars ([X] detected)",
	"fastlane.template.blankweight.validation": "Blank Weight is mandatory for Form Blank and must be a valid number greater or equal to 1 with 2 digits (truncated if more). ([X] detected)",
	"fastlane.template.coating.validation": "Coating is mandatory and cannot exceed 50 chars ([X] detected)",
	"fastlane.template.coilaxis.validation": "Coil Axis is mandatory and must be one of the followed values: -- None --, Horizontal, Vertical (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.currency.validation": "Currency is mandatory and must be one of the followed values: EUR, GPB, USD (“[X]” detected). EUR will be set by default",
	"fastlane.template.deliveryaddress.validation": "Delivery address is not mandatory, but if filled in, cannot exceed 150 chars ([X] detected)",
	"fastlane.template.description.validation": "Description is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.detected.items": "[X] items detected in the file",
	"fastlane.template.form.validation": "Form is mandatory and must be one of the followed values: Coil, Sheet, Slitting Coil, Form Blank (“[X]” detected). Coil will be set by default",
	"fastlane.template.format.error": "The file should be a template provided by ArcelorMittal. We are not able to analyse it, it may be a wrong file or a corrupted one. If you have doubt on it, communicate with your AM contact by sending them the file.",
	"fastlane.template.global.data.issue": "Global data with issues",
	"fastlane.template.global.error": "Global error(s) preventing any analysis of the document",
	"fastlane.template.incoterms.validation": "Incoterms is mandatory and must be one of the followed values: -- None --, DAP, CIF, CIP, FCA, DDP (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.innerdiameter.validation": "Inner Diameter is mandatory and must be one of the followed values: N/A, 508 mm, 610 mm (“[X]” detected). “N/A” will be set by default",
	"fastlane.template.item.issue.header": "[X] items with issues",
	"fastlane.template.itemname.validation": "Item Name is mandatory and cannot exceed 80 chars ([X] detected)",
	"fastlane.template.length.validation": "Length is mandatory for Sheet and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.line": "Line",
	"fastlane.template.mill.validation": "Mill is mandatory and must be one of the valid values. (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.oiling.validation": "Oiling cannot exceed 50 chars ([X] detected)",
	"fastlane.template.outerdiameter.validation": "Max Outer Diameter must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.packing.validation": "Packing cannot exceed 50 chars ([X] detected)",
	"fastlane.template.quantity.validation": "Quantity is mandatory and must be a valid positive number with max 2 or 0 digits based on unit selected (truncated if more). ([X] detected)",
	"fastlane.template.rddday.validation": "A Delivery Date has been provided in Day, but not in proper pattern (dd/mm/yyyy, ex: 02/02/2024). (“[X]” detected)",
	"fastlane.template.rddweek.validation": "A Delivery Date has been provided in Week, but not in proper pattern (Www/YYYY, ex: W01/2024). (“[X]” detected)",
	"fastlane.template.rddwnd.validation": "The day provided for Delivery Date should correspond to the week. (“[Y]” is not part of “[X]” Week)",
	"fastlane.template.request": "Request",
	"fastlane.template.requestname.validation": "Request name is mandatory and cannot exceed 120 chars ([X] detected)",
	"fastlane.template.steelgrade.validation": "Steelgrade is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.thickness.validation": "Thickness is mandatory and must be a valid positive number with max 2 digits (truncated if more). Should be less than or equal to 999. ([X] detected)",
	"fastlane.template.tmode.validation": "Transport Mode is mandatory and must be one of the followed values: -- None --, Train, Boat, Truck, Plane (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.unitbasic.validation": "Unit is mandatory and must be one of the followed values: Tons, Sheets, m², Blanks. (“[X]” detected). Default value will be set linked to Form.",
	"fastlane.template.unitform.validation": "“[X]” Quantity value is not valid for “[Y]” Form.",
	"fastlane.template.upload.confirmation.text1": "File properly imported in session.",
	"fastlane.template.upload.confirmation.text2": "Please recheck all items in session before confirming the request.",
	"fastlane.template.upload.warning.text": "You can validate this partial result or try to reupload the file by fixing issues",
	"fastlane.template.valid.items": "[X] items without any issue",
	"fastlane.template.width.validation": "Width is mandatory and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.xls.mime.type": "The file must be an Excel file. Please use the proper template provided by SteelUser application.",
	"fastlane.wizard.contact.person.mandatory": "Person of contact is mandatory!",
	"fastlane.wizard.contact.phone.number": "Phone number of this contact",
	"fastlane.wizard.currency": "Divisa",
	"fastlane.wizard.custom.destination": "Custom destination",
	"fastlane.wizard.custom.destination.contact.person": "Person of contact at custom destination",
	"fastlane.wizard.decide.later": "-- Decide Later --",
	"fastlane.wizard.delivery.address": "Predefined delivery address",
	"fastlane.wizard.header.customer": "El cliente es obligatorio",
	"fastlane.wizard.header.customer-request-name": "Request name",
	"fastlane.wizard.header.customer-request-name.error.invalid": "Invalid Request name",
	"fastlane.wizard.header.global.description": "Description",
	"fastlane.wizard.header.no.item.list": "No item in this request",
	"fastlane.wizard.header.request.data": "Request data",
	"fastlane.wizard.items.details.addanitem": "Add an item",
	"fastlane.wizard.items.details.datetype": "Date type",
	"fastlane.wizard.items.details.datetype.errormsg": "¡El tipo de fecha es obligatorio!",
	"fastlane.wizard.items.details.datetype.rdd": "Fecha de entrega solicitada",
	"fastlane.wizard.items.details.day": "Día",
	"fastlane.wizard.items.details.itemrequest": "Item requests",
	"fastlane.wizard.items.details.sheet.weight": "Peso de la hoja (en kg)",
	"fastlane.wizard.items.details.total.weight": "Peso total (en toneladas)",
	"fastlane.wizard.items.details.week": "Semana",
	"fastlane.wizard.parameters.error": "No se pueden cargar los parámetros fastlane",
	"fastlane.wizard.phone.number.mandatory": "Phone number is mandatory!",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant": "Desired ArcelorMittal plant",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant.errmsg": "Plant is mandatory!",
	"fastlane.wizard.product.transport.mode.errormsg": "¡El modo de transporte es obligatorio!",
	"fastlane.wizard.shipto.name": "Dirección de entrega",
	"fastlane.wizard.soldto.name": "Cliente",
	"fastlane.wizard.stepper.step.items.details": "Items details",
	"fastlane.wizard.stepper.step.main.data": "Main data",
	"fastlane.wizard.stepper.step.transport.details": "Transport details",
	"fastlane.wizard.stepper.step.transport.summary": "Summary",
	"fastlane.wizard.summary.header.currency.po": "Moneda de facturación",
	"fastlane.wizard.summary.submitBtn": "Submit your Fast Lane request",
	"fastlane.xlx.template": "XLS Template",
	"favorite-orders.title": "Mis pedidos marcados",
	"feasibility-status": "Feasibility",
	"feasibility.product-category": "Product category",
	"feasibiliy-characteristics": "Characteristics",
	"feasible-results": "Feasibility Results",
	"fields.number.error": "Thickness and width should be in number format",
	"filter.abandon": "Abandonar",
	"filter.add": "Añadir",
	"filter.add.dimension": "Dimensiones (en mm)",
	"filter.all": "Todo",
	"filter.apply": "Solicitar",
	"filter.atConsignment": "En consignación",
	"filter.batchid": "Identificación del lote",
	"filter.bottom-color": "Color inferior",
	"filter.cancel": "Cancelar",
	"filter.cdd": "Fecha de entrega confirmada",
	"filter.cddGtRdd": "CDD > RDD",
	"filter.coating": "Especificación del recubrimiento",
	"filter.confirmation.deleteall": "¿De verdad quiere eliminar todos los filtros?",
	"filter.contractNumber": "Número de contrato",
	"filter.criteria.applied": "Filtro aplicado",
	"filter.criteria.no.applied": "Ningún filtro aplicado",
	"filter.customerArticleReference": "Referencia del artículo del cliente",
	"filter.customerOrderNumber": "Número de pedido del cliente",
	"filter.date": "Fecha…",
	"filter.date.from": "De",
	"filter.date.invalid": "La fecha debe ser válida",
	"filter.date.to": "A",
	"filter.deleteall": "Suprimir todo",
	"filter.delivered": "Entregado",
	"filter.deliveryMode": "Modalidad de entrega",
	"filter.dimension": "Dimensiones",
	"filter.dimensions.length": "Largo",
	"filter.dimensions.thickness": "Espesor",
	"filter.dimensions.width": "Ancho",
	"filter.dispatchAdviceNumber": "Número de aviso del envío",
	"filter.dispatchDate": "Fecha de envío",
	"filter.enddate.inferior": "Esta fecha debe ser superior a la anterior",
	"filter.field.invalid": "Valor no válido",
	"filter.field.required": "Este campo es obligatorio",
	"filter.filters": "Filtros",
	"filter.format.day": "Formato de día",
	"filter.format.week": "Formato de semana",
	"filter.grossOrdersWithMaterial": "Pedidos brutos con material",
	"filter.inTransit": "En tránsito",
	"filter.is-not-a-number": "El valor debe ser un número",
	"filter.is-not-a-positive-number": "El valor debe ser un número positivo",
	"filter.length": "Longitud (m)",
	"filter.less-than": "Igual o menor que",
	"filter.mill": "Fábrica",
	"filter.more-than": "Igual o mayor que",
	"filter.multiple-values": "Múltiples valores...",
	"filter.netOrdersWithMaterial": "Pedidos netos con material",
	"filter.no-matching-value": "Ningún valor coincidente",
	"filter.no-value": "Sin valor",
	"filter.no.predefined": "No predefinido",
	"filter.number.from": "De",
	"filter.number.to": "A",
	"filter.ok": "Aceptar",
	"filter.operator.exact": "Exacto",
	"filter.operator.range": "Gama",
	"filter.order-number.item": "Artículo",
	"filter.order-number.reference": "Referencia",
	"filter.order.item.number": "Número de artículo",
	"filter.order.reference": "Referencia del pedido",
	"filter.orderWithCddGtRdd": "RDD < CDD",
	"filter.ordersWithMaterial": "Pedidos con material",
	"filter.placeholder.list": "Seleccionar en la lista",
	"filter.placeholder.suggestive.list": "Buscar un valor",
	"filter.predefined": "Predefinido",
	"filter.readyToShip": "Listo para enviar",
	"filter.reset": "Restablecer",
	"filter.schedule-business-order": "Schedule business order",
	"filter.scheduleBusinessOrdersWithMaterial": "Schedule Business Orders with material",
	"filter.shipment-section-n1": "Trabajo en curso",
	"filter.shipment-section-n2": "Trabajo en curso",
	"filter.spot-order": "Spot order",
	"filter.standardsteelgrade": "Grado del acero estándar",
	"filter.supplierOrderNumber": "Número de pedido del proveedor",
	"filter.text": "Use ; como signo de separación, * como comodín",
	"filter.thickness": "Espesor (mm)",
	"filter.top-color": "Color superior",
	"filter.week.to": "A",
	"filter.width": "Ancho (mm)",
	"filter.workInProgress": "Trabajo en curso",
	"filter.x-filter-applied": "{{value}} filtro aplicado",
	"filter.x-filters-applied": "{{value}} filtros aplicados",
	"filter.x-selected-values": "{{value}} valores seleccionados",
	"filter.yes": "Sí",
	"footer.alerts": "Alertas",
	"footer.home": "Inicio",
	"footer.message": "Mensaje",
	"footer.search": "Buscar",
	"form.blanks": "Blanks",
	"form.coil": "Coil",
	"form.heavy.plate": "Heavy Plate",
	"form.indif.04": "Slab",
	"form.indif.06": "Coil",
	"form.indif.07": "Sheet",
	"form.indif.08": "Blanks",
	"form.indif.09": "Heavy Plate",
	"form.indif.10": "Thick Plate",
	"form.indif.12": "Slit coil",
	"form.indif.15": "Scrolled sheet",
	"form.indif.16": "Mixed Coil",
	"form.indif.17": "Welded Coil",
	"form.mixed.coil": "Mixed Coil",
	"form.scrolled.sheet": "Scrolled Sheet",
	"form.sheet": "Sheet",
	"form.slab": "Slab",
	"form.slit.coil": "Slit Coil",
	"form.thick.plate": "Thick Plate",
	"form.welded.coil": "Welded Coil",
	"full.product.catalogue": "Catálogo completo de productos",
	"global-subcategory.BL": "Laminados en caliente sin decapar",
	"global-subcategory.CR": "Cold rolled",
	"global-subcategory.MS": "Metal studs",
	"global-subcategory.PI": "Hot rolled pickled and oiled",
	"global-subcategory.Z": "Hot dip galvanized",
	"global.action.cancelled": "Acción anulada",
	"global.business-type": "Business Type",
	"global.cancelled": "Cancelado",
	"global.clickhere": "Haga clic aquí",
	"global.closed": "Cerrado",
	"global.copyto": "Copy to",
	"global.error": "An error occured while trying to get your list of products",
	"global.error.unexpected": "Error inesperado",
	"global.internal.server.error": "Error interno del servidor",
	"global.internal.soldto.error": "Error de configuración en su cuenta, no puede realizar esta solicitud de pedido (cliente). Por favor, póngase en contacto con su contacto AM.",
	"global.message": "Message",
	"global.message-error": "Message is mandatory!",
	"global.next": "Siguiente",
	"global.no": "No",
	"global.none": "Ninguno",
	"global.open": "Abrir",
	"global.or": "O",
	"global.search-filter": "Global Search",
	"global.search.fastlane-entry": "FastLane",
	"global.search.fastlane-requests": "FastLane requests",
	"global.send": "Enviar",
	"global.servicelevel": "Nivel de servicio",
	"global.subject": "Subject",
	"global.subject-error-msg": "Subject is mandatory!",
	"global.submit.error.unexpected": "Se ha producido un error inesperado durante el proceso de envío, inténtelo más tarde o póngase en contacto con su contacto AM.",
	"global.submit.service.error": "Su cuenta no tiene los permisos adecuados para enviar una solicitud de pedido. Por favor, póngase en contacto con su contacto AM.",
	"global.unexpected.error.identified": "unexpected error identified",
	"global.warning": "Advertencia",
	"global.yes": "Sí",
	"guaranatee.aluminium.parts": "Aluminio para piezas",
	"guarantee.Others": "Otros",
	"guarantee.Poultry": "Aves de corral",
	"guarantee.acoustic": "Barreras acústicas",
	"guarantee.acoustic.concrete": "¿Hay una base de hormigón que separa los elementos revestidos de Magnelis® del suelo?",
	"guarantee.acoustic.railroad": "Barreras acústicas para un ferrocarril",
	"guarantee.acoustic.road.traffic": "Dispositivo de reducción del ruido de tráfico / barreras acústicas para carreteras",
	"guarantee.activity.building": "Actividad dentro del edificio",
	"guarantee.activity.specify": "Por favor, especifique la actividad",
	"guarantee.add.parts": "Añadir piezas",
	"guarantee.additional.comments": "Información o comentarios adicionales",
	"guarantee.additional.documents": "Documentos adicionales",
	"guarantee.address": "Ciudad / País",
	"guarantee.age.material": "Antigüedad del material a sustituir",
	"guarantee.agricultural": "Agrícola",
	"guarantee.agricultural.questions": "Pregunta para edificios agrícolas",
	"guarantee.agricultural.specify": "Por favor, especifique",
	"guarantee.air.renewal": "especificar la tasa de renovación del aire (en m3/h/animal)",
	"guarantee.allocation.building": "Asignación y destino del edificio",
	"guarantee.altitude.above.900m": "Por encima de 900 m",
	"guarantee.altitude.below.900m": "Por debajo de 900 m",
	"guarantee.aluminium": "Aluminio",
	"guarantee.ambiance": "Ambiente en el interior del edificio",
	"guarantee.ammonia": "especifique la concentración de amoniaco en el interior (en ppm)",
	"guarantee.animals.density": "¿Densidad de animales por m²?",
	"guarantee.animals.inside.building": "¿Qué animales hay dentro del edificio?",
	"guarantee.animals.shed": "Especifique el número de animales en la nave",
	"guarantee.area": "Nombre del área",
	"guarantee.atmospheric.corrosion": "Corrosión atmosférica",
	"guarantee.attachment": "Documento adjunto",
	"guarantee.attachment.categorize.title": "Etiquete cada documento con el análisis al que corresponde:",
	"guarantee.attachment.category.label": "Tipo de documento",
	"guarantee.attachment.category.other": "Otro",
	"guarantee.attachment.category.soil": "Análisis del suelo",
	"guarantee.attachment.category.water": "Análisis del agua",
	"guarantee.attachment.column.actions": "Acciones",
	"guarantee.attachment.column.file": "Nombre del archivo",
	"guarantee.attachment.column.size": "Tamaño",
	"guarantee.attachment.description": "Suba y etiquete sus documentos. Cada archivo debe etiquetarse con el análisis al que corresponde.",
	"guarantee.attachment.limit": "El tamaño máximo del archivo es de 115 MB.",
	"guarantee.attachment.missing.soil": "Falta: documento para el análisis del suelo",
	"guarantee.attachment.missing.title": "Falta el documento requerido",
	"guarantee.attachment.missing.water": "Falta: documento para el análisis del agua",
	"guarantee.attachment.size": "El tamaño del archivo adjunto no debe superar los 115mb",
	"guarantee.attachment.title": "Adjuntos",
	"guarantee.attachment.uploaded.title": "Documentos subidos",
	"guarantee.between.2kmand10km": "Situado entre 2 km y 10 km de la costa",
	"guarantee.between.300mand2km": "Situado entre 300 m y 2 km de la costa",
	"guarantee.breeding.animals": "Cría de animales",
	"guarantee.building.altitude": "Altitud",
	"guarantee.building.heated": "¿El edificio tiene calefacción?",
	"guarantee.cancelled": "Cancelar",
	"guarantee.card.client.project.name": "Nombre del proyecto del cliente",
	"guarantee.card.details": "Detalles de la solicitud de garantía",
	"guarantee.card.info": "Información sobre la garantía",
	"guarantee.card.title": "Tarjeta de garantía - Solicitud de garantía",
	"guarantee.cattle": "Ganado",
	"guarantee.certificate.issued": "Certificado emitido",
	"guarantee.certificate.request": "Solicitar certificado",
	"guarantee.certificate.request.confirmation": "¿Confirma que desea solicitar el certificado para esta solicitud de garantía",
	"guarantee.certificate.request.failed": "Lo sentimos, se ha producido un error inesperado durante el proceso. Inténtelo de nuevo más tarde.",
	"guarantee.certificate.request.success": "La solicitud del certificado se ha enviado correctamente.",
	"guarantee.certificate.request.unavailable": "Esta garantía ya no está disponible para solicitar un certificado.",
	"guarantee.certificate.requested": "Certificado solicitado",
	"guarantee.characteristics": "Características del proyecto",
	"guarantee.chimney": "Chimenea",
	"guarantee.choose.applicationtype": "Elija el tipo de garantía que desee solicitar",
	"guarantee.cladding": "Revestimiento ",
	"guarantee.cladding.double.skin": "Doble capa",
	"guarantee.cladding.single.skin": "Capa única",
	"guarantee.cladding.specify.material.type": "En revestimiento de fachada (especifique el tipo de material y la superficie a cubrir)",
	"guarantee.client.project.name": "Nombre del proyecto",
	"guarantee.coastal.marine": "En un entorno costero o marino",
	"guarantee.cold.structure": "Elementos estructurales conformados en frío para edificios (correas, rieles,…)",
	"guarantee.composite.floor": "Forjado compuesto",
	"guarantee.concrete.foundations": "Hormigón para cimientos",
	"guarantee.condensation.rink": "¿Existe riesgo de condensación en el interior del edificio?",
	"guarantee.condition.material": "Estado del material que se va a sustituir",
	"guarantee.construction.new.building": "Construcción completa de un nuevo edificio",
	"guarantee.construction.site": "Obra de construcción",
	"guarantee.construction.site.mandatory": "La ubicación GPS (Latitud y Longitud) es obligatoria",
	"guarantee.contact": "(p. ej. acero pregalvanizado, acero posgalvanizado, madera, etc)",
	"guarantee.contact.orther.parts": "¿Qué otros materiales van a ser utilizados en contacto con las piezas con recubrimiento Magnelis®? En caso afirmativo, especifique por favor.",
	"guarantee.contact.parts": "¿Qué recubrimientos van a ser utilizados para las piezas en contacto con las piezas con recubrimiento Magnelis®? En caso afirmativo, especifique por favor.",
	"guarantee.coordinates.decimal": "Coordenadas en grados decimales",
	"guarantee.coordinates.dms": "Coordenadas en grados, minutos, segundos",
	"guarantee.coordinates.pair.mandatory": "Introduzca tanto la Latitud como la Longitud",
	"guarantee.corporate.name.mandatory": "El campo Cliente es obligatorio",
	"guarantee.current.status": "Estado actual",
	"guarantee.customer.information": "Información del cliente",
	"guarantee.customer.name": "Cliente",
	"guarantee.customer.rejected": "Rechazado por el cliente",
	"guarantee.desert": "En el desierto",
	"guarantee.designation": "Designación",
	"guarantee.direction.of.cladding.installation": "Dirección de instalación del revestimiento",
	"guarantee.distance.3KM.seafront": "Si la distancia es inferior a 3 km del frente marino, especifique la distancia",
	"guarantee.distance.lake": "Distancia a un lago o río (km)",
	"guarantee.distance.less than 300m": "Situado a menos de 300 metros de la costa",
	"guarantee.distance.seafront": "Si la distancia es inferior a 10 km del frente marino, especifique la distancia",
	"guarantee.distance.seafrontkm": "Distancia al frente marino (km)",
	"guarantee.distance.site": "Distancia de la obra (km)",
	"guarantee.documents": "Documentos de garantía",
	"guarantee.documents.title": "Documentos",
	"guarantee.double.skin.roof": "En cubierta (especifique el tipo de material y la superficie cubierta)",
	"guarantee.draft": "Borrador",
	"guarantee.draft.edit": "Podrá actualizarlo en su borrador",
	"guarantee.draft.saved.successfully": "Su borrador se ha guardado",
	"guarantee.duckboard": "A través de enrejado/rejilla de hormigón",
	"guarantee.duration.year": "{{value}} año",
	"guarantee.duration.years": "{{value}} años",
	"guarantee.duration.years.indoor": "Duración prevista de la garantía interior (en años)",
	"guarantee.duration.years.outdoor": "Duración prevista de la garantía exterior (en años)",
	"guarantee.emission.type": "Tipo de emisiones",
	"guarantee.epassivation.type": "Tipo de E-Passivation",
	"guarantee.epc": "Ingeniería, adquisiciones y construcción (EPC)",
	"guarantee.epc.company.name": "Nombre de la empresa",
	"guarantee.equipment": "¿Qué equipamiento se utiliza para la evacuación de humos, gases, vapores y humedad?",
	"guarantee.extension.existing.building": "Ampliación de un edificio existente",
	"guarantee.extension.solar.plant": "Ampliación de una planta solar existente",
	"guarantee.extractor": "Extractor",
	"guarantee.fabrication": "Proceso de fabricación",
	"guarantee.fastners": "Materiales para fijaciones",
	"guarantee.fertilizer": "Almacenamiento de fertilizantes",
	"guarantee.floating.solar.installation": "Instalación solar flotante",
	"guarantee.floating.solar.magnelis": "Garantía para instalaciones solares flotantes con Magnelis®",
	"guarantee.fodder": "Almacenamiento de pienso o forraje",
	"guarantee.forced": "ventilación forzada",
	"guarantee.forced.ventilation": "Ventilación forzada",
	"guarantee.gas.building": "¿hay presencia de gases o vapores en el interior del edificio?",
	"guarantee.gratings": "Sobre rejillas",
	"guarantee.ground.mounted": "Planta solar montada en el suelo / a gran escala",
	"guarantee.heating.type": "Tipo de calefacción",
	"guarantee.horizontal.rails": "Rieles horizontales de quitamiedos",
	"guarantee.humidity.high": "Alta",
	"guarantee.humidity.low": "Baja",
	"guarantee.humidity.medium": "Media",
	"guarantee.humidity.rate.inside.building": "Porcentaje de humedad en el interior del edificio",
	"guarantee.humidity.saturated": "Saturado",
	"guarantee.humidity.specify": "Especifique la tasa de humedad",
	"guarantee.humidity.very.high": "Muy alta",
	"guarantee.hydrogen.sulphide": "especifique la concentración de sulfuro de hidrógeno en el interior (en ppm)",
	"guarantee.industrial": "Industrial",
	"guarantee.industrial.questions": "Pregunta para edificios industriales",
	"guarantee.industry.type": "Tipo de industria",
	"guarantee.inside-building.activity": "Please specify the activity inside the building",
	"guarantee.installation.direction.horizontal": "Horizontal",
	"guarantee.installation.direction.vertical": "Vertical",
	"guarantee.last.modified.date": "Última actualización",
	"guarantee.lat.degree": "Grados (0-89)",
	"guarantee.lat.degrees": "Lat grados",
	"guarantee.lat.max": "Latitud (-90 a 90)",
	"guarantee.lat.minutes": "Lat minutos",
	"guarantee.lat.seconds": "Lat segundos",
	"guarantee.latitude": "Latitud",
	"guarantee.latlong.degree.pattern": "El máximo de decimales es 6",
	"guarantee.latlongmin.max": "Minutos (0-59)",
	"guarantee.latlongsec.max": "Segundos (0-59,9999)",
	"guarantee.latlongsec.pattern": "El máximo de decimales es 4",
	"guarantee.launch.analysis": "Iniciar análisis",
	"guarantee.long.degrees": "Long grados",
	"guarantee.long.max": "Longitud (-180 a 180)",
	"guarantee.long.minutes": "Long. minutos",
	"guarantee.long.seconds": "Long. segundos",
	"guarantee.longdegress.max": "Grados (0-179)",
	"guarantee.longitude": "Longitud",
	"guarantee.magnelis": "Masa de recubrimiento Magnelis®",
	"guarantee.magnelis.other": "Otro",
	"guarantee.magnelis.poles": "Masa de recubrimiento Magnelis® para postes",
	"guarantee.magnelis.upper.structure": "Masa de recubrimiento Magnelis® para estructura superior",
	"guarantee.magnelis.zm310": "Magnelis® ZM310 con recubrimiento metálico de 310 g/m² en ambas caras",
	"guarantee.magnelis.zm430": "Magnelis® ZM430 con recubrimiento metálico de 430 g/m² en ambas caras",
	"guarantee.magnelis.zm620": "Magnelis® ZM620 con recubrimiento metálico de 620 g/m² en ambas caras",
	"guarantee.magnelis.zm800": "Magnelis® ZM800 con recubrimiento metálico de 800 g/m² en ambas caras",
	"guarantee.magnelisbuilding.long": "Magnelis® para aplicación en edificios",
	"guarantee.magnelisbuilding.short": "Magnelis® Edificación",
	"guarantee.magnelisothers.long": "Magnelis® para otra aplicación",
	"guarantee.magnelisothers.short": "Magnelis® Otros",
	"guarantee.magnelissolar.long": "Magnelis® para aplicación solar",
	"guarantee.magnelissolar.short": "Magnelis® Solar",
	"guarantee.manure.management": "Gestión de estiércol para edificios con animales",
	"guarantee.mineral.wool.insulation": "Lana mineral",
	"guarantee.mounting.system.producer": "Fabricante del sistema de montaje",
	"guarantee.msp.company.name": "Nombre de la empresa",
	"guarantee.name.copy": "copiar",
	"guarantee.name.unique.error": "Se ha producido un error inesperado durante el proceso ({{errordetails}})",
	"guarantee.name.unique.reason.duplicate": "unicidad del nombre",
	"guarantee.name.unique.reason.network": "no se puede acceder al servidor",
	"guarantee.natural.ventilation": "Ventilación natural",
	"guarantee.nature.content": "Naturaleza y contenido del ambiente interior",
	"guarantee.nature.material": "Naturaleza del material que se va a sustituir",
	"guarantee.new.solar.plant": "Construcción completa de una nueva planta solar",
	"guarantee.no.duckboard": "Sin enrejado",
	"guarantee.no.parts.magnelis": "No hay piezas con recubrimiento Magnelis®",
	"guarantee.notypes.available": "No hay tipos de garantía disponibles",
	"guarantee.open.building": "Edificio abierto",
	"guarantee.open.building.specify": "Especificar",
	"guarantee.organiccoating.long": "Aceros con recubrimiento orgánico para aplicación en edificios",
	"guarantee.other": "Otras aplicaciones",
	"guarantee.other.application": "Por favor, indique la aplicación",
	"guarantee.other.building": "Otros (p. ej., oficinas, sanidad, hoteles, deportes y ocio, aparcamientos ...)",
	"guarantee.other.coatings": "Acero revestido con otros recubrimientos",
	"guarantee.other.materials": "Otros materiales utilizados en contacto directo con Magnelis®",
	"guarantee.other.materials.used": "Otros materiales utilizados",
	"guarantee.others.animals": "Otros",
	"guarantee.others.please.specify": "Por favor, especifique:",
	"guarantee.part.corrosion": "Tipo de corrosión",
	"guarantee.part.magnelis": "Masa de recubrimiento Magnelis® (g/m2)",
	"guarantee.parts.magnelis": "Piezas con recubrimiento Magnelis®",
	"guarantee.pdf.page": "Página",
	"guarantee.per.app": "¿En qué aplicación va a utilizarse la chapa perforada?",
	"guarantee.per.rich": "Indique el esquema de perforación",
	"guarantee.perforated.sheet": "Chapa perforada",
	"guarantee.pigs": "Cerdos",
	"guarantee.pir.insulation": "PIR",
	"guarantee.planned.operations": "Operación(es) prevista(s)",
	"guarantee.poles.magnelis": "Garantía para postes con recubrimiento Magnelis® para proyectos con postes hincados en el suelo",
	"guarantee.poles.soil": "Proyectos con postes en el suelo",
	"guarantee.power.generation": "Generación de energía",
	"guarantee.presence.animals": "Presencia de animales en el interior del edificio",
	"guarantee.prevailing.wind": "¿Existen emisiones de gas, humo o polvo que sean transportadas hacia el edificio por acción de vientos dominantes?",
	"guarantee.project.characteristics": "Características del proyecto",
	"guarantee.project.environment": "Entorno del proyecto",
	"guarantee.project.for.floating.solar": "Proyecto para solar flotante",
	"guarantee.project.location": "Ubicación del proyecto",
	"guarantee.project.name": "Nombre del proyecto",
	"guarantee.project.name.mandatory": "El nombre del proyecto es obligatorio",
	"guarantee.project.size": "Tamaño del proyecto",
	"guarantee.project.type": "Tipo de proyecto",
	"guarantee.proposal.ongoing": "Propuesta en curso",
	"guarantee.proposals": "Propuesta y documentos adicionales",
	"guarantee.proximity.buildings": "En las proximidades de edificio(s) alojando animales o que almacenen productos en fermentación",
	"guarantee.pu.insulation": "PU",
	"guarantee.purpose.building": "Por favor, especifique la finalidad del edificio",
	"guarantee.questions": "Preguntas para edificios industriales y agrícolas",
	"guarantee.radio.na": "NA",
	"guarantee.radio.no": "No",
	"guarantee.radio.yes": "Sí",
	"guarantee.rainwater.systems": "Sistemas de aguas pluviales / Canalones",
	"guarantee.reason": "Motivo",
	"guarantee.refineries.factories": "Comprende principalmente refinerías, plantas de incineración, centrales eléctricas de carbón o petróleo, industrias de destilación, fábricas de cemento, fábricas de papel, plantas químicas...",
	"guarantee.register": "Producto - solicitud de garantía",
	"guarantee.register.magnelisbuilding": "Producto - solicitud de certificado de garantía - Magnelis® para aplicación en edificios",
	"guarantee.register.magnelisothers": "Producto - solicitud de certificado de garantía - Magnelis® para otras aplicaciones",
	"guarantee.register.magnelissolar": "Producto - solicitud de certificado de garantía - Magnelis® para aplicación solar",
	"guarantee.relative.humidity": "Especifique la humedad relativa",
	"guarantee.remarks": "Especifique cualquier otra observación o detalle sobre el proyecto:",
	"guarantee.request.author": "Autor",
	"guarantee.request.certificate.id": "Certificado",
	"guarantee.request.date": "Fecha",
	"guarantee.request.drafts": "Solicitud de garantía - lista de borradores",
	"guarantee.request.duplicate": "Duplicado",
	"guarantee.request.followup": "Podrá verlo en Mis solicitudes de garantía.",
	"guarantee.request.id": "ID. de garantía",
	"guarantee.request.list": "Mis solicitudes de garantía",
	"guarantee.request.requested.date": "Fecha de solicitud",
	"guarantee.request.submitted.successfully": "Tu solicitud de garantía se ha enviado correctamente.",
	"guarantee.request.type": "Tipo",
	"guarantee.requested": "Garantía solicitada",
	"guarantee.requested.type.indoor": "Interiores",
	"guarantee.requested.type.indoor.label": "Garantía de interiores solicitada",
	"guarantee.requested.type.outdoor": "Exteriores",
	"guarantee.requested.type.outdoor.label": "Garantía de exteriores solicitada",
	"guarantee.residential": "Para uso residencial",
	"guarantee.retrofitting.existing.building": "Renovación/Reparación de un edificio existente",
	"guarantee.retrofitting.solar.plant": "Renovación/Reparación de una planta solar existente",
	"guarantee.road.restraint": "Sistemas de contención de vehículos para carreteras",
	"guarantee.roofing": "Cubierta del silo",
	"guarantee.roofing-cladding.anti-condensation.felt": "Fieltro anticondensación",
	"guarantee.roofing-cladding.color": "Color",
	"guarantee.roofing-cladding.desired.back.coat": "Capa posterior deseada",
	"guarantee.roofing-cladding.desired.coating": "Recubrimiento deseado",
	"guarantee.roofing-cladding.external.skin": "Cara exterior",
	"guarantee.roofing-cladding.insulation": "Aislamiento",
	"guarantee.roofing-cladding.internal.skin": "Cara interior",
	"guarantee.roofing-cladding.made.with.product": "Cubierta y/o revestimiento hecho íntegramente con el producto",
	"guarantee.roofing-cladding.metallic.coating.weight": "Peso del recubrimiento metálico",
	"guarantee.roofing-cladding.overlapping": "Solapamiento",
	"guarantee.roofing-cladding.perforation": "Perforación",
	"guarantee.roofing-cladding.pv.solar.roof": "Pendiente de la cubierta (%)",
	"guarantee.roofing-cladding.substrate.thickness": "Espesor del sustrato",
	"guarantee.roofing-cladding.surface": "Superficie",
	"guarantee.roofing.decking.roof": "Techo entarimado",
	"guarantee.roofing.roofslope": "Cubierta tipo deck",
	"guarantee.roofing.specify.material.type": "Cubierta de doble capa",
	"guarantee.rooftop.installation": "Cubiertas",
	"guarantee.rrs.miscellaneous": "Distintas piezas de sistemas de contención de vehículos para carreteras, sometidas a corrosión atmosférica",
	"guarantee.rrs.poles": "Postes para sistemas de contención de vehículos para carreteras",
	"guarantee.rrs.welded": "¿Las piezas que se fabricarán con Magnelis® están soldadas?",
	"guarantee.rural.area": "En una zona rural a más de 10 km de la costa",
	"guarantee.rural.area.20KM": "En una zona rural a más de 20 km de la costa",
	"guarantee.sandwich.panel": "Paneles sándwich o paneles sandwich in-situ",
	"guarantee.satisfied": "Satisfecho",
	"guarantee.save.failed": "El envío de la garantía ha fallado.",
	"guarantee.save.failed.message": "Inténtelo de nuevo más tarde o póngase en contacto con ebusiness.support@arcelormittal.com",
	"guarantee.service.requests": "Mis solicitudes de garantía",
	"guarantee.sheet.thickness": "Espesor de la chapa (mm)",
	"guarantee.silo": "Silo",
	"guarantee.silo.cylinder": "Cilindro del silo",
	"guarantee.silo.liner": "¿El silo tendrá un forro?",
	"guarantee.silo.parts": "¿Qué partes del silo se fabricarán con Magnelis®?",
	"guarantee.silo.products": "¿Qué productos se almacenarán en el silo?",
	"guarantee.silo.roof": "Techo del silo",
	"guarantee.silo.soil": "Base del silo, que está en contacto con el suelo u hormigón",
	"guarantee.single.skin.roof": "Cubierta monocapa",
	"guarantee.soil.analysis": "¿Se dispone de un análisis completo del suelo?",
	"guarantee.soil.document": "En caso afirmativo, adjunte el documento de análisis del suelo:",
	"guarantee.soil.information": "The soil analysis should contain at least the following information Granulometry, pH-value, moisture content, chloride content, sulphate content, sulphide content, resistivity, presence of ground water.Any other information about the soil, which is in accordance with DIN 50929-3:2018, will be useful.",
	"guarantee.soil.requirements.title": "Requisitos del análisis del suelo",
	"guarantee.specific.environment": "En un entorno específico (combinación de los factores indicados anteriormente y ciertos efectos adicionales como abrasión, alta temperatura, alta humedad, depósitos de polvo, etc.)",
	"guarantee.specify": "Por favor especifique:",
	"guarantee.specify.perforation.scheme": "Especifique el esquema de perforación",
	"guarantee.stainless.steel": "Acero inoxidable",
	"guarantee.steel.parts": "Acero inoxidable para piezas",
	"guarantee.storage.chemicals": "Presencia y/o uso y/o almacenamiento de productos químicos",
	"guarantee.storage.fermentation": "Presencia y/o almacenamiento de productos en fermentación",
	"guarantee.structure": "La estructura está hecha totalmente con Magnelis®",
	"guarantee.suggested.coating.mass": "Masa de recubrimiento a sugerir por ArcelorMittal en función de la duración prevista de la Garantía",
	"guarantee.summary": "Resumen",
	"guarantee.supplier.rejected": "Rechazado por el proveedor",
	"guarantee.surface.building": "Para aplicaciones en edificios: superficie (m²):",
	"guarantee.tonnage.magnelis": "Toneladas de acero con recubrimiento Magnelis®",
	"guarantee.type": "Tipo de garantía",
	"guarantee.type.application": "Tipo de aplicación",
	"guarantee.type.of.installation": "Tipo de instalación",
	"guarantee.types.of.guarantee": "Tipos de garantía",
	"guarantee.unknown": "Unknown",
	"guarantee.upper.structure": "Garantía para estructura superior fabricada con Magnelis®.",
	"guarantee.urban.agglomeration": "En una aglomeración urbana y/o entorno industrial",
	"guarantee.use.of.other.materials": "Utilización de otros materiales, en particular cemento, bovedillas, bloques ligeros de hormigón",
	"guarantee.ventilation.roof": "ventilación natural mediante persianas en el tejado",
	"guarantee.ventilation.walls": "ventilación natural mediante persianas en las paredes",
	"guarantee.wall.facade": "Pared / Fachada",
	"guarantee.water.analysis": "¿Se dispone de un análisis del agua?",
	"guarantee.water.document": "Envíe el análisis del agua junto con la solicitud de garantía",
	"guarantee.water.information": "El análisis del agua debe contener al menos la siguiente información Contenido de cloruro, contenido de sulfato, contenido de calcio, contenido de magnesio, alcalinidad Ks4,3, valor de pH, estructura/potencial del agua UH, conductividad. Será útil cualquier otra información sobre el agua que sea conforme con la norma DIN 50929-3:2018.",
	"guarantee.water.requirements.title": "Requisitos del análisis del agua",
	"guarantee.with.partial.momentary.wetting": "Con mojado parcial o momentáneo con agua de mar y/o con acción directa de spray marino",
	"guarantee.without.direct.wetting": "Sin mojado directo con agua del mar y/o con acción directa de spray marino",
	"guarantee.without.gratings": "Sin rejillas",
	"guarantee.zinc": "Acero recubierto de zinc",
	"gurantee.duration.years": "Duración prevista de la garantía (en años)",
	"gurantee.other.coating.mass": "Otra masa de recubrimiento",
	"help.data.documents": "Documentos",
	"help.documents": "Documentos de ayuda",
	"highest.stocks.widget.title": "5 existencias más altas",
	"home.batch-list": "Mis lotes",
	"home.customer.feedback": "Valoración del cliente",
	"home.dashboard": "Tablero",
	"home.deliveryschedule": "Plazo de entrega",
	"home.diplay.last.batches": "Mostrar los últimos 20 lotes consultados",
	"home.identify.batch": "Identificar un lote",
	"home.last.seen.batch": "Últimos lotes vistos",
	"home.no.service": "Su perfil no puede gestionar ningún servicio. Póngase en contacto con SteelUser Relay para obtener acceso ilimitado al servicio de la aplicación.",
	"home.no.service.alert": "Sin servicio",
	"home.order-tracking.commercial-documents": "Mis documentos comerciales",
	"home.order-tracking.my-schedule-business-order": "Mi programación de pedidos del negocio",
	"home.order-tracking.orders": "Mis pedidos",
	"home.ordertracking": "Seguimiento del pedido",
	"home.quality-issues.issues": "Mis problemas de calidad",
	"import.data": "Import data",
	"import.excel": "Import excel",
	"import.file.message": "Upload an XLS file to import data from existing file. Please follow the template in order to allow automatic detection.",
	"import.file.message.all.fields.mandatory": "All the fields are mandatory.",
	"incoterm.22": "CFR landed duty - no pagado",
	"incoterm.23": "CFR liner terms duty - no pagado",
	"incoterm.24": "CFR free out duty - no pagado",
	"incoterm.25": "CIF landed duty - no pagado",
	"incoterm.26": "CIF LINER TERMS DUTY - NO PAGADO",
	"incoterm.27": "CIF FREE OUT",
	"incoterm.28": "CFR sous palan",
	"incoterm.33": "CFR FO Quick custom desp",
	"incoterm.CFR": "CFR (Cost and Freight)",
	"incoterm.CIF": "CIF (Cost, Insurance, Freight)",
	"incoterm.CIP": "CIP (Carriage and insurance paid to)",
	"incoterm.CPT": "CPT (Carriage paid to)",
	"incoterm.DAF": "Entregado en la frontera",
	"incoterm.DAT": "DPU (Delivered at Place Unloaded)",
	"incoterm.DDP": "DDP (Delivered duty paid)",
	"incoterm.DDU": "Entregado derechos no pagados",
	"incoterm.DEQ": "Transporte pagado hasta el muelle",
	"incoterm.DES": "Entregado en buque",
	"incoterm.FAS": "FAS (Free alongside ship)",
	"incoterm.MAD": "Disponible en fábrica",
	"incoterm.RC": "Incl. transporte a las instalaciones del cliente",
	"incoterm.dap": "DAP (Delivered at place)",
	"incoterm.exw": "Ex works",
	"incoterm.fca": "FCA (Free carrier)",
	"incoterm.fob": "FOB (Free on board)",
	"inner.greater.than.outer.error": "Campo mayor que el Ø exterior.",
	"internal.placeholder.choose.customer": "Introducir el nombre del cliente",
	"issue.acceptedquantity": "Quantidad aceptada",
	"issue.acceptedquantity.value": "Cantidad aceptada (valor)",
	"issue.action.data.center": "Centro de datos",
	"issue.action.filters": "Filtros",
	"issue.attach.documents": "Añadir adjuntos",
	"issue.batch.cdd": "CDD",
	"issue.batch.commercial.documents": "Documentos comerciales",
	"issue.batch.customer.order.number": "Número de pedido del cliente",
	"issue.batch.dimension": "Dimensiones (mm)",
	"issue.batch.invoiced": "Invoiced",
	"issue.batch.no.result": "Ningún resultado",
	"issue.batch.number": "Número de lote",
	"issue.batch.quick.search": "Búsqueda rápida",
	"issue.batch.status": "Estado",
	"issue.batch.steelgrade": "Grado del acero",
	"issue.batch.view-details": "Ver detalles",
	"issue.batchesassociated": "Lotes asociados con este problema",
	"issue.calimed.quantity": "Cantidad reclamada",
	"issue.calimed.quantity.value": "Cantidad reclamada (Valor)",
	"issue.cancel": "Your claim has been cancelled successfully",
	"issue.claim": "Reclamo",
	"issue.closingdate": "Fecha de cierre",
	"issue.contact.info": "Información de contacto",
	"issue.contact.label": "Quiero que un contacto de ArcelorMittal se ponga en contacto conmigo.",
	"issue.contact.type": "Tipo de contacto",
	"issue.creditnote": "Nota de crédito",
	"issue.creditnotedate": "Fecha de nota de crédito",
	"issue.currency": "Divisa",
	"issue.customer.defect": "Defecto ",
	"issue.customer.reference": "Referencia de problema de calidad del cliente",
	"issue.decision": "Decisión",
	"issue.defect.type": "Tipo de defecto",
	"issue.do.you.want.to.be.contacted": "¿Quieres que nos pongamos en contacto contigo?",
	"issue.draft": "Borrador",
	"issue.draft.deleted": "Tu borrador ha sido eliminado correctamente",
	"issue.drag.and.drop.files": "Arrastra y suelta tus archivos aquí",
	"issue.filterbystatus": "Filtrar por estado",
	"issue.followup.widget.title": "Comentarios sobre calidad",
	"issue.inprocess": "En proceso",
	"issue.invoiced.batch": "Invoiced batches only",
	"issue.issuecard": "Tarjeta de problema de calidad",
	"issue.issuedocuments": "Documentos",
	"issue.issueinformation": "Información de emisión",
	"issue.ok.value": "De acuerdo",
	"issue.origin": "Origen",
	"issue.origin.ach": "Sistema de entrada de reclamaciones de ArcelorMittal",
	"issue.origin.sta": "SteelUser",
	"issue.pending": "Pendiente",
	"issue.qualityfeedback": "Panel de calidad del producto - lista de problemas",
	"issue.qualityissues": "Problemas de calidad",
	"issue.qualityissues.drafts": "Problema de qualidad - lista de borradores",
	"issue.register": "Registrar un problema de calidad",
	"issue.requested.total.amount": "Importe total solicitado",
	"issue.requested.total.amount.value": "Importe total solicitado (valor)",
	"issue.save.as.drafts": "Guardar como borrador",
	"issue.select.batches.action.next": "Siguiente",
	"issue.select.current.batch": "Tu lote actual seleccionado:",
	"issue.select.first.batch": "Selecciona el primer lote para registrar tu problema de calidad",
	"issue.select.other.batch": "O selecciona otro lote",
	"issue.send.claim": "Enviar",
	"issue.sending.sample": "Enviar muestra",
	"issue.shipments": "Envíos",
	"issue.submit.quality.feedback": "Enviar tus comentarios sobre calidad",
	"issue.supplierdefect": "Defecto del proveedor",
	"issue.supplierissuenumber": "Número de expedición de ArcelorMittal",
	"issue.total.amount.accepted": "Importe total aceptado",
	"issue.total.amount.accepted.value": "Importe total aceptado (valor)",
	"issue.type.of.request": "Tipo de solicitud",
	"issue.unit": "Unidad",
	"issue.widget.overviewofqi": "Resumen de reclamaciones de calidad",
	"issue.widget.selector.feedbackselected": "Usted ha seleccionado: Seguimiento de los comentarios de calidad",
	"issue.widget.selector.validateadvice": "Pulsar en validar para confirmar su elección",
	"label.calculation": "Obtener cálculo",
	"label.coil.calculator": "Calculadora de bobinas",
	"last.guarantee.requests": "Últimas solicitudes de garantía",
	"latitude.N": "N",
	"latitude.S": "S",
	"legal-document.needforsteel.sales.framework": "Marco de ventas de ArcelorMittal Need4Steel®",
	"legal-documents.agree.to.sales.conditions": "Por favor, acepte nuestras",
	"legal-documents.and": "y",
	"legal-documents.confirm.cart.with.sales.conditions": "Al confirmar tu carrito, aceptas nuestras",
	"legal-documents.general.sales.conditions": "condiciones generales de venta",
	"legal-documents.non.prime.sales.framework": "marco de ventas no primario",
	"legal.data.header": "Plazos, condiciones y políticas",
	"line.select.family.period": "S un periodo para navegar",
	"line.select.family.product": "Selecciona una familia de productos para navegar",
	"line.select.period.fiveyears": "5 años",
	"line.select.period.oneyear": "1 año",
	"line.select.period.sixmonths": "6 meses",
	"line.select.period.threemonths": "3 meses",
	"line.select.period.twoyear": "2 años",
	"line.select.tab.layout": "Selecciona el diseño de tu pestaña",
	"linked.soldto": "Vinculado Vendido a",
	"loader.text": "Products are loading",
	"longitude.E": "E",
	"longitude.W": "W",
	"manage.services.add-services": "Añadir servicios",
	"manage.services.drag-and-drop-items-on-the-right": "Arrastre y suelte elementos de la derecha para añadir un servicio",
	"manual.data.customer": "Número de pedido del cliente",
	"manual.data.enter.reference": "Ingrese una referencia del pedido",
	"manual.data.not.found": "No se ha encontrado el lote.",
	"manual.data.num": "Objeto",
	"manual.data.reference": "Referencia",
	"manual.data.supplier": "Número de pedido del proveedor",
	"manual.data.supplier.or.customer": "Ingrese un número de pedido del proveedor o un número de pedido del cliente.",
	"materials.rts.widget.title": "Material listo para su envío",
	"menu.closed.issues": "Problemas de calidad completados",
	"menu.declare.choose.customer": "Elegir un cliente",
	"menu.declare.order-tracking": "Seguimiento del pedido web",
	"menu.declare.order-tracking.deliveryschedule": "Plazo de entrega",
	"menu.declare.order-tracking.ordertracking": "Seguimiento del pedido",
	"menu.declare.quality.issue": "Informar de un problema de calidad",
	"menu.drafts": "Borradores",
	"menu.logout": "CERRAR SESIÓN",
	"menu.modify.quality.issue": "Editar un problema de calidad",
	"menu.order-services": "Encargar servicios",
	"menu.pending.issues": "Problemas de calidad pendientes",
	"menu.product-services": "Servicios de productos",
	"menu.profile": "Perfil",
	"menu.sales-services": "Servicios de venta",
	"menu.settings": "Configuración",
	"menu.sign.in": "Iniciar sesión",
	"modification.error.message": "Tu modificación no se guardará",
	"n4steel.contact-add-attachment": "Add attachment",
	"n4steel.contact-attachment-help": "Drag and drop your files here",
	"n4steel.contact-mail": "Contact ArcelorMittal Need4Steel®",
	"n4steel.contact-mail-from": "From",
	"n4steel.contact-mail-invalid-email": "Invalid format of e-mail address",
	"n4steel.contact-mail-mill": "Mill",
	"n4steel.contact-mail-offer": "Related offer",
	"n4steel.contact-mail-prefill-data": "Data automatically sent with the mail",
	"n4steel.upload.file.size.error.message": "Max 10MB per file and max 3 files.",
	"navig.confirm": "Confirmar",
	"need4steel-logistic-routes.errormsg": "Max coil weight or Packing not compatible due to selected delivery address.",
	"need4steel-logistic-routes.packaging.errormsg": "Packaging is not compatible with delivery address.",
	"need4steel-order.history.errormsg": "Ningún pedido histórico de su cartera de pedidos de ArcelorMittal Need4Steel® coincide con las opciones de oferta actuales",
	"need4steel-order.history.import": "Importar",
	"need4steel-order.history.notfound": "Pedido no encontrado",
	"need4steel-order.history.subtitle": "Por favor seleccione los productos a importar",
	"need4steel-order.history.title": "Historial de pedidos",
	"need4steel-product-details-tooltip.no-price-msg": "Datos del producto no disponibles",
	"need4steel-product-details-tooltip.price-msg": "Ver datos del producto",
	"need4steel-product-details.chemical-treatment": "Chemical Treatment",
	"need4steel-product-details.effectivedelivered": "€/t effective delivered",
	"need4steel-product-details.header-msg": "Detalles del producto -",
	"need4steel-product-details.max-outside-Diameter": "Max Outside Diameter (mm)",
	"need4steel-product-details.min-coil-weight": "Min coil weight (t)",
	"need4steel-product-details.proposed-price": "Precio propuesto",
	"need4steel-product-details.unrolledWelds": "Unrolled Welds",
	"need4steel-product-offers.additional-fields": "Campos adicionales",
	"need4steel-product-section-details.min-coil-weight": "Min Coil Weight (t)",
	"need4steel-schedule.button": "Importar desde el histórico",
	"need4steel-summary-details.effectivedelivered": "effective delivered",
	"need4steel.dialog.coil.weight": "Peso máximo de la bobina (t)",
	"need4steel.dialog.coil.weight.range": "de {{minValue}} a {{maxValue}} t",
	"need4steel.dialog.coil.weight.range.title": "Rango de peso máximo de la bobina",
	"need4steel.dialog.max.coilweight.range.content": "Peso máximo disponible de la bobina",
	"need4steel.dialog.max.specific.weight.range.content": "Peso específico máximo disponible",
	"need4steel.dialog.range.steelgrade": "Para grado",
	"need4steel.dialog.specific.weight.range": "de {{minValue}} a {{maxValue}} kg/mm",
	"need4steel.dialog.specific.weight.range.title": "Rango de peso específico máximo",
	"need4steel.dialog.thickness.content": "Por favor seleccione una SteelGrade",
	"need4steel.dialog.thickness.list.content": "si es obvio tener que seleccionar un valor",
	"need4steel.dialog.thickness.range.content": "Las dimensiones disponibles para el grosor son",
	"need4steel.dialog.thickness.range.title": "Rango de grosor",
	"need4steel.dialog.width.content": "Introduzca un valor adecuado para Espesor",
	"need4steel.dialog.width.list.content": "Seleccione un valor adecuado para Espesor",
	"need4steel.dialog.width.range.content": "Las dimensiones disponibles para la anchura son",
	"need4steel.dialog.width.range.title": "Rango de anchura",
	"need4steel.dialog.width.range.title.content": "y grosor",
	"need4steel.offer.error.message": "Lo sentimos, se han producido algunos errores al acceder a esta oferta. Por favor, inténtalo de nuevo o envía un mensaje a tu contacto en ArcelorMittal",
	"need4steel.offer.finishingline": "líneaAcabado",
	"need4steel.offer.simulation.error.message": "Lo sentimos, se han producido algunos errores. Por favor, inténtelo de nuevo o envíe un mensaje a su contacto de ArcelorMittal.",
	"need4steel.offers.order.button": "Pedido",
	"need4steel.offers.title": "Ofertas de ArcelorMittal Need4Steel®",
	"need4steel.product.details.product.coilweight": "Peso máx. de la bobina (t)",
	"need4steel.product.details.specific.weight": "Peso máx. específico (kg/mm)",
	"need4steel.product.thickness.tolerance": "toleranciaGrosor",
	"need4steel.soldto.shipto.error.message": "Lo sentimos, hay un problema en la configuración del servicio; por favor, ponte en contacto con el administrador de SteelUser",
	"need4steel.submit.credit.limit.error.msg": "☹ ArcelorMittal Need4Steel® order request impossible: not sufficient credit limit available. Please contact us at need4steel@arcelormittal.com",
	"need4steel.submit.error.msg": "Ha habido algún problema, ponte en contacto con el administrador de SteelUser",
	"need4steel.submit.exchange.rate.mandatory.error.msg": "El tipo de cambio es obligatorio",
	"need4steel.submit.exchange.rate.refreshed.error.msg": "El tipo de cambio se ha actualizado durante tu proceso de pedido; revísalo antes de volver a enviarlo",
	"need4steel.submit.order.error.msg.title": "Error durante la validación de tu pedido",
	"need4steel.submit.order.success.msg.row1": "Tu pedido ha sido procesado",
	"need4steel.submit.order.success.msg.row2": "Puedes seguir el estado de tu pedido en el",
	"need4steel.submit.order.success.msg.row2.link": "SEGUIMIENTO DEL PEDIDO Y LA ENTREGA.",
	"need4steel.trademark": "®",
	"need4steel.wizard.coil.error": "Introduzca un valor válido inferior o igual a 1000.",
	"need4steel.wizard.estimated": "Estimado:",
	"need4steel.wizard.exchange-rate.rate": "Tipo de cambio",
	"need4steel.wizard.exchange-rate.reference-date": "Fecha de referencia",
	"need4steel.wizard.header.Delivery-address": "La dirección de entrega es obligatoria",
	"need4steel.wizard.header.customer": "El cliente es obligatorio",
	"need4steel.wizard.header.customer-order-number": "Número de pedido del cliente",
	"need4steel.wizard.header.customer-order-number.error.invalid": "Número de pedido del cliente no válido",
	"need4steel.wizard.header.customer-order-number.error.mandatory": "El número de pedido del cliente es obligatorio",
	"need4steel.wizard.header.delivery.date": "Fecha de entrega",
	"need4steel.wizard.header.mill": "Fábrica",
	"need4steel.wizard.header.shipto": "Dirección de entrega",
	"need4steel.wizard.header.soldto": "cliente",
	"need4steel.wizard.header.transport-mode": "Modo de transporte",
	"need4steel.wizard.maxcoilweight.range.error": "Ingrese un peso máximo de bobina válido.",
	"need4steel.wizard.maxspecificweight.range.error": "Ingrese un peso específico máximo válido",
	"need4steel.wizard.no.weight.option.error.message": "Problema con la configuración de plantillas: no hay opciones de peso",
	"need4steel.wizard.product.coil.weight": "t peso máx. de la bobina",
	"need4steel.wizard.product.max.specific.weight": "kg/mm peso máx. específico",
	"need4steel.wizard.product.price.calculate.offline": "Asegúrese de tener acceso a Internet para solicitar un precio",
	"need4steel.wizard.product.specific.weight": "Peso máx. específico (kg/mm)",
	"need4steel.wizard.product.weight.type.label": "Selección del tipo de peso",
	"need4steel.wizard.step.product.title": "Especifica el producto",
	"need4steel.wizard.stepper.product.action.delete": "Eliminar",
	"need4steel.wizard.stepper.product.action.duplicate": "Duplicado",
	"need4steel.wizard.stepper.product.action.reset": "Restablecer",
	"need4steel.wizard.stepper.product.add": "Añadir producto",
	"need4steel.wizard.stepper.product.coil": "# (Bobina)",
	"need4steel.wizard.stepper.product.coilweight": "Peso máx. de la bobina (t)",
	"need4steel.wizard.stepper.product.itemnumber": "Número de artículo",
	"need4steel.wizard.stepper.product.steelgrade": "Grado de acero",
	"need4steel.wizard.stepper.product.thickness": "Espesor (mm)",
	"need4steel.wizard.stepper.product.total.weight": "Peso total",
	"need4steel.wizard.stepper.product.width": "Ancho (mm)",
	"need4steel.wizard.stepper.step.product.specification": "Especificaciones de productos",
	"need4steel.wizard.stepper.step.summary": "Resumen",
	"need4steel.wizard.summary.confirm.to.order.button": "Confirmar pedido",
	"need4steel.wizard.summary.proceed.order.button": "Proceder al pedido",
	"need4steel.wizard.summary.product.coils": "N.º de bobinas",
	"need4steel.wizard.summary.product.dimension": "Dimensiones (en mm)",
	"need4steel.wizard.summary.product.price": "Precio (€/t)",
	"need4steel.wizard.summary.product.selection": "Selección de producto",
	"need4steel.wizard.summary.product.total.weight": "Peso total (t)",
	"need4steel.wizard.summary.terms.conditions.text": "Al hacer clic en Proceder al pedido, aceptas las condiciones del programa ArcelorMittal Need4Steel®",
	"need4steel.wizard.thickness.range.error": "Introduzca un grosor válido.",
	"need4steel.wizard.thickness.tolerance.field": "Tolerancia de grosor",
	"need4steel.wizard.width.range.error": "Introduce un ancho válido.",
	"new.offer.request.message": "¿Sabes la cantidad que necesitas para las especificaciones de cada artículo?",
	"news.detail": "Ver detalles",
	"news.last-news": "Últimas novedades",
	"news.news-list": "Lista de novedades",
	"news.view-all": "Ver todo",
	"no.data.error": "No data found in the feasibility sheet",
	"no.guarantee.documents": "No hay documentos de garantía",
	"no.legal.documents": "No se han encontrado documentos",
	"no.product.family": "No se ha encontrado ninguna familia de productos.",
	"no.result": "no se han encontrado resultados",
	"notifications.daily": "Diario",
	"notifications.immediatly": "Inmediatamente",
	"notifications.management": "Gestión de notificaciones",
	"notifications.monthly": "Mensualmente",
	"notifications.weekly": "Semanalmente",
	"number.of.items.in.order": "Demasiados elementos para añadir en este pedido.",
	"number.of.items.infos.message": "Introduce el número de copias de este producto que quieres como artículo en este pedido",
	"number.of.items.label": "Número de artículos",
	"number.of.items.limit.in.order": "Solo podemos aceptar 100 artículos en un mismo pedido. Revisa tu selección.",
	"offer-dashboard-card.accepted": "Aceptado",
	"offer-dashboard-card.annually": "Anualmente",
	"offer-dashboard-card.monthly": "Mensualmente",
	"offer-dashboard-card.offered": "Ofrecido",
	"offer-dashboard-card.order": "Pedido",
	"offer-dashboard-card.other-period": "Otro período",
	"offer-dashboard-card.quarterly": "Trimestralmente",
	"offer-dashboard-card.remaining-to-order": "Pendientes de pedir",
	"offer-dashboard-card.requested": "Solicitado",
	"offer-dashboard-card.semesterly": "Semestralmente",
	"offer-dashboard-card.view-details": "Ver detalles",
	"offer-period.from": "De",
	"offer-period.reset": "Restablecer",
	"offer-period.to": "A",
	"offer.card.table.header.quantity": "Cantidad (t)",
	"offer.current.total.tons": "t",
	"offer.dashboard.services": "Mis servicios",
	"offer.end.date": "Fecha de finalización",
	"offer.enduser.update.cart.warning": "Este usuario final no es compatible con algunos productos seleccionados. Se eliminarán automáticamente del carrito.",
	"offer.multiple.families": "Múltiplo",
	"offer.new.request.title": "Nueva solicitud",
	"offer.product.disabled.tooltip": "Este producto no es compatible con la dirección de entrega o el usuario final seleccionados actualmente",
	"offer.product.family": "Familia de productos",
	"offer.quantity.framework": "Elige las cantidades por familia, sobre las que quieres recibir una oferta ",
	"offer.quantity.spot": "Elija las cantidades por artículo sobre las que desea recibir una oferta ",
	"offer.shipto.update.cart.warning": "Esta dirección de entrega no es compatible con algunos productos seleccionados. Se eliminarán automáticamente del carrito.",
	"offer.sub.family": "Subfamilia",
	"offer.template.disabled.tooltip": "Este plantilla no es compatible con la dirección de entrega o el usuario final seleccionados actualmente",
	"offer.transport.condition": "Condiciones de transporte",
	"offer.type.no": "No",
	"offer.type.yes": "Sí",
	"offer.weight": "Peso",
	"offers.action.next": "Siguiente",
	"offers.commercial.terms": "Condiciones comerciales",
	"offers.commitment.period": "Plazo de compromiso",
	"offers.create.details.customer.offer-name": "Número de RFQ del cliente",
	"offers.create.details.customer.offer-name.error.mandatory": "El número de solicitud de presupuesto del cliente es obligatorio",
	"offers.create.details.field.currency": "Elegir moneda",
	"offers.create.details.field.offer-name": "Nombre de solicitud de oferta",
	"offers.create.details.field.offer-name.error.mandatory": "El nombre de la solicitud de oferta es obligatorio",
	"offers.create.details.section.entities": "Entidades",
	"offers.create.details.section.offer-period": "Condiciones de la oferta y período de compromiso",
	"offers.create.path.cart": "establece tu cantidad",
	"offers.create.path.confirmation": "envíe su solicitud de oferta",
	"offers.create.request.offer": "Solicitar una oferta",
	"offers.create.section.offer-period": "Condiciones y período de compromiso",
	"offers.product.list": "Lista de productos",
	"offers.proposals.price.nooffer": "No hay ofertas disponibles",
	"offers.proposals.price.period": "Período relacionado",
	"offers.proposals.price.title": "Últimas propuestas de precio",
	"offers.request.info": "Información sobre la solicitud de oferta",
	"offers.soldTo.selection.text": "Por favor, seleccione el cliente adecuado para esta solicitud de oferta, para empezar a mostrar la lista de productos disponibles. Todos los artículos de la cesta deben estar relacionados con el mismo cliente.",
	"offers.sqmeters": "Metros cuadrados",
	"offers.wizard.stepper.customization": "Personalización",
	"offers.wizard.stepper.request.and.selection": "Solicitud y selección de ofertas",
	"offers.wizard.stepper.step.offer-summary": "Resumen",
	"offers.wizard.stepper.step.quantity": "Cantidad",
	"offline.alert": "Alerta",
	"ok.value": "De acuerdo",
	"order-card.batches-at-reshipper": "En el transportista",
	"order-card.batches-available": "Lotes - Disponibles",
	"order-card.batches-blocked": "Lotes - Existencias bloqueadas",
	"order-card.batches-called": "Called",
	"order-card.batches-consignment-stock": "Existencias en consignación",
	"order-card.batches-delivered": "Lotes - Entregados",
	"order-card.batches-land-transit": "Tránsito terrestre",
	"order-card.batches-on-vessel": "Por barco/vía marítima",
	"order-card.batches-overseas-transit": "Tránsito al extranjero",
	"order-card.batches-ready-to-ship": "Listo para enviar",
	"order-card.batches-transit-to-customer": "En tránsito al cliente",
	"order-card.commercial-documents": "Documentos comerciales",
	"order-card.data-not-found": "Order data not found",
	"order-card.document": "Documento",
	"order-card.due-to-technical-issue": "Debido a un problema técnico, no podemos mostrar estos datos",
	"order-card.gross": "Bruto: {{value}}",
	"order-card.name": "Nombre",
	"order-card.net": "Neto: {{value}}",
	"order-card.no-rows-to-show": "No hay filas para mostrar",
	"order-card.proforma": "Proforma",
	"order-card.type": "Tipo",
	"order-card.we-are-actively-working": "Estamos trabajando activamente para restablecer el servicio.",
	"order-card.wip-quantity": "Cantidad (t)",
	"order-card.work-in-progress": "Trabajo en curso",
	"order-item-status.completely-produced": "Totalmente producido",
	"order-tracking.card.batches-in-stock": "Lotes en existencias",
	"order-tracking.card.callables-batches.days": "{{value}} días",
	"order-tracking.card.callables-batches.view-details": "Ver detalles",
	"order-tracking.card.delivery-date.cdd": "CDD",
	"order-tracking.card.delivery-date.first-batch": "1ER LOTE EN EXISTENCIAS",
	"order-tracking.card.delivery-date.last-batch": "ÚLTIMO LOTE EN EXISTENCIAS",
	"order-tracking.card.delivery-date.rdd": "RDD",
	"order-tracking.card.delivery-date.view-details": "Ver detalles",
	"order-tracking.card.delivery-status": "Estado de entrada",
	"order-tracking.cdd": "CDD",
	"order-tracking.choice": "Elección",
	"order-tracking.customerArticleReference": "Referencia del artículo del cliente",
	"order-tracking.delivered": "Entregado",
	"order-tracking.delivered-t": "Entregado (t)",
	"order-tracking.dimension": "Dimensiones (mm)",
	"order-tracking.final.use": "Uso final",
	"order-tracking.form": "Forma",
	"order-tracking.in.production": "En producción",
	"order-tracking.in.production-t": "En producción (t)",
	"order-tracking.in.stock": "En stock",
	"order-tracking.in.stock-t": "En existencias (t)",
	"order-tracking.in.transit": "En tránsito",
	"order-tracking.in.transit-t": "En tránsito (t)",
	"order-tracking.list": "Lista",
	"order-tracking.no.connection": "El servicio de seguimiento del pedido web no está disponible",
	"order-tracking.no.result": "Ningún resultado",
	"order-tracking.overview": "Resumen",
	"order-tracking.product": "Producto",
	"order-tracking.product.category": "Categoría del producto",
	"order-tracking.product.description": "Descripción del producto",
	"order-tracking.running.orders": "Pedidos en curso",
	"order-tracking.standard-steel-grade": "Calidad del acero",
	"order-tracking.standard.steelgrade": "Grado del acero estándar",
	"order-tracking.steelgrade": "Grado del acero",
	"order.avail-t": "Aprovechar (t)",
	"order.bill.to": "Facturar a",
	"order.book.only": "Solo cartera de pedidos",
	"order.callable.gross.weight": "Callable gross weight",
	"order.called.gross.weight": "Called gross weight",
	"order.card": "Tarjeta de pedido",
	"order.card.all.documents": "Últimos documentos de este pedido",
	"order.card.certificate.display.all": "Mostrar todos los certificados",
	"order.card.dates": "Fechas",
	"order.card.detail.information": "Ver los datos del pedido detallados",
	"order.card.dispatch.advice.display.all": "Mostrar todos los avisos del envío",
	"order.card.document.certificates": "Certificados",
	"order.card.document.date": "Fecha",
	"order.card.document.dispatch.advices": "Avisos del envío",
	"order.card.document.display.batches": "Mostrar todos los lotes",
	"order.card.document.invoices": "Facturas",
	"order.card.document.number": "Número del documento",
	"order.card.document.order.acknowledgments": "Confirmaciones del pedido",
	"order.card.document.show": "Mostrar documento",
	"order.card.document.type": "Tipo",
	"order.card.followup": "Seguimiento del pedido",
	"order.card.in-consignment": "En consignación",
	"order.card.in-consignment-t": "En consignación (t)",
	"order.card.information": "Datos del pedido",
	"order.card.invoice.display.all": "Mostrar todas las facturas",
	"order.card.last.certificate": "Último certificado",
	"order.card.last.dispatch.advice": "Último aviso del envío",
	"order.card.last.documents": "Últimos documentos",
	"order.card.last.invoice": "Última factura",
	"order.card.last.order.acknowledgment": "Última confirmación del pedido",
	"order.card.order.acknowledgment.display.all": "Mostrar todas las confirmaciones del pedido",
	"order.card.product": "Producto",
	"order.card.xcarb": "XCarb®",
	"order.cdd-week": "CDD (semana)",
	"order.certificate": "Certificado",
	"order.chemical.passivation": "Chemical Passivation",
	"order.choice": "Elección",
	"order.coating": "Revestimiento",
	"order.coating-side": "Lado del revestimiento",
	"order.color-bottom-side": "Parte inferior de color",
	"order.color-top-side": "Parte superior de color",
	"order.color.category.bottom.side": "Color Category Bottom Side",
	"order.color.category.top.side": "Color Category Top Side",
	"order.confirmed.delivery.date": "Fecha de entrega confirmada",
	"order.contract.number": "Número de contrato",
	"order.creation.date": "Fecha de creación",
	"order.customer": "Cliente",
	"order.customer-template-reference": "Referencia de plantilla del cliente",
	"order.customer.article.reference": "Referencia del artículo del cliente",
	"order.customer.order.number": "Número de pedido del cliente",
	"order.daysInStock": "Número de días en stock",
	"order.delivered-t": "Entregado (t)",
	"order.delivery": "Entrega",
	"order.delivery.address": "Dirección de entrega",
	"order.delivery.mode": "Modalidad de entrega",
	"order.dim-mm": "Dim (mm)",
	"order.easy-film-bottom": "Easy film inferior",
	"order.easy-film-top": "Easy film superior",
	"order.easy.film.bottom": "EasyFilm Bottom",
	"order.easy.film.top": "EasyFilm Top",
	"order.ebusiness.order.number": "Referencia del pedido de comercio electrónico",
	"order.end.user": "Usuario final",
	"order.enduser": "Usuario final",
	"order.entry": "Entrada de pedido",
	"order.final-use": "Uso final",
	"order.firm": "Empresa",
	"order.first.batch.available": "Primer lote disponible",
	"order.first.batch.in.stock": "Primer lote en existencias",
	"order.form": "Forma",
	"order.grade": "Grado",
	"order.incoterm": "Incoterm",
	"order.incoterm2": "Incoterm2",
	"order.internal-diameter": "Diámetro interior (mm)",
	"order.interpretation.delivery.date": "Fecha de entrega estimada",
	"order.item.reference.soldto.party": "Artículo vendido a una persona",
	"order.item.status": "Estado del artículo del pedido",
	"order.last.batch.available": "Último lote disponible",
	"order.last.batch.in.stock": "Último lote en existencias",
	"order.last.updated": "Actualizado por última vez",
	"order.maximum-outside-diameter": "Diámetro exterior máximo (mm)",
	"order.mill": "Fábrica",
	"order.mill.order.number": "Número de pedido de fábrica",
	"order.minimum-outside-diameter": "Diámetro exterior mínimo (mm)",
	"order.no-documents": "No hay documentos disponibles",
	"order.oil-reference": "Referencia del aceite",
	"order.oil-side": "Lado del aceite",
	"order.oil.reference": "Oil Reference",
	"order.ord-t": "Ped (t)",
	"order.order-status": "Estado del pedido",
	"order.ordered": "Pedido",
	"order.ordered-t": "Pedido (t)",
	"order.orders": "Pedidos",
	"order.packing": "Embalaje",
	"order.paint.marking.for.sh": "Paint Marking",
	"order.pattern.for.sh": "Pattern",
	"order.place.delivery": "Lugar de entrega",
	"order.prevision.item": "Artículo previsto (especificación de última hora)",
	"order.protection": "Protección",
	"order.provisional": "Provisional",
	"order.provisional.item": "Artículo provisional/ estable",
	"order.rdd": "Fecha de entrega solicitada",
	"order.reason": "Motivo del pedido",
	"order.responsible.order.manager": "Administrador responsable del pedido",
	"order.sales.quarter": "Trimestre de ventas",
	"order.service.level": "Nivel de servicio",
	"order.service.request": "Solicitud de servicio",
	"order.ship.to": "Enviar a",
	"order.sortby": "Ordenar por",
	"order.spangle": "Lentejuela",
	"order.standard": "Estándar",
	"order.status": "Estado del pedido",
	"order.steelgrade": "Grado del acero",
	"order.stock-alert": "Alerta de existencias",
	"order.sub.category": "Sub Category",
	"order.submit": "Enviar",
	"order.supplier": "Proveedor",
	"order.supplier-rfq-number": "Supplier RFQ number",
	"order.supplier.order.number": "Número de pedido del proveedor",
	"order.surface-aspect": "Aspecto de la superficie",
	"order.thickness": "Espesor",
	"order.transport-mode": "Modo de transporte",
	"order.transport.mode": "Modalidad de transporte",
	"order.ultrasonic.testing": "Ultrasonic Testing",
	"order.width": "Ancho",
	"order.wip": "En producción",
	"order.wip-t": "TEC (t)",
	"order.wip.forecast.stock": "Entrada de stock prevista",
	"order.wip.quantity": "Cantidad",
	"order.woe.version": "Versión WOE",
	"order.z.test.certificat": "Z-test Certificat",
	"orderview.sort.cdd": "cdd",
	"orderview.sort.order": "pedido",
	"orderview.sort.product": "producto",
	"organization-type.agency": "Agencia",
	"organization-type.buyer": "Comprador",
	"organization-type.lab": "Laboratorio",
	"organization-type.selag": "Vendedor Agencia",
	"organization-type.seller": "Vendedor",
	"organization-type.super-user": "Usuario Superior",
	"organization-users.one-admin": "One administrator should be selected",
	"organization-users.one-admin-only": "Only one administrator should be selected",
	"organization-users.roles-error": "An error occurred during the update of the user, changes are not saved",
	"organization-users.roles-saved": "Roles have been correctly updated",
	"organization.card.administrator.comment": "Responsable actual para esta organización",
	"organization.card.administrator.email": "Email",
	"organization.card.administrator.name": "Nombre",
	"organization.card.details": "Detalles",
	"organization.card.details.administrator": "Administrador",
	"organization.card.details.identity": "Identidad",
	"organization.card.identity.address": "Dirección",
	"organization.card.identity.city": "Ciudad",
	"organization.card.identity.country": "País",
	"organization.card.identity.country.AD": "Andorra",
	"organization.card.identity.country.AE": "Emiratos Árabes Un.",
	"organization.card.identity.country.AF": "Afganistán",
	"organization.card.identity.country.AG": "Antigua/Barbuda",
	"organization.card.identity.country.AI": "Anguila",
	"organization.card.identity.country.AL": "Albania",
	"organization.card.identity.country.AM": "Armenia",
	"organization.card.identity.country.AN": "Antillas Neerlandesas",
	"organization.card.identity.country.AO": "Angola",
	"organization.card.identity.country.AQ": "Antártida",
	"organization.card.identity.country.AR": "Argentina",
	"organization.card.identity.country.AS": "Samoa",
	"organization.card.identity.country.AT": "Austria",
	"organization.card.identity.country.AU": "Australia",
	"organization.card.identity.country.AW": "Aruba",
	"organization.card.identity.country.AZ": "Azerbaiyán",
	"organization.card.identity.country.BA": "Bosnia Herzeg.",
	"organization.card.identity.country.BB": "Barbados",
	"organization.card.identity.country.BD": "Bangladés",
	"organization.card.identity.country.BE": "Bélgica",
	"organization.card.identity.country.BF": "Burkina Faso",
	"organization.card.identity.country.BG": "Bulgaria",
	"organization.card.identity.country.BH": "Bahréin",
	"organization.card.identity.country.BI": "Burundi",
	"organization.card.identity.country.BJ": "Benín",
	"organization.card.identity.country.BM": "Bermuda",
	"organization.card.identity.country.BN": "Brunéi",
	"organization.card.identity.country.BO": "Bolivia",
	"organization.card.identity.country.BR": "Brasil",
	"organization.card.identity.country.BS": "Bahamas",
	"organization.card.identity.country.BT": "Bután",
	"organization.card.identity.country.BU": "Birmania",
	"organization.card.identity.country.BV": "Isla Bouvet",
	"organization.card.identity.country.BW": "Botsuana",
	"organization.card.identity.country.BY": "Bielorrusia",
	"organization.card.identity.country.BZ": "Belice",
	"organization.card.identity.country.CA": "Canadá",
	"organization.card.identity.country.CC": "Islas Cocos",
	"organization.card.identity.country.CD": "Repúb. Domin. Congo",
	"organization.card.identity.country.CF": "Repúb. Centr.",
	"organization.card.identity.country.CG": "Congo",
	"organization.card.identity.country.CH": "Suiza",
	"organization.card.identity.country.CI": "Costa de Marfil",
	"organization.card.identity.country.CK": "Islas Cook",
	"organization.card.identity.country.CL": "Chile",
	"organization.card.identity.country.CM": "Camerún",
	"organization.card.identity.country.CN": "China",
	"organization.card.identity.country.CO": "Colombia",
	"organization.card.identity.country.CR": "Costa Rica",
	"organization.card.identity.country.CS": "no usar (S/M)",
	"organization.card.identity.country.CU": "Cuba",
	"organization.card.identity.country.CV": "Cabo Verde",
	"organization.card.identity.country.CX": "Isla de Navidad",
	"organization.card.identity.country.CY": "Chipre",
	"organization.card.identity.country.CZ": "República Checa",
	"organization.card.identity.country.DE": "Alemania",
	"organization.card.identity.country.DJ": "Yibuti",
	"organization.card.identity.country.DK": "Dinamarca",
	"organization.card.identity.country.DM": "Dominica",
	"organization.card.identity.country.DO": "Rep. Dominicana",
	"organization.card.identity.country.DZ": "Argelia",
	"organization.card.identity.country.EC": "Ecuador",
	"organization.card.identity.country.EE": "Estonia",
	"organization.card.identity.country.EG": "Egipto",
	"organization.card.identity.country.EH": "Sáhara Occidental",
	"organization.card.identity.country.ER": "Eritrea",
	"organization.card.identity.country.ES": "España",
	"organization.card.identity.country.ET": "Etiopía",
	"organization.card.identity.country.FI": "Finlandia",
	"organization.card.identity.country.FJ": "Fiyi",
	"organization.card.identity.country.FK": "Islas Malvinas",
	"organization.card.identity.country.FM": "Micronesia",
	"organization.card.identity.country.FO": "Islas Feroe",
	"organization.card.identity.country.FR": "Francia",
	"organization.card.identity.country.GA": "Gabón",
	"organization.card.identity.country.GB": "Gran Bretaña",
	"organization.card.identity.country.GD": "Granada",
	"organization.card.identity.country.GE": "Georgia",
	"organization.card.identity.country.GF": "Guayana Francesa",
	"organization.card.identity.country.GH": "Ghana",
	"organization.card.identity.country.GI": "Gibraltar",
	"organization.card.identity.country.GL": "Groenlandia",
	"organization.card.identity.country.GM": "Gambia",
	"organization.card.identity.country.GN": "Guinea",
	"organization.card.identity.country.GP": "Guadalupe",
	"organization.card.identity.country.GQ": "Guinea Ecuat.",
	"organization.card.identity.country.GR": "Grecia",
	"organization.card.identity.country.GS": "I. Sandwich del Sur",
	"organization.card.identity.country.GT": "Guatemala",
	"organization.card.identity.country.GU": "Guam",
	"organization.card.identity.country.GW": "Guinea-Bisáu",
	"organization.card.identity.country.GY": "Guayana",
	"organization.card.identity.country.HK": "Hong Kong",
	"organization.card.identity.country.HM": "Isl. Heard/McDonald",
	"organization.card.identity.country.HN": "Honduras",
	"organization.card.identity.country.HR": "Croacia",
	"organization.card.identity.country.HT": "Haití",
	"organization.card.identity.country.HU": "Hungría",
	"organization.card.identity.country.ID": "Indonesia",
	"organization.card.identity.country.IE": "Irlanda",
	"organization.card.identity.country.IL": "Israel",
	"organization.card.identity.country.IN": "India",
	"organization.card.identity.country.IO": "Terr.Br.Oc.Índ.",
	"organization.card.identity.country.IQ": "Irak",
	"organization.card.identity.country.IR": "Irán",
	"organization.card.identity.country.IS": "Islandia",
	"organization.card.identity.country.IT": "Italia",
	"organization.card.identity.country.JM": "Jamaica",
	"organization.card.identity.country.JO": "Jordania",
	"organization.card.identity.country.JP": "Japón",
	"organization.card.identity.country.KE": "Kenia",
	"organization.card.identity.country.KG": "Kirguistán",
	"organization.card.identity.country.KH": "Camboya",
	"organization.card.identity.country.KI": "Kiribati",
	"organization.card.identity.country.KM": "Is. Comoro",
	"organization.card.identity.country.KN": "Is. San Cristóbal",
	"organization.card.identity.country.KP": "Corea del Norte",
	"organization.card.identity.country.KR": "Corea del Sur",
	"organization.card.identity.country.KW": "Kuwait",
	"organization.card.identity.country.KY": "Islas Caimán",
	"organization.card.identity.country.KZ": "Kazajistán",
	"organization.card.identity.country.LA": "Laos",
	"organization.card.identity.country.LB": "Líbano",
	"organization.card.identity.country.LC": "Santa Lucía",
	"organization.card.identity.country.LI": "Liechtenstein",
	"organization.card.identity.country.LK": "Sri Lanka",
	"organization.card.identity.country.LR": "Liberia",
	"organization.card.identity.country.LS": "Lesoto",
	"organization.card.identity.country.LT": "Lituania",
	"organization.card.identity.country.LU": "Luxemburgo",
	"organization.card.identity.country.LV": "Letonia",
	"organization.card.identity.country.LY": "Libia",
	"organization.card.identity.country.MA": "Marruecos",
	"organization.card.identity.country.MC": "Mónaco",
	"organization.card.identity.country.MD": "Moldavia",
	"organization.card.identity.country.ME": "Montenegro",
	"organization.card.identity.country.MF": "San Martín",
	"organization.card.identity.country.MG": "Madagascar",
	"organization.card.identity.country.MH": "Islas Marshall",
	"organization.card.identity.country.MK": "Macedonia del Norte",
	"organization.card.identity.country.ML": "Mali",
	"organization.card.identity.country.MM": "Birmania",
	"organization.card.identity.country.MN": "Mongolia",
	"organization.card.identity.country.MO": "Macao",
	"organization.card.identity.country.MP": "Isl. Marianas del Norte",
	"organization.card.identity.country.MQ": "Martinica",
	"organization.card.identity.country.MR": "Mauritania",
	"organization.card.identity.country.MS": "Montserrat",
	"organization.card.identity.country.MT": "Malta",
	"organization.card.identity.country.MU": "Mauricio",
	"organization.card.identity.country.MV": "Maldivas",
	"organization.card.identity.country.MW": "Malaui",
	"organization.card.identity.country.MX": "México",
	"organization.card.identity.country.MY": "Malasia",
	"organization.card.identity.country.MZ": "Mozambique",
	"organization.card.identity.country.NA": "Namibia",
	"organization.card.identity.country.NC": "Nueva Caledonia",
	"organization.card.identity.country.NE": "Níger",
	"organization.card.identity.country.NF": "Isla Norfolk",
	"organization.card.identity.country.NG": "Nigeria",
	"organization.card.identity.country.NI": "Nicaragua",
	"organization.card.identity.country.NL": "Países Bajos",
	"organization.card.identity.country.NO": "Noruega",
	"organization.card.identity.country.NP": "Nepal",
	"organization.card.identity.country.NR": "Nauru",
	"organization.card.identity.country.NU": "Niue",
	"organization.card.identity.country.NZ": "Nueva Zelanda",
	"organization.card.identity.country.O1": "Otro NO-COMPLEMENTARIO",
	"organization.card.identity.country.O2": "Otro TASIA",
	"organization.card.identity.country.O3": "Otro TAEX",
	"organization.card.identity.country.O4": "Otro TANY",
	"organization.card.identity.country.OM": "Omán",
	"organization.card.identity.country.OT": "Otros Países",
	"organization.card.identity.country.PA": "Panamá",
	"organization.card.identity.country.PE": "Perú",
	"organization.card.identity.country.PF": "Polinesia Fran.",
	"organization.card.identity.country.PG": "Papúa Nueva Guinea",
	"organization.card.identity.country.PH": "Filipinas",
	"organization.card.identity.country.PK": "Pakistán",
	"organization.card.identity.country.PL": "Polonia",
	"organization.card.identity.country.PM": "Isl. San Pedro",
	"organization.card.identity.country.PN": "Isl. Pitcairn",
	"organization.card.identity.country.PR": "Puerto Rico",
	"organization.card.identity.country.PS": "Territ. palest.",
	"organization.card.identity.country.PT": "Portugal",
	"organization.card.identity.country.PW": "Palau",
	"organization.card.identity.country.PY": "Paraguay",
	"organization.card.identity.country.QA": "Catar",
	"organization.card.identity.country.RE": "Reunión",
	"organization.card.identity.country.RO": "Rumanía",
	"organization.card.identity.country.RS": "Serbia",
	"organization.card.identity.country.RU": "Fed. Rusa",
	"organization.card.identity.country.RW": "Ruanda",
	"organization.card.identity.country.SA": "Arabia Saudí",
	"organization.card.identity.country.SB": "Islas Salomón",
	"organization.card.identity.country.SC": "Seychelles",
	"organization.card.identity.country.SD": "Sudán",
	"organization.card.identity.country.SE": "Suecia",
	"organization.card.identity.country.SG": "Singapur",
	"organization.card.identity.country.SH": "Isl. Santa Elena",
	"organization.card.identity.country.SI": "Eslovenia",
	"organization.card.identity.country.SJ": "Svalbard",
	"organization.card.identity.country.SK": "Eslovaquia",
	"organization.card.identity.country.SL": "Sierra Leona",
	"organization.card.identity.country.SM": "San Marino",
	"organization.card.identity.country.SN": "Senegal",
	"organization.card.identity.country.SO": "Somalia",
	"organization.card.identity.country.SR": "Surinam",
	"organization.card.identity.country.ST": "Santo Tomé",
	"organization.card.identity.country.STL": "Apátrida",
	"organization.card.identity.country.SV": "El Salvador",
	"organization.card.identity.country.SY": "Siria",
	"organization.card.identity.country.SZ": "Suazilandia",
	"organization.card.identity.country.TC": "Isl. Turcas y Caicos",
	"organization.card.identity.country.TD": "Chad",
	"organization.card.identity.country.TF": "Terr. Aust. Franceses",
	"organization.card.identity.country.TG": "Togo",
	"organization.card.identity.country.TH": "Tailandia",
	"organization.card.identity.country.TJ": "Tayikistán",
	"organization.card.identity.country.TK": "Isl. Tokelau",
	"organization.card.identity.country.TL": "Timor Oriental",
	"organization.card.identity.country.TM": "Turkmenistán",
	"organization.card.identity.country.TN": "Túnez",
	"organization.card.identity.country.TO": "Tonga",
	"organization.card.identity.country.TP": "Timor Oriental",
	"organization.card.identity.country.TR": "Turquía",
	"organization.card.identity.country.TT": "Trinidad",
	"organization.card.identity.country.TV": "Tuvalu",
	"organization.card.identity.country.TW": "Taiwán",
	"organization.card.identity.country.TZ": "Tanzania",
	"organization.card.identity.country.UA": "Ucrania",
	"organization.card.identity.country.UG": "Uganda",
	"organization.card.identity.country.UM": "Isl. Ultr. Men. EE.UU.",
	"organization.card.identity.country.US": "EE. UU.",
	"organization.card.identity.country.UY": "Uruguay",
	"organization.card.identity.country.UZ": "Uzbekistán",
	"organization.card.identity.country.VA": "Ciudad del Vaticano",
	"organization.card.identity.country.VC": "San Vicente",
	"organization.card.identity.country.VE": "Venezuela",
	"organization.card.identity.country.VG": "Isl.Vírg.Brit.",
	"organization.card.identity.country.VI": "Isl.Vírg.Est.",
	"organization.card.identity.country.VN": "Vietnam",
	"organization.card.identity.country.VU": "Vanuatu",
	"organization.card.identity.country.WF": "Wallis",
	"organization.card.identity.country.WS": "Arch. Samoa",
	"organization.card.identity.country.XK": "Kósovo",
	"organization.card.identity.country.YE": "Yemen",
	"organization.card.identity.country.YT": "Mayotte",
	"organization.card.identity.country.YU": "Yugoslavia",
	"organization.card.identity.country.ZA": "Sudáfrica",
	"organization.card.identity.country.ZM": "Zambia",
	"organization.card.identity.country.ZR": "Zaire",
	"organization.card.identity.country.ZW": "Zimbabue",
	"organization.card.identity.name": "Nombre",
	"organization.card.identity.postCode": "Código Postal",
	"organization.card.identity.state": "País o estado",
	"organization.card.identity.suppliers": "Proveedores",
	"organization.card.identity.vat": "número IVA",
	"organization.card.manage-transactional-visibilities": "Gestionar visibilidades transaccionales",
	"organization.card.organizationcard": "Tarjeta de la organización",
	"organization.card.services": "Servicios",
	"organization.card.services.no-data": "No tienes ningún servicio",
	"organization.card.services.tab.desc": "Descripción",
	"organization.card.services.tab.name": "Nombre",
	"organization.card.services.title": "Lista de servicio",
	"organization.card.services.title.desc": "Lista de todos los servicios disponibles para esta organización en el contexto del proveedor relacionado",
	"organization.card.transactional-visibilities": "Visibilidades transaccionales",
	"organization.card.users": "Usuarios",
	"organization.card.visibilities": "Visibilidades",
	"organization.details-card.flow-chart": "Diagrama de flujo",
	"organization.details-card.flow-chart.current-organization": "Organización actual",
	"organization.details-card.flow-chart.customer": "Cliente",
	"organization.details-card.flow-chart.desc": "Lugar de esta organización en el panorama actual",
	"organization.details-card.flow-chart.supplier": "Proveedor",
	"organization.is-payer": "esPagador",
	"organization.is-shipto": "esEnviarA",
	"organization.is-soldto": "esVendidoA",
	"organization.status.deactivated": "Desactivado",
	"organization.status.deleted": "Eliminado",
	"organization.user-accept": "Aceptar",
	"organization.user-id": "Id.",
	"organization.user-manage": "Gestionar",
	"organization.user-reject": "Rechazar",
	"organization.user-status-in-organization": "Estado en la organización",
	"organization.users.list.desc": "Lista de todos los usuarios disponibles en esta organización",
	"organizationrole.api": "API",
	"organizationrole.dsu": "Administrador",
	"organizationrole.hlpdk": "HelpDesk",
	"organizationrole.subscription": "Notification",
	"organizationrole.user": "Usuario",
	"overview.survey-answer": "Yo respondo",
	"overview.survey-no-answer": "No, gracias",
	"overview.survey.please": "Por favor,",
	"overview.survey.questions": "responde a estas 3 preguntas después de navegar (tiempo estimado 20 seg.)",
	"overview.viewby": "Vista por",
	"product.added.to.cart": "producto(s) se han añadido al carrito correctamente",
	"product.card.new.specification": "Nueva especificación",
	"product.error": "unexpected error while trying to look for the product",
	"product.feasibility.not-feasible": "not feasible",
	"product.feasibility.ok": "De acuerdo",
	"product.feasibility.pending": "Pendiente",
	"product.feasibility.refused": "Rechazado",
	"product.feasibility.technical-error": "Technical Error",
	"product.message.product.not.saved": "No se ha podido guardar el producto",
	"product.message.template.product.not.saved": "No ha sido posible crear un nuevo producto",
	"product.most.used.values": "Valores más utilizados",
	"product.no.original.value": "No hay ningún valor original",
	"product.not.exist": "Este producto no existe",
	"product.original.value": "Valor original",
	"product.other.values": "Otros valores existentes",
	"product.pc.label.max": "Max",
	"product.pc.label.min": "Min",
	"product.pc.label.unit": "Unidad",
	"product.product.submitted": "Producto enviado",
	"product.quality.dashboard": "Panel de calidad del producto",
	"product.save.template.product": "Guardar como una nueva especificación",
	"product.save.template.product.and.add.to.cart": "Guardar y añadir al carrito",
	"product.table.header.add": "Añadir",
	"product.table.header.view": "Ver",
	"product.template": "Plantilla de producto",
	"product.template.isbeingsimulated": "La nueva especificación está siendo especificada...",
	"product.title.group.certificate": "Certificado",
	"product.title.group.coating": "Revestimiento",
	"product.title.group.dimensions": "Dimensiones",
	"product.title.group.insulationResistanceTest": "Prueba de resistencia del aislamiento",
	"product.title.group.labelling": "Etiquetado",
	"product.title.group.management": "Gestión",
	"product.title.group.packing": "Embalaje",
	"product.title.group.productionProcess": "Proceso de producción",
	"product.title.group.specifications": "Especificaciones",
	"product.title.group.stamping": "Estampación",
	"product.title.group.surface": "Superficie",
	"product.title.group.surfaceTreatment": "Tratamiento de la superficie",
	"product.title.group.use": "Uso",
	"product.title.group.weightDiameter": "Peso / diámetro",
	"product.title.group.welds": "Soldaduras",
	"product.title.section.bottom": "Inferior",
	"product.title.section.bundleHeight": "Altura del paquete",
	"product.title.section.bundleWeight": "Peso del paquete",
	"product.title.section.coilWeight": "Peso de la bobina",
	"product.title.section.customerArticle": "Artículo del cliente",
	"product.title.section.diameter": "Diámetro",
	"product.title.section.edge": "Margen",
	"product.title.section.insideDiameter": "Diámetro interior",
	"product.title.section.numberSheetsPerBundle": "Número de hojas por paquete",
	"product.title.section.numberSlitCoilsPerPackage": "Número de bobinas cortadas por paquete",
	"product.title.section.outsideDiameter": "Diámetro exterior",
	"product.title.section.packageHeight": "Altura del paquete",
	"product.title.section.packageHeightWithPalet": "Altura del paquete incl. palet",
	"product.title.section.packageWeight": "Altura del paquete (más de una bobina por paquete)",
	"product.title.section.removableProtectiveFilm": "Película protectora extraíble",
	"product.title.section.slabWeightInTon": "Peso del bloque en toneladas",
	"product.title.section.specificWeight": "Peso específico",
	"product.title.section.thickness": "Espesor",
	"product.title.section.top": "Superior",
	"product.title.section.weight": "Peso",
	"product.title.section.width": "Ancho",
	"profile.no.access": "Asegúrese de estar conectado a internet y de haber iniciado sesión en la aplicación para ver su perfil.",
	"profile.select": "Perfil - Seleccionar",
	"profile.select.visibility": "Seleccione una empresa/visibilidad",
	"profile.visibility.all": "Todas",
	"progress.message": "Tu transacción está en proceso",
	"progress.message.fastlane": "Your transaction is in progress",
	"promote.user.message": "Usuario a promocionar:",
	"prototype-card": "Tarjeta prototipo",
	"prototype-card-details.proposed-price": "Precio propuesto",
	"prototype-card-details.proposed-price.na": "N/D",
	"prototype-card.data-not-found": "El prototipo no existe",
	"prototype.card.deliveryweek": "Delivery week",
	"prototype.card.product.source": "source",
	"prototype.card.proposal": "Propuesta",
	"prototype.card.proposal.deliveries": "Entregas propuestas",
	"prototype.card.proposal.product.information": "Producto propuesto",
	"prototype.card.proposed.quantities": "Cantidad propuesta",
	"prototype.card.proposed.readyForDispatch": "Ready for dispatch at PO receipt",
	"prototype.card.request.deliveries": "Entregas solicitadas",
	"prototype.card.request.information": "Producto solicitado",
	"prototype.card.request.quantities": "Cantidades solicitadas",
	"prototype.card.sheetweight": "Peso de la hoja",
	"prototype.card.status.accepted": "Aceptado",
	"prototype.card.status.materialnotfound": "Material no disponible",
	"prototype.card.status.notavailable": "Not available",
	"prototype.card.status.refusedbycustomer": "Rechazado por el cliente",
	"prototype.card.status.requested": "Solicitado",
	"prototype.production-po-reception-date": "Fecha de recepción del pedido",
	"prototype.production.po-delivery": "Entrega",
	"prototype.production.po.order": "Pida",
	"prototype.status.accepted": "Aceptado",
	"prototype.status.closed": "Closed",
	"prototype.status.confirmed": "Confirmed",
	"prototype.status.decision": "Decision",
	"prototype.status.proposal": "Propuesta",
	"prototype.status.refused": "Rechazada",
	"prototype.tracker.status": "Estado del prototipo",
	"qty-by-family.title.note": "AlgIndique las cantidades correspondientes a los períodos relacionados con esta familia",
	"quality.feedback.card.closed.issues": "Problemas cerrados",
	"quality.feedback.card.closed.paid": "Pagado",
	"quality.feedback.card.closed.rejected": "Rechazado",
	"quality.feedback.card.details": "Ver detalles",
	"quality.feedback.card.open.issues": "Problemas abiertos",
	"quality.feedback.card.subtitle": "Detalles de reclamaciones cerradas",
	"quality.feedback.card.title": "Comentarios sobre calidad",
	"quality.first.selected.batch": "Tus lotes entregados o listos para envío por pedido",
	"quality.guarantee.request": "Solicitud de garantía",
	"quality.information": "Información de la calidad",
	"quality.issue.save.failed": "El envío del problema de calidad ha fallado.",
	"quality.issues.draft.edit": "Podrás editarlo en tu borrador de seguimiento.",
	"quality.issues.draft.saved.successfully": "Tu borrador se ha guardado",
	"quality.issues.followup": "Podrás verlo en tu seguimiento de Mis problemas de calidad.",
	"quality.issues.save.failed.message": "Inténtalo de nuevo o ponte en contacto con ebusiness.support@arcelormittal.com",
	"quality.issues.submitted.successfully": "Tu problema de calidad se ha enviado correctamente.",
	"quality.max.selected.batch": "Lotes seleccionados (máx. 6 lotes)",
	"quapp.action.add.attach": "Añadir un adjunto",
	"quapp.action.add.attach.progress": "Añadiendo",
	"quapp.action.cancel": "Cancelar problema de calidad",
	"quapp.action.change": "Editar",
	"quapp.action.delete": "Eliminar",
	"quapp.action.edit": "Editar",
	"quapp.action.go.back": "Volver",
	"quapp.action.save": "Guardar",
	"quapp.action.select.file": "Seleccione su archivo",
	"quapp.action.send": "Enviar",
	"quapp.action.view": "Ver",
	"quapp.actor.am": "ArcelorMittal",
	"quapp.actor.customer": "Cliente",
	"quapp.alert": "Alerta",
	"quapp.attach.audio": "Audio",
	"quapp.attach.file": "Archivo (PDF, Excel...)",
	"quapp.attach.picture": "Imagen",
	"quapp.attach.record.sound": "Grabar sonido",
	"quapp.attach.record.video": "Grabar un vídeo",
	"quapp.attach.take.picture": "Sacar una foto",
	"quapp.attach.video": "Vídeo",
	"quapp.detector": "Detector",
	"quapp.error": "Error",
	"quapp.loading": "Cargando",
	"quapp.logout.warning1": "¡Advertencia!",
	"quapp.logout.warning2": "Al salir de la aplicación, perderá todos los problemas no sincronizados.",
	"quapp.logout.warning3": "En este momento tiene {{value}} acciones no sincronizadas.",
	"quapp.logout.warning4": "¿Está seguro de que desea cerrar sesión?",
	"quapp.notif.claim.cancelled": "{{value}} ha sido cancelado",
	"quapp.notif.claim.comment": "Comentario: {{comment}}",
	"quapp.notif.claim.paid": "{{value}} se ha pagado ({{amount}} {{currency}}, {{quantity}} {{unit}})",
	"quapp.notif.claim.refused": "{{value}} ha sido rechazado",
	"quapp.notif.claim.warning": "{{value}} ha sido registrado como advertencia",
	"quapp.notif.label": "Reclamo actualizado:",
	"quapp.notif.title": "SteelUser",
	"quapp.notification": "Notificación",
	"quapp.page.not.found": "Página no encontrada",
	"quapp.process.closed": "Aceptado o rechazado",
	"quapp.process.closed.paid": "Pagado",
	"quapp.process.closed.refused": "Rechazado",
	"quapp.process.closed.warning": "Registrado como advertencia",
	"quapp.process.create": "Esperando la conexión",
	"quapp.process.inprogress": "Siendo procesado por ArcelorMittal",
	"quapp.process.push": "Dirigido a ArcelorMittal",
	"quapp.process.push-cancel": "Cancelación dirigida a ArcelorMittal",
	"quapp.process.push-update": "Modificación dirigida a ArcelorMittal",
	"quapp.process.registered": "Registrado por ArcelorMittal",
	"quapp.reader": "Lector",
	"quapp.validator": "Validador",
	"quapp.warning": "Advertencia",
	"readonly.user.error": "No puedes realizar ninguna acción en el modo de simulación, solo puedes consultar la vista de cliente",
	"remove.notification": "Eliminar notificación",
	"remove.unrecognized.batch": "no es un lote reconocido. Selecciona un lote válido.",
	"request-feasibility": "Request feasibility",
	"request.card.information": "Información de la solicitud",
	"reset.order": "Restableciendo tu pedido",
	"reset.order.confirmation": "¿Quieres proceder de todos modos?",
	"reset.order.warning.add.product.another.family": "Atención: ya tienes uno o más productos de otra familia en tu carrito. Al añadir este producto, se restablecerá el carrito actual (todos los productos seleccionados).",
	"reset.order.warning.customer.change": "Advertencia: al cambiar el cliente de un pedido se restablecerán el carrito actual (todos los productos seleccionados).",
	"saBusinessStatus.closed": "Cerrado",
	"saBusinessStatus.high.risk.external": "High Risk External",
	"saBusinessStatus.high.risk.internal": "High Risk Internal",
	"saBusinessStatus.high.runner": "High runner",
	"saBusinessStatus.low.runner": "Low runner",
	"saBusinessStatus.on.hold": "En espera",
	"saBusinessStatus.running": "En producción",
	"saBusinessStatus.running.out": "Finalizando",
	"saBusinessStatus.start.up": "Arrancando",
	"sb.Cancel": "Cancelar",
	"sb.Download": "Descargar",
	"sb.choose.options": "Elegir opciones",
	"sb.detailed.report": "Informe detallado",
	"sb.period": "Período",
	"sb.type": "Tipo",
	"scan.barcode": "Código de barras",
	"scan.batch.choose": "Elegir este lote",
	"scan.browser.title": "Reconocimiento del lote",
	"scan.customer": "Cliente",
	"scan.dimensions": "Dimensiones",
	"scan.get.closer": "Acérquese a la etiqueta",
	"scan.go-batch-card": "Acceder a la bobina",
	"scan.invoiced": "Facturado",
	"scan.looking.batch.data": "Buscando información del lote...",
	"scan.looking.multi.batch.data": "Buscando lotes relacionados",
	"scan.material-scan": "Escaneo del material",
	"scan.mill.order": "Pedido de la planta",
	"scan.quantity": "Cantidad",
	"scan.quantity.optional": "Cantidad (opcional)",
	"scan.quantity.placeholder": "Ingrese la cantidad enviada",
	"scan.select.batch": "Seleccione su lote",
	"scan.serial.number": "Número de serie",
	"scan.serial.number.placeholder": "Ingrese el número de serie",
	"scan.supplier.order": "Pedido del proveedor",
	"scan.tip.disable-tips": "Desactivar consejos",
	"scan.tip.message": "¿No puede escanear un código de barras? Revise la configuración (botón superior derecho) para comprobar si ha activado el modo de escaneo correcto para su código de barras.",
	"scan.tip.ok": "Aceptar",
	"scan.tip.title": "Consejo",
	"scan.title": "Escanee las etiquetas",
	"scan.weight": "Peso",
	"schedule-business-order-card.commercial-documents": "Documentos comerciales",
	"schedule-business-order-filter.customer-article-reference": "Referencia del artículo del cliente",
	"schedule-business-order-filter.thickness": "Espesor (mm)",
	"schedule-business-order-filter.width": "Ancho (mm)",
	"schedule-business-order.SA-unit": "Unidad SA",
	"schedule-business-order.card": "Tarjeta de pedido SA",
	"schedule-business-order.cem-partner": "Socio CEM",
	"schedule-business-order.certificate": "Certificado",
	"schedule-business-order.choice": "Elección",
	"schedule-business-order.country-of-scf": "País de SCF",
	"schedule-business-order.customer-expected-cumul": "Acum. esperada por cliente",
	"schedule-business-order.customer-realized-cumul": "Acum. realizada por cliente",
	"schedule-business-order.customer.article.reference": "Referencia del artículo del cliente",
	"schedule-business-order.customer.order.number": "Número de pedido del cliente",
	"schedule-business-order.delivery": "Entrega",
	"schedule-business-order.delivery.address": "Dirección de entrega",
	"schedule-business-order.delivery.mode": "Modalidad de entrega",
	"schedule-business-order.final-use": "Uso final",
	"schedule-business-order.form": "Forma",
	"schedule-business-order.icon": "icono",
	"schedule-business-order.in-transit-stock": "Existencias en tránsito",
	"schedule-business-order.incoterm": "Incoterm",
	"schedule-business-order.internal-diameter": "Diámetro interior (mm)",
	"schedule-business-order.interpretation-delivery-date": "Fecha de entrega de la interpretación",
	"schedule-business-order.lead-delay": "Adelanto/retraso",
	"schedule-business-order.needs": "Necesidades",
	"schedule-business-order.oil-reference": "Referencia del aceite",
	"schedule-business-order.order-follow-up-schedule": "Calendario de seguimiento de pedidos",
	"schedule-business-order.order-reason": "Razón del pedido",
	"schedule-business-order.packing": "Embalaje",
	"schedule-business-order.pds-instruction": "Instrucción PDS",
	"schedule-business-order.plant-stock": "Existencias de planta",
	"schedule-business-order.product": "Información del producto",
	"schedule-business-order.product.category": "Categoría del producto",
	"schedule-business-order.protection": "Protección",
	"schedule-business-order.realized-cumul": "Acum. realizada",
	"schedule-business-order.reference-of-alignment": "Referencia de alineación",
	"schedule-business-order.sa-business-status": "Estado del negocio SA",
	"schedule-business-order.sfc-country": "País SFC",
	"schedule-business-order.shortdescription": "Descripción breve",
	"schedule-business-order.situation-overview": "Vista general de la situación",
	"schedule-business-order.standard": "Estándar",
	"schedule-business-order.standard.steelgrade": "Grado del acero estándar",
	"schedule-business-order.stock": "Existencias",
	"schedule-business-order.stock-blocked": "Existencias bloqueadas",
	"schedule-business-order.stock-partner": "Socio de existencias",
	"schedule-business-order.supplier.order.number": "Número de pedido del proveedor",
	"schedule-business-order.surface-aspect": "Aspecto de la superficie",
	"schedule-business-order.time-of-alignment": "Momento de la alineación",
	"schedule-business-order.transport-mode": "Modo de transporte",
	"schedule-business-order.wip": "WIP",
	"search.batches": "Lotes",
	"search.by": "Búsqueda por",
	"search.certificates": "Certificados",
	"search.claim": "Reclamaciones",
	"search.count.batches": "{{value}} lotes",
	"search.count.closed": "{{value}} Problemas de calidad completados",
	"search.count.drafts": "{{value}} Borradores",
	"search.count.orders": "{{value}} pedidos",
	"search.count.pending": "{{value}} Problemas de calidad pendientes",
	"search.dispatch.advices": "Avisos del envío",
	"search.display": "Monitora",
	"search.guarantees": "Garantías",
	"search.invoices": "Facturas",
	"search.order.acknowledgments": "Confirmaciones del pedido",
	"search.placeholder": "Buscar…",
	"search.see.result": "Ver resultado",
	"search.see.results": "Ver resultados de {{value}}",
	"search.shipment": "Envío",
	"search.shipments": "Entregas",
	"section.filters": "Filtros",
	"see.all.batches": "See all batches",
	"see.all.documents": "See all documents",
	"select.auction.title": "Selecciona tu subasta",
	"select.new.administrator": "Al eliminar a este usuario, tendrás que seleccionar a un nuevo administrador para esta organización:",
	"select.product.spec": "Filtra tu catálogo de productos",
	"sent.closed.no.issue": "No existen problemas completados",
	"sent.hide.process": "Ocultar proceso",
	"sent.issue": "Problema de calidad",
	"sent.pending.no.issue": "No existen problemas pendientes",
	"sent.search.issues": "Buscar problemas",
	"sent.show.process": "Mostrar proceso",
	"sent.since": "Desde {{value}}",
	"sent.status": "ESTADO",
	"service.parameters.value": "Valor",
	"services.Back": "VOLVER A AÑADIR UN SERVICIO",
	"services.management": "Gestión de servicios",
	"services.settings": "Configuración",
	"settings.account": "Mi cuenta",
	"settings.actions": "Acciones",
	"settings.activity": "Actividad",
	"settings.activity-desc": "Última actividad",
	"settings.add-all-services": "Añadir todos los servicios",
	"settings.all-services-added": "Todos los servicios añadidos al usuario",
	"settings.any": "Cualquiera",
	"settings.boolean.off": "Apagado",
	"settings.boolean.on": "Encendido",
	"settings.business-id": "Id. del negocio",
	"settings.change-simulated-user": "Cambiar usuario simulado",
	"settings.city": "Ciudad",
	"settings.company": "Empresa",
	"settings.date-format-dd/mm/yyyy": "dd/mm/aaaa",
	"settings.date-format-mm/dd/yyyy": "mm/dd/aaaa",
	"settings.delegation.changement": "Cambiar mi organización delegada",
	"settings.download.aggregated": "Agregado",
	"settings.download.duplicate": "Duplicado",
	"settings.drag-drop-services-here": "Arrastra y suelta aquí los servicios que quieras añadir",
	"settings.drag-services-here": "Arrastra aquí los servicios para eliminarlos del usuario",
	"settings.email": "Correo electrónico",
	"settings.faq": "Preguntas frecuentes",
	"settings.firstname": "Apellidos",
	"settings.gender": "Sexo",
	"settings.general": "Configuración general",
	"settings.general.date-format": "Formato de fecha",
	"settings.general.helper": "Configuraciones para aplicaciones móviles y elementos web",
	"settings.general.time-format": "Formato de hora",
	"settings.generalSalesCondition": "Condiciones Generales de Venta",
	"settings.identity": "Identidad",
	"settings.identity.desc": "Datos personales de usuario",
	"settings.informational-visibilities": "Visibilidades informativas",
	"settings.last-connection-date": "Última fecha de conexión",
	"settings.lastname": "Apellido(s)",
	"settings.legal-information": "Información legal",
	"settings.legal-information.property": "SteelUser App es propiedad de ArcelorMittal FCE SA, con domicilio en 24-26 Boulevard d'Avranches L-1160 Luxemburgo, Luxemburgo.",
	"settings.legal-information.questions": "Por favor, dirija todas las preguntas o comentarios sobre esta aplicación a nuestro equipo de servicios electrónicos:",
	"settings.legal-information.require-registration": "El uso de la aplicación requiere un registro",
	"settings.login": "Acceso",
	"settings.logout": "Cerrar sesión",
	"settings.manage-info-visibilities": "Gestionar visibilidades informativas",
	"settings.manage-services": "Gestionar servicios",
	"settings.name": "Nombre",
	"settings.order.customer": "Número de pedido del cliente",
	"settings.order.number": "Número de pedido",
	"settings.order.supplier": "Número de pedido del proveedor",
	"settings.order.tracking": "Seguimiento del pedido",
	"settings.ordertracking.sorting.list": "Ordenación por defecto de la lista",
	"settings.organisation": "Organización",
	"settings.organizations": "Organizaciones",
	"settings.organizations.desc": "Usurios miembros de una organización",
	"settings.organizations.name": "Nombre",
	"settings.organizations.role": "Role",
	"settings.organizations.visibilities.address": "Dirección",
	"settings.organizations.visibilities.name": "Nombre / Ciudad",
	"settings.other": "Otra configuración",
	"settings.password-doesn't-match-rules": "La contraseña no cumple con las siguientes reglas",
	"settings.password-updated-successfully": "Contraseña actualizada correctamente",
	"settings.phone": "Número de teléfono móvil",
	"settings.phone-number": "Número de teléfono",
	"settings.privacy-policy": "Política de privacidad",
	"settings.privacypolicy.ContactUs": "Contacto",
	"settings.privacypolicy.ContactUsAddress": "Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxemburgo (Luxemburgo)",
	"settings.privacypolicy.ContactUsByEmail": "o por correo electrónico a",
	"settings.privacypolicy.ContactUsPlease": "Por favor, dirija todas las preguntas o comentarios sobre esta Política de Privacidad a:",
	"settings.privacypolicy.GeneralInformation": "Información general",
	"settings.privacypolicy.GeneralInformationProperty": "SteelUser es propiedad de ArcelorMittal France. ArcelorMittal France, una empresa francesa registrada en el Registro Mercantil (RCS) de Bobigny con el número 562 094 425, con domicilio social en Immeuble “Le Cézanne\", 6, rue André Campra, F-93200 Saint-Denis (Francia), aloja el sitio web SteelUser.com, coordina el mantenimiento del sitio y se ocupa de las funciones de integración. Registrándose como miembro de SteelUser, podrá realizar transacciones (compras, seguimiento de pedidos en línea, acceso a documentos de venta, etc.) en Internet con total seguridad y confidencialidad.",
	"settings.privacypolicy.GeneralInformationWebservices": "La plataforma SteelUser ofrece a los clientes de ArcelorMittal servicios web avanzados como el seguimiento de pedidos en línea, la consulta de documentos comerciales, las subastas de materiales no primarios, la introducción de pedidos en la web y la consulta de datos técnicos. Esta simplifica y acelera las relaciones entre los compradores de acero y ArcelorMittal.",
	"settings.privacypolicy.HypertextLinksContent": "Los hipervínculos en la plataforma SteelUser que conducen a otros recursos existentes en Internet, en especial a sus socios, han recibido previamente una autorización expresa por escrito. Los usuarios de SteelUser pueden establecer un hipervínculo a este sitio sin la autorización previa expresa de ArcelorMittal.",
	"settings.privacypolicy.PersonalInformation": "Información personal que usted elija proporcionar",
	"settings.privacypolicy.PersonalInformationContent": "El objetivo de la plataforma SteelUser es dar soporte a algunos procesos de negocio entre ArcelorMittal, a saber, la gestión de pedidos, el seguimiento de litigios, las subastas y la publicación de documentación comercial y técnica sobre los productos de ArcelorMittal. Estas funciones comerciales implican la gestión de las acciones de los usuarios como representantes de los clientes de ArcelorMittal. Por lo tanto, el forma de registro de SteelUser le pide que nos proporcione sus referencias (nombre de cliente, nombre y apellido(s), datos de contacto y función). Si no proporciona información personal obligatoria con respecto a una actividad determinada, no podrá participar en dicha actividad.",
	"settings.privacypolicy.PrivacyPolicy": "Política de privacidad",
	"settings.privacypolicy.PrivacyPolicyContent": "Proteger su privacidad y sus datos personales es importante para nosotros. ArcelorMittal ha adoptado un procedimiento de protección de datos (en lo sucesivo, las «normas corporativas vinculantes»). Este procedimiento proporciona una base jurídica global y simplificada para todas las bases de datos y aplicaciones que comparten datos personales dentro del grupo. El procedimiento de protección de datos de ArcelorMittal es un procedimiento que se aplica a todo el grupo y que garantiza un nivel mínimo de protección de los datos personales compartidos a nivel mundial, similar a la protección ofrecida por las normas de la UE. El procedimiento de protección de datos de ArcelorMittal («normas corporativas vinculantes») junto con las principales políticas se publica en",
	"settings.privacypolicy.Property": "Propiedad intelectual e industrial",
	"settings.privacypolicy.PropertyContent": "El contenido de la plataforma SteelUser (incluyendo, sin limitación en cuanto al carácter, texto, imágenes gráficas, archivos de audio y vídeo, código HTML, botones, marcas comerciales, programas, emblemas) es propiedad de ArcelorMittal, a menos que se indique lo contrario. Esta respeta los derechos relativos a terceros. El contenido no puede comercializarse, distribuirse, transmitirse, copiarse, modificarse en modo alguno sin el consentimiento previo por escrito de ArcelorMittal. Queda estrictamente prohibido el uso no autorizado del contenido de la plataforma SteelUser. Hacerlo constituye una violación de la legislación, incluidos los derechos de propiedad intelectual, comercial, de nombres comerciales o cualquier otro tipo de derecho de la propiedad industrial. Los usuarios podrán descargar, visualizar o imprimir una copia de esta página en un ordenador personal exclusivamente para uso personal y privado.",
	"settings.privacypolicy.Protection": "Protección de los datos personales",
	"settings.privacypolicy.Protection2years": "En caso de inactividad del usuario durante 2 años, el acceso a SteelUser se eliminará automáticamente. La información personal que ya no sea necesaria para cumplir los fines identificados se destruirá, eliminará o anonimizará. ArcelorMittal elaboró directrices e implementó procedimientos para regir la destrucción de información personal.",
	"settings.privacypolicy.ProtectionAbuse": "Los usuarios deben abstenerse, en lo que respecta a los datos nominativos a los que pueden acceder en cualquier base de datos, del abuso de cualquier tipo y de todo acto susceptible de atentar contra la vida privada o la reputación de las personas.",
	"settings.privacypolicy.ProtectionCommunication": "ArcelorMittal comunica a los usuarios que sus datos personales no se transmitirán a terceros. Si fuera necesario, se pedirá permiso explicando las razones y actividades para las que se utilizará la información una vez y si se concede el permiso. Sus datos se tratarán con absoluta confidencialidad. Independientemente del motivo, el consentimiento del usuario para el tratamiento y la cesión de sus datos puede revocarse poniéndose en contacto con la dirección mencionada al final de este apartado. Cuando se solicita información, entendemos que el usuario acepta (i) que ArcelorMittal puede compartir su información dentro de sus filiales (las empresas indexadas en el sitio web www.arcelormittal.com) y (ii) que permite a ArcelorMittal usar dicha información en el futuro para informar al usuario sobre cuestiones o asuntos de interés para este relacionados con ArcelorMittal y sus productos.",
	"settings.privacypolicy.ProtectionResponsible": "Cuando hayamos dado al usuario (o cuando el usuario haya elegido) una contraseña que le permita acceder a ciertas partes del sitio de SteelUser, el usuario será responsable de mantener esta contraseña confidencial. Pedimos al usuario que no comparta su contraseña con nadie. El usuario se compromete a (a) notificarnos inmediatamente cualquier uso no autorizado de su contraseña o cuenta o cualquier otra violación de seguridad, y (b) asegurarse de que el usuario salga de su cuenta al final de cada sesión. Es responsabilidad del usuario controlar la difusión y el uso de su contraseña, controlar el acceso a y el uso de su cuenta, y notificarnos cuando el usuario desee cancelar su cuenta en este sitio. No nos hacemos responsables de ninguna pérdida o daño derivado del incumplimiento de esta disposición.",
	"settings.privacypolicy.ProtectionSecrecy": "ArcelorMittal se compromete a cumplir con su obligación de secreto de la información de los datos personales. Su deber es tratarlos con confidencialidad y asumir las medidas de seguridad necesarias de naturaleza técnica y organizativa para evitar la alteración, la pérdida o el acceso no autorizado a dicha información.",
	"settings.privacypolicy.ResponsabilitiesContent": "ArcelorMittal implementa la plataforma SteelUser para ofrecer a los usuarios datos y/o herramientas disponibles y verificados, pero ArcelorMittal no se hace responsable de los errores, la falta de disponibilidad de los datos y/o la presencia de un virus en SteelUser.",
	"settings.privacypolicy.UseCookiesInstalled": "Visitando SteelUser, el usuario acepta que pueden instalarse «cookies» en su navegador. Las «cookies» hace que sea posible guardar información relevante para la navegación del usuario en el sitio. SteelUser solo las usa para garantizar el buen funcionamiento de las secciones privadas del sitio.",
	"settings.privacypolicy.UseCookiesNavigation": "Los parámetros del navegador permiten al usuario ser consciente de la presencia de las «cookies» y rechazarlas si lo desea de la siguiente manera:",
	"settings.privacypolicy.UseCookiesRefusing": "No obstante, se informa al usuario de que, si rechaza las «cookies», le será imposible acceder a las secciones privadas del sitio, en especial, no podrá realizar transacciones en línea.",
	"settings.privacypolicy.UseDataProvidedConsultrectify": "Algunos usuarios asumirán el papel de administrador y gestionarán los perfiles de los miembros de su empresa. Los administradores deben informar a estos usuarios del derecho que tienen de acceder, modificar y suprimir los perfiles que les conciernen. Todo usuario de SteelUser tiene derecho a consultar y rectificar sus datos nominativos, los cuales puede ejercer escribiendo a la dirección siguiente: Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxemburgo (Luxemburgo), o por correo electrónico a",
	"settings.privacypolicy.UseDataProvidedResponses": "Se informa al usuario de que ArcelorMittal puede utilizar las respuestas introducidas en SteelUser, especialmente las necesarias para acceder a las secciones privadas de dicho sitio como miembro, y transferirlas a los servicios encargados de las operaciones industriales y comerciales, que son esenciales para la consideración y la tramitación de las transacciones.",
	"settings.privacypolicy.UseGoogleAnalytics": "Uso de Google Analytics",
	"settings.privacypolicy.UseGoogleAnalyticsContent": "Las «cookies» de Google Analytics se utilizan para recopilar información sobre el uso que hacen los visitantes de nuestro sitio. Usamos la información para recopilar informes y para ayudarnos a mejorar el sitio.  Las «cookies» recopilan información de manera anónima, incluyendo el número de visitantes del sitio, de dónde han venido los visitantes al sitio y las páginas que han visitado. Para obtener información sobre el uso de los datos por parte de Google, por favor, consulte la siguiente URL:",
	"settings.privacypolicy.Worldwidetransfer": "Transferencia mundial de datos personales",
	"settings.privacypolicy.amwebsite": "Sitio web de ArcelorMittal",
	"settings.privacypolicy.creditsforpictures": "Créditos de las imágenes",
	"settings.privacypolicy.hypertextlinks": "Enlaces de hipertexto",
	"settings.privacypolicy.ifyouareusing": "Si está usando",
	"settings.privacypolicy.responsabilities": "Responsabilidades",
	"settings.privacypolicy.tableofcontent": "Índice",
	"settings.privacypolicy.usecookies": "Uso de las cookies",
	"settings.privacypolicy.usedataprovided": "Uso de los datos proporcionados",
	"settings.privacypolicy.worldwidetransfercontent": "Las entidades de todo el mundo de ArcelorMittal pueden acceder a SteelUser. Los datos personales se usarán únicamente para los fines descritos en esta Política de Privacidad. Se garantizará un nivel de protección adecuado y se adoptarán medidas de seguridad apropiadas para proteger dichos datos personales contra la destrucción accidental o ilícita o la pérdida accidental, la alteración, la divulgación o el acceso no autorizados. Usando SteelUser, estará dando su consentimiento para cualquier transferencia de este tipo.",
	"settings.product": "Producto",
	"settings.product.article": "Referencia del artículo del cliente",
	"settings.product.standard.dimension": "Grado del acero estándar + Dimensiones",
	"settings.product.steelgrade": "Grado del acero",
	"settings.profile": "Perfil",
	"settings.remove-service": "Eliminar servicio",
	"settings.remove-service-confirmation": "¿Estás seguro/a de que quieres eliminar este servicio?",
	"settings.requested.email": "Requested Email",
	"settings.sales.framework": "Marco de ventas",
	"settings.save-changes": "Guardar cambios",
	"settings.scan": "Escanear",
	"settings.scan.beep": "Pitido",
	"settings.scan.display-tip": "Mostrar consejo",
	"settings.scan.mode": "Modo de escaneo",
	"settings.scan.mode.laser": "Modo láser / valor único",
	"settings.scan.mode.matrix": "Zonas de la matriz/ múltiples",
	"settings.select.download-type": "Selecciona cómo quieres descargar datos:",
	"settings.select.language": "Seleccione su idioma:",
	"settings.select.order.number": "Seleccione cómo quiere mostrar las referencias del pedido:",
	"settings.select.ordertracking.sortlist": "Seleccione cómo quiere ordenar su lista en el seguimiento del pedido:",
	"settings.select.product": "Seleccione cómo quiere mostrar el producto:",
	"settings.select.scan.beep": "Quiere escuchar un pitido cada vez que se reconozcan los valores:",
	"settings.select.scan.mode": "Seleccione el método con el que quiere escanear:",
	"settings.select.weight": "Seleccione cómo quiere mostrar el peso:",
	"settings.services-mangement": "Gestión de servicios",
	"settings.snackbar.downloadType": "Ahora tu tipo de descarga es {{downloadType}}.",
	"settings.snackbar.language": "Tu idioma es ahora el español.",
	"settings.snackbar.order": "Ahora la pantalla de referencia de su pedido es {{pedido}}.",
	"settings.snackbar.product": "Ahora su visualización de producto es",
	"settings.snackbar.visibility": "Ahora podrá ver los datos de {{visibilidad}} para el proveedor {{proveedor}}.",
	"settings.snackbar.weight": "Ahora su visualización de pedos es {{peso}}",
	"settings.supplier": "Proveedor",
	"settings.survey.wot.overview": "página de nueva vista general de pedidos y entregas",
	"settings.terms.of.use": "Condiciones de uso",
	"settings.time-format-12:00": "12:00",
	"settings.time-format-24:00": "24:00",
	"settings.update.validate": "Validar",
	"settings.user-update-error": "Se ha producido un error durante la actualización del usuario, los cambios no se han guardado",
	"settings.visibility": "Visibilidades",
	"settings.visibility.changeimpact": "Cambiar este valor afectará a otros sistemas del Steeluser",
	"settings.visibility.data": "Actualmente veo datos de (Organización - proveedor)",
	"settings.visibility.helper": "Elija su alcance para la aplicación móvil y el elemento web",
	"settings.visibility.info": "Esta visibilidad es compartida por todas las plataformas Steeluser (movil y web).",
	"settings.weight": "Peso",
	"settings.weight.gross": "Bruto",
	"settings.weight.net": "Neto",
	"share.view.share": "Compartir",
	"shareview.success.message": "compartido correctamente",
	"shipment-card.data-not-found": "Shipment data not found",
	"shipment.card": "Tarjeta de envíos",
	"shipment.card.information": "Información de envíos",
	"shipment.dispatch-advice": "Aviso de envío",
	"shipment.dispatch-advice-date": "Fecha de la nota de envío",
	"shipment.dispatch-advice-number": "Número de aviso de envío",
	"shipment.dispatch-date": "Fecha de envío",
	"shipment.filter.batch-number": "Número de lote",
	"shipment.filter.customer": "Cliente",
	"shipment.filter.customer-article-reference": "Referencia del artículo del cliente",
	"shipment.filter.customer-order-number": "Número de pedido del cliente",
	"shipment.filter.dispatch-advice-date": "Fecha del aviso de envío",
	"shipment.filter.dispatch-advice-number": "Número de aviso de envío",
	"shipment.filter.dispatch-date": "Fecha de envío",
	"shipment.filter.mill": "Fábrica",
	"shipment.filter.ship-to": "Enviar a",
	"shipment.filter.sold-to": "Vendido a",
	"shipment.filter.standard-steelgrade": "Grado de acero estándar",
	"shipment.filter.supplier-order-number": "Número de pedido del proveedor",
	"shipment.filter.thickness": "Espesor",
	"shipment.filter.transport-mode": "Modo de transporte",
	"shipment.filter.transport-reference": "Referencia de transporte",
	"shipment.filter.width": "Anchura",
	"shipment.first": "Primer",
	"shipment.last": "Último",
	"shipment.shipped-qty-gross": "Cantidades enviadas en bruto (t)",
	"shipment.step": "Paso",
	"shipment.tmode.byairplane": "Por avión",
	"shipment.tmode.byinlandwaterways": "Por vías navegables",
	"shipment.tmode.byrail": "Por ferrocarril",
	"shipment.tmode.byrail.feve": "Por ferrocarril (FEVE)",
	"shipment.tmode.byrailroad": "Por ferrocarril y carretera",
	"shipment.tmode.byroad": "Por carretera",
	"shipment.tmode.bysea": "Marítimo",
	"shipment.tmode.bytrain": "Tren",
	"shipment.tmode.notspecified": "No especificado",
	"shipment.to": "Envío a",
	"shipment.transport-reference": "Referencia de transporte",
	"simulated.customer.updated": "El cliente simulado ha sido actualizado.",
	"snackbar.add.existing.user.validation.mail-external": "User has been correctly created.",
	"snackbar.add.user.validation.mail-external": "User has been correctly created. An email has been sent to the new user to activate the account.",
	"snackbar.add.user.validation.mail-internal": "User has been correctly created. An email has been sent to the admin for validation.",
	"snackbar.offline": "Tiene que estar conectado para cambiar la configuración",
	"snackbar.survey": "Muchas gracias por tu tiempo, tus comentarios son muy importantes para nosotros.",
	"sortby.cdd.asc": "CDD ascendente",
	"sortby.cdd.desc": "CDD descendente",
	"sortby.order.asc": "Pedido ascendente",
	"sortby.order.desc": "Pedido descendente",
	"sortby.product.asc": "Producto ascendente",
	"sortby.product.desc": "Producto descendente",
	"srvmg.requestor.description": "Actuar como solicitante SOX",
	"srvmg.requestor.label": "Solicitante",
	"srvmg.validator.description": "Actuar como validador SOX",
	"srvmg.validator.label": "Validador",
	"standard-steelgrade": "Standard steelgrade",
	"start.date": "Fecha de inicio",
	"status-group.blocked": "Stock bloqueado",
	"status-group.in-consignment": "Available - In consignment",
	"status-group.in-prod": "En producción",
	"status-group.in-transit": "En tránsito al cliente",
	"status-group.rtt": "Listo para expedir",
	"steelgrade-feasibility": "Steelgrade",
	"stock-alert.green": "Green",
	"stock-alert.orange": "Orange",
	"stock-alert.red": "Red",
	"submit.guarantee.request": "Enviar su solicitud de garantía",
	"supplier.comment": "Comentario del proveedor",
	"suppliergroup.amds": "ArcelorMittal Distribution Solutions",
	"suppliergroup.aperam": "Aperam",
	"suppliergroup.fce": "ArcelorMittal FCE",
	"survey.agree": "de acuerdo",
	"survey.amount.of.time": "tiempo que me toma encontrar información",
	"survey.answer.dialog.title": "Por favor, valora la facilidad de uso de",
	"survey.clarity.information": "claridad de la información",
	"survey.disagree": "en desacuerdo",
	"survey.ease.find.information": "facilidad para encontrar información",
	"survey.evaluate.statement": "Evalúa las 3 afirmaciones siguientes",
	"survey.header.title": "Ayúdanos a mejorar",
	"survey.statements": "Estoy satisfecho/a con el",
	"survey.strongly": "Totalmente",
	"table.no.results": "ningún resultado",
	"table.results": "{{value}} resultados",
	"term.policy": "Términos y política",
	"title.product.catalogue": "Añade un nuevo producto a tu catálogo",
	"title.product.order": "Elige el producto que quieras pedir",
	"tmode.byair": "Por vía aérea",
	"tmode.bysea": "marítimo",
	"tmode.default": "_Por defecto",
	"tmode.inlandwaterway": "Fluvial",
	"tmode.lorry": "camión",
	"tmode.lorryrailway": "Camión + Ferrocarril",
	"tmode.othertospecify": "Otro (por precisar)",
	"tmode.rail": "Ferroviario",
	"tmode.railwaylorry": "Ferrocarril + camión",
	"total.quantity.period": "Cantidad total para el período",
	"transport.mode": "Modo de transporte",
	"transport.mode.boat": "Barco",
	"transport.mode.plane": "Avión",
	"transport.mode.train": "Tren",
	"transport.mode.truck": "Camión",
	"transversal.dashboard": "Panel de control",
	"transversal.dashboard.plural": "Paneles",
	"transversal.data-administration": "Administración",
	"transversal.data-center": "Centro de datos",
	"transversal.data-center-batches": "Lotes",
	"transversal.data-center-documents": "Documentos comerciales",
	"transversal.data-center-order": "Pedidos",
	"transversal.data-center.batches": "Centro de datos: Lotes",
	"transversal.data-center.plural": "Centros de datos",
	"transversal.data-center.prototype": "Prototypes",
	"transversal.data-center.users": "Usuarios",
	"transversal.delegated-to": "Delegado a",
	"transversal.eoffer": "Oferta electrónica",
	"transversal.equality": "Calidad electrónica",
	"transversal.go-back-to-old-steeluser": "Ir a la version anterior del portal",
	"transversal.guarantee-documents": "Documentos de garantía",
	"transversal.home": "Página de inicio",
	"transversal.in-a-delegation": "(en una delegación)",
	"transversal.lastbatches": "Últimos lotes",
	"transversal.legal": "Legal",
	"transversal.order-tracking": "Seguimiento del pedido",
	"transversal.order.delivery": "Pedidos y entregas",
	"transversal.quality": "Calidad",
	"transversal.schedule-busiess-order": "Programar pedidos del negocio",
	"transversal.services": "Servicios",
	"transversal.shipments": "Envíos",
	"transversal.simulation-of": "Simulación de",
	"transversal.steeluser": "SteelUser",
	"unit.kg": "kg",
	"unit.m2": "m²",
	"unit.pc": "Unidades",
	"unit.to": "Toneladas métricas",
	"unrecognized.batch": "Lote no reconocido",
	"upload.file.count.error.message": "-max-count- files maximum per item",
	"upload.file.error.message": "An error occured during uploading process",
	"upload.file.maxitem.error.message": "3 files maximum per item",
	"upload.file.mime.type.error.message": "PDF, DOC, XLS, PPT or images only allowed. Upload type is MIME--TYPE",
	"upload.file.name.error.message": "Invalid file name - Use alphanumeric, hyphens, spaces, underscores and at least 5 characters",
	"upload.file.size.error.message": "Max file size is 20MB",
	"upload.file.space.error.message": "Sorry: not enough space to add automatically template file as attachment",
	"upload.or": "or",
	"user.belong.to": "Pertenezco a ",
	"user.card.about-cookies": "Las cookies son pequeños archivos de texto que las páginas web pueden utilizar para hacer más eficiente la experiencia del usuario. La ley prevé que solo podemos almacenar cookies en tu dispositivo si estas son estrictamente necesarias para el funcionamiento de la página. Para los demás tipos de cookies, necesitamos tu consentimiento. Esta web utiliza diferentes tipos de cookies. Algunas cookies son colocadas por los servicios de terceros que aparecen en nuestras páginas. Puedes modificar o retirar tu consentimiento en cuanto veas la Declaración de cookies en nuestra página web. Para más información sobre quiénes somos, cómo puedes ponerte en contacto con nosotros y de qué manera podemos tratar los datos personales, consulta nuestra Política de privacidad.",
	"user.card.about-cookies.title": "Sobre las cookies",
	"user.card.accept": "Aceptar",
	"user.card.account-info": "Información de la cuenta",
	"user.card.allowed": "Permitidas",
	"user.card.apply": "Aplicar",
	"user.card.audience-measurement-cookies": "Utilizamos cookies de medición de audiencia cuya finalidad se limita a medir el rendimiento de la audiencia de la web o de la aplicación, la detección de posibles problemas de navegación, la optimización del rendimiento técnico o de la ergonomía, la estimación de la potencia de los servidores necesarios y el análisis del contenido creado exclusivamente por Arcelor Mittal.",
	"user.card.audience-measurement-cookies.title": "Cookies de medición de audiencia",
	"user.card.cookies-exempt-from-consents.one": "Las cookies guardan las elecciones de los usuarios en el repositorio del trazador.",
	"user.card.cookies-exempt-from-consents.three": "Las cookies de personalización de la interfaz de usuario (p. ej., para seleccionar el idioma o presentar un servicio), cuando la personalización sea un elemento intrínseco y que se espere del servicio.",
	"user.card.cookies-exempt-from-consents.title": "Cookies exentas del consentimiento",
	"user.card.cookies-exempt-from-consents.two": "Las cookies destinadas a la autenticación en un servicio, incluyendo aquellas destinadas a garantizar la seguridad del mecanismo de autenticación, p. ej. limitando los intentos de acceso robotizados o inesperados.",
	"user.card.details": "Detalles",
	"user.card.not-allowed": "No permitidas",
	"user.card.notifications": "Notificaciones",
	"user.card.notifications.no-data": "No tienes ninguna notificación",
	"user.card.notifications.tab.description": "Descripción",
	"user.card.notifications.tab.details": "Detalles",
	"user.card.notifications.tab.frequency": "Frecuencia",
	"user.card.notifications.tab.service": "Servicio",
	"user.card.notifications.tab.subscription": "Suscripción",
	"user.card.notifications.title": "Notificaciones",
	"user.card.notifications.title.desc": "Lista de alertas para este usuario",
	"user.card.personalcard": "Tarjeta personal",
	"user.card.personalize-privacy-settings.title": "Personaliza tus ajustes de privacidad",
	"user.card.privacy-settings": "Ajustes de privacidad",
	"user.card.reject": "Rechazar",
	"user.card.security": "Seguridad",
	"user.card.security.1-lowercase-letter-rule": "1 letra minúscula (a, b, c, d, e)",
	"user.card.security.1-number-rule": "1 número (1, 2, 3, 4)",
	"user.card.security.1-special-character-rule": "1 carácter especial (:, /, !, _, -, #, @)",
	"user.card.security.1-uppercase-letter-rule": "1 letra mayúscula (A, B, C, D, E)",
	"user.card.security.15-character-rule": "15 caracteres como mínimo",
	"user.card.security.change-login-title": "Change your login",
	"user.card.security.change-password-title": "Cambia tu contraseña",
	"user.card.security.confirm-password-match": "La contraseña de confirmación debe coincidir con la nueva contraseña",
	"user.card.security.password-must-contain-title": "Para que sea válida, la contraseña debe contener al menos:",
	"user.card.security.username-error": "Please enter valid username",
	"user.card.security.your-current-password": "Tu contraseña actual",
	"user.card.security.your-login": "Your login",
	"user.card.security.your-new-password": "Tu nueva contraseña",
	"user.card.security.your-repeat-new-password": "Repite tu nueva contraseña",
	"user.card.services": "Servicios",
	"user.card.services.no-data": "No tienes ningún servicio",
	"user.card.services.tab.desc": "Descripción",
	"user.card.services.tab.name": "Nombre",
	"user.card.services.tab.settings": "Configuración",
	"user.card.services.title": "Lista de servicio",
	"user.card.services.title.desc": "Lista de todos los servicios disponibles para este usuario en el contexto del proveedor relacionado",
	"user.card.settings": "Configuraciones",
	"user.expired": "Expired",
	"user.expiryDate": "Expiry date",
	"user.gender.mr": "Sr.",
	"user.gender.mrs": "Sra.",
	"user.gender.ms": "Srta.",
	"user.language": "Idioma",
	"user.need.connection": "Necesita estar autentificado para acceder a esta parte.",
	"user.no.connection": "Necesita una conexión válida para acceder a esta parte.",
	"user.no.role": "Su perfil no puede gestionar el problema de calidad. Póngase en contacto con SteelUser Relay para obtener acceso ilimitado al servicio Quality App.",
	"user.no.service": "Su perfil no puede gestionar el problema de calidad. Comuníquese con su contacto de SteelUser para obtener acceso ilimitado al servicio Quality App.",
	"user.notifications.add.subscription": "Añadir",
	"user.notifications.btn.add.subscription": "Añadir suscripción",
	"user.notifications.dialog.subscription": "Añadir una suscripción",
	"user.notifications.dropdown.frequency": "Frecuencia",
	"user.notifications.dropdown.services": "Servicios",
	"user.notifications.dropdown.subscription": "Suscripción",
	"user.notifications.select.frequency": "Por favor, selecciona una frecuencia",
	"user.notifications.select.service": "Por favor, selecciona un servicio",
	"user.notifications.select.subscription": "Por favor, selecciona una suscripción",
	"user.see.data": "Actualmente veo datos para",
	"user.supplier": "Mi proveedor",
	"user.user": "Usuario",
	"user.validation": "El usuario es necesario",
	"user.validationDaysLeft": "ValidationDaysLeft",
	"userServiceInfo.services.management": "Servicios activos",
	"userServiceInfo.services.settings": "Configuración",
	"users.details-card.actions": "Acciones",
	"users.list": "Lista de usuarios",
	"view.shared.success": "¿Estás seguro/a de que quieres eliminar este borrador {{value}}?",
	"view.validation": "La vista es necesaria",
	"viewby.cdd.asc": "CDD ascendente",
	"viewby.cdd.desc": "CDD descendente",
	"viewby.mill.asc": "Fábrica ascendente",
	"viewby.mill.desc": "Fábrica descendente",
	"viewby.product.asc": "Producto ascendente",
	"viewby.product.desc": "Producto descendente",
	"viewby.step": "Paso",
	"wait.message": "Por favor, NO PULSES el botón de volver o de actualizar en tu navegador",
	"wait.message.fastlane": "Please DO NOT PRESS back button or refresh button in your browser",
	"wait.user.validation": "Waiting for user validation",
	"want.to.cancel.issue": "Do you really want to cancel this issue",
	"want.to.close": "¿Estás seguro/a de que quieres salir?",
	"want.to.delete.draft": "¿Estás seguro/a de que quieres eliminar este borrador?",
	"want.to.delete.notification": "¿Estás seguro/a de que quieres eliminar esta notificación?",
	"warning-product-category": "Please select a product category.",
	"warning-standard-steelgrade": "Please select a standard steelgrade.",
	"warning-steelgrade": "Please select a steelgrade.",
	"warning-sub-category": "Please select a sub category.",
	"warning-thickness": "Please enter thickness.",
	"warning-width": "Please enter width.",
	"warning.closed.orders": "You are writing a comment on a closed order",
	"warning.maximum.1000": "No pueden descargarse más de 1000 registros a la vez",
	"warning.maximum.30": "No pueden descargarse más de 30 registros a la vez",
	"woe.noitems": "No ha posición",
	"workflow-steps.next.error": "Ha habido algún problema, ponte en contacto con el administrador de SteelUser",
	"xcarb-document.card": "XCarb® Document",
	"xcarb.label": "XCarb®"
};
